import * as e from "react";
import t, { createContext as n, createElement as r, forwardRef as i, useCallback as a, useContext as o, useEffect as s, useLayoutEffect as c, useMemo as l, useRef as u, useState as d } from "react";
import * as f from "react-dom";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var g = Object.defineProperty, _ = (e, t) => {
	let n = {};
	for (var r in e) g(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || g(n, Symbol.toStringTag, { value: "Module" }), n;
}, v = (e) => e?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toLucideIconData.mjs
function y(e, t, n = []) {
	if (t == null) throw Error("[lucide]: iconNode is required when icon name is used");
	return {
		name: v(e),
		size: 24,
		node: t,
		...n.length > 0 ? { aliases: n } : {}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/toCamelCase.mjs
var b = (e) => {
	let t = "", n = !1;
	for (let r of e) {
		if (r === "-" || r === "_" || r <= " ") {
			n = t.length > 0;
			continue;
		}
		t.length === 0 ? t += r.toLowerCase() : t += n ? r.toUpperCase() : r, n = !1;
	}
	return t;
}, x = (e) => {
	let t = b(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, S = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), C = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": 2,
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconNode.mjs
function w(e) {
	return e != null;
}
function T(e, t = {}) {
	let n = t.attributeNames ?? {}, r = (e) => n[e] ?? e, i = e.size ?? e.width ?? C.width, a = e.size ?? e.height ?? C.height, o = e.aliases?.filter((e) => typeof e == "string" && e.trim() !== "").map((e) => `lucide-${e}`) ?? [], s = [...e.name ? [`lucide-${e.name}`] : [], ...o], c = t.className?.split(" ").filter(Boolean) ?? [], l = t.includeDefaultClasses === !1 ? S(...c) : S("lucide", ...s, ...c), u = t.absoluteStrokeWidth ? Number(t.strokeWidth ?? C["stroke-width"]) * Number(e.size ?? e.width ?? C.width) / Number(t.size ?? t.width ?? C.width) : t.strokeWidth ?? C["stroke-width"];
	return [
		"svg",
		{
			...Object.entries(C).reduce((e, [t, n]) => (e[r(t)] = n, e), {}),
			..."color" in t && t.color && { [r("stroke")]: t.color },
			..."size" in t && w(t.size) && {
				[r("width")]: t.size,
				[r("height")]: t.size
			},
			..."width" in t && w(t.width) && { [r("width")]: t.width },
			..."height" in t && w(t.height) && { [r("height")]: t.height },
			[r("stroke-width")]: u,
			...l && { [r("class")]: l },
			[r("viewBox")]: `0 0 ${i} ${a}`,
			...t.hasA11yProp === !1 ? { [r("aria-hidden")]: "true" } : {},
			..."attributes" in t && t.attributes
		},
		e.node.map((e) => {
			let [n, i, a] = e, o = t.nonScalingStroke ? {
				[r("vector-effect")]: "non-scaling-stroke",
				...i
			} : i;
			return a ? [
				n,
				o,
				a
			] : [n, o];
		})
	];
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/build/buildLucideIconForReact.mjs
function E(e, t = {}) {
	return T(e, {
		...t,
		attributeNames: {
			...t.attributeNames,
			class: "className",
			"stroke-width": "strokeWidth",
			"stroke-linecap": "strokeLinecap",
			"stroke-linejoin": "strokeLinejoin",
			"vector-effect": "vectorEffect"
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/shared/src/utils/hasA11yProp.mjs
var D = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, O = n({}), k = () => o(O), A = i(({ color: e, size: t, width: n, height: i, strokeWidth: a, absoluteStrokeWidth: o, nonScalingStroke: s, className: c = "", children: l, iconNode: u = [], icon: d = {
	node: u,
	aliases: [],
	size: 24
}, ...f }, p) => {
	let { size: m = 24, strokeWidth: h = 2, absoluteStrokeWidth: g = !1, nonScalingStroke: _ = !1, color: v = "currentColor", className: y = "" } = k() ?? {}, b = !!l || D(f), [x, C, w = []] = E(d, {
		color: e ?? v,
		width: n ?? t ?? m,
		height: i ?? t ?? m,
		strokeWidth: a ?? h,
		absoluteStrokeWidth: o ?? g,
		nonScalingStroke: s ?? _,
		className: S(y, c),
		hasA11yProp: b,
		attributes: f
	});
	return r(x, {
		ref: p,
		...C
	}, [...w.map(([e, t]) => r(e, t)), ...Array.isArray(l) ? l : [l]]);
});
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/createLucideIcon.mjs
function j(e, t = [], n = []) {
	let a = typeof e == "string" ? y(e, t, n) : e, o = i(({ className: e, ...t }, n) => r(A, {
		ref: n,
		icon: a,
		className: e,
		...t
	}));
	return a.name && (o.displayName = x(a.name)), o;
}
//#endregion
//#region ../../node_modules/.pnpm/lucide-react@1.48.0_react@19.3.0/node_modules/lucide-react/dist/esm/icons/calendar.mjs
var M = {
	name: "calendar",
	size: 24,
	node: [
		["path", {
			d: "M8 2v3",
			key: "1ioesn"
		}],
		["path", {
			d: "M16 2v3",
			key: "otl347"
		}],
		["rect", {
			x: "3",
			y: "3",
			width: "18",
			height: "18",
			rx: "2",
			key: "h1oib"
		}],
		["path", {
			d: "M3 9h18",
			key: "1pudct"
		}]
	]
};
M.node;
var ee = j(M), N = {
	name: "check",
	size: 24,
	node: [["path", {
		d: "M20 6 9 17l-5-5",
		key: "1gmf2c"
	}]]
};
N.node;
var te = j(N), P = {
	name: "chevron-down",
	size: 24,
	node: [["path", {
		d: "m6 9 6 6 6-6",
		key: "qrunsl"
	}]]
};
P.node;
var ne = j(P), re = {
	name: "chevron-left",
	size: 24,
	node: [["path", {
		d: "m15 18-6-6 6-6",
		key: "1wnfg3"
	}]]
};
re.node;
var ie = j(re), ae = {
	name: "chevron-right",
	size: 24,
	node: [["path", {
		d: "m9 18 6-6-6-6",
		key: "mthhwq"
	}]]
};
ae.node;
var F = j(ae), oe = {
	name: "chevron-up",
	size: 24,
	node: [["path", {
		d: "m18 15-6-6-6 6",
		key: "153udz"
	}]]
};
oe.node;
var se = j(oe), ce = {
	name: "ellipsis",
	size: 24,
	node: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "1",
			key: "41hilf"
		}],
		["circle", {
			cx: "19",
			cy: "12",
			r: "1",
			key: "1wjl8i"
		}],
		["circle", {
			cx: "5",
			cy: "12",
			r: "1",
			key: "1pcz8c"
		}]
	],
	aliases: ["more-horizontal"]
};
ce.node;
var I = j(ce), le = {
	name: "search",
	size: 24,
	node: [["path", {
		d: "m21 21-4.34-4.34",
		key: "14j7rj"
	}], ["circle", {
		cx: "11",
		cy: "11",
		r: "8",
		key: "4ej97u"
	}]]
};
le.node;
var ue = j(le), de = {
	name: "x",
	size: 24,
	node: [["path", {
		d: "M18 6 6 18",
		key: "1bl5f8"
	}], ["path", {
		d: "m6 6 12 12",
		key: "d8bk6v"
	}]]
};
de.node;
var fe = j(de), pe = Object.defineProperty, me = (e, t) => pe(e, "name", {
	value: t,
	configurable: !0
});
function he(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
me(he, "setRef");
function ge(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = he(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : he(e[t], null);
			}
		};
	};
}
me(ge, "composeRefs");
function L(...t) {
	return e.useCallback(ge(...t), t);
}
me(L, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-slot/dist/index.mjs
var _e = Object.defineProperty, ve = (e, t) => _e(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ye(t) {
	let n = e.forwardRef((n, r) => {
		let { children: i, ...a } = n, o = null, s = !1, c = [];
		Oe(i) && typeof Me == "function" && (i = Me(i._payload)), e.Children.forEach(i, (e) => {
			if (Ee(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				Oe(n) && typeof Me == "function" && (n = Me(n._payload)), o = Ce(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = e.cloneElement(o, void 0, c) : !s && e.Children.count(i) === 1 && e.isValidElement(i) && (o = i);
		let l = o ? Te(o) : void 0, u = L(r, l);
		if (!o) {
			if (i || i === 0) throw Error(s ? je(t) : Ae(t));
			return i;
		}
		let d = we(a, o.props ?? {});
		return o.type !== e.Fragment && (d.ref = r ? u : l), e.cloneElement(o, d);
	});
	return n.displayName = `${t}.Slot`, n;
}
ve(ye, "createSlot");
var be = /* @__PURE__ */ ye("Slot"), xe = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Se(e) {
	let t = /* @__PURE__ */ ve((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = xe, t;
}
ve(Se, "createSlottable");
var Ce = /* @__PURE__ */ ve((t, n) => {
	if ("child" in t.props) {
		let n = t.props.child;
		return e.isValidElement(n) ? e.cloneElement(n, void 0, t.props.children(n.props.children)) : null;
	}
	return e.isValidElement(n) ? n : null;
}, "getSlottableElementFromSlottable");
function we(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
ve(we, "mergeProps");
function Te(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
ve(Te, "getElementRef");
function Ee(t) {
	return e.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === xe;
}
ve(Ee, "isSlottable");
var De = Symbol.for("react.lazy");
function Oe(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === De && "_payload" in e && ke(e._payload);
}
ve(Oe, "isLazyComponent");
function ke(e) {
	return typeof e == "object" && !!e && "then" in e;
}
ve(ke, "isPromiseLike");
var Ae = /* @__PURE__ */ ve((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), je = /* @__PURE__ */ ve((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Me = e.use, Ne = Object.defineProperty, Pe = (e, t) => Ne(e, "name", {
	value: t,
	configurable: !0
}), R = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((t, n) => {
	let r = /* @__PURE__ */ ye(`Primitive.${n}`), i = e.forwardRef((e, t) => {
		let { asChild: i, ...a } = e, o = i ? r : n;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(o, {
			...a,
			ref: t
		});
	});
	return i.displayName = `Primitive.${n}`, {
		...t,
		[n]: i
	};
}, {});
function Fe(e, t) {
	e && f.flushSync(() => e.dispatchEvent(t));
}
Pe(Fe, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-visually-hidden@1.2.11_@types+react-dom@19.3.0_@types+react@19.3.0__@types+re_n6jx6dzvh44dfkh6bwen4iojya/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var Ie = Object.defineProperty, Le = (e, t) => Ie(e, "name", {
	value: t,
	configurable: !0
}), Re = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), ze = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Le(function(e, t) {
	return /* @__PURE__ */ m(R.span, {
		...e,
		ref: t,
		style: {
			...Re,
			...e.style
		}
	});
}, "VisuallyHidden")), Be = Object.defineProperty, Ve = (e, t) => Be(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function He(t, n) {
	let r = e.createContext(n);
	r.displayName = t + "Context";
	let i = /* @__PURE__ */ Ve((t) => {
		let { children: n, ...i } = t, a = e.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ m(r.Provider, {
			value: a,
			children: n
		});
	}, "Provider");
	i.displayName = t + "Provider";
	function a(i, a = {}) {
		let { optional: o = !1 } = a, s = e.useContext(r);
		if (s) return s;
		if (n !== void 0) return n;
		if (!o) throw Error(`\`${i}\` must be used within \`${t}\``);
	}
	return Ve(a, "useContext"), [i, a];
}
Ve(He, "createContext");
// @__NO_SIDE_EFFECTS__
function Ue(t, n = []) {
	let r = [];
	function i(n, i) {
		let a = e.createContext(i);
		a.displayName = n + "Context";
		let o = r.length;
		r = [...r, i];
		let s = /* @__PURE__ */ Ve((n) => {
			let { scope: r, children: i, ...s } = n, c = r?.[t]?.[o] || a, l = e.useMemo(() => s, Object.values(s));
			return /* @__PURE__ */ m(c.Provider, {
				value: l,
				children: i
			});
		}, "Provider");
		s.displayName = n + "Provider";
		function c(r, s, c = {}) {
			let { optional: l = !1 } = c, u = s?.[t]?.[o] || a, d = e.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${r}\` must be used within \`${n}\``);
		}
		return Ve(c, "useContext"), [s, c];
	}
	Ve(i, "createContext");
	let a = /* @__PURE__ */ Ve(() => {
		let n = r.map((t) => e.createContext(t));
		return /* @__PURE__ */ Ve(function(r) {
			let i = r?.[t] || n;
			return e.useMemo(() => ({ [`__scope${t}`]: {
				...r,
				[t]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return a.scopeName = t, [i, We(a, ...n)];
}
Ve(Ue, "createContextScope");
function We(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = /* @__PURE__ */ Ve(() => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ Ve(function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = n.scopeName, r;
}
Ve(We, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-collection@1.1.15_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@1_f3ap4vliqleip4r4cx5rrf2sqy/node_modules/@radix-ui/react-collection/dist/index.mjs
var Ge = Object.defineProperty, Ke = (e, t) => Ge(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function qe(t) {
	let n = t + "CollectionProvider", [r, i] = /* @__PURE__ */ Ue(n), [a, o] = r(n, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), s = /* @__PURE__ */ Ke((t) => {
		let { scope: n, children: r } = t, i = e.useRef(null), o = e.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ m(a, {
			scope: n,
			itemMap: o,
			collectionRef: i,
			children: r
		});
	}, "CollectionProvider");
	s.displayName = n;
	let c = t + "CollectionSlot", l = /* @__PURE__ */ ye(c), u = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = L(t, o(c, n).collectionRef);
		return /* @__PURE__ */ m(l, {
			ref: i,
			children: r
		});
	});
	u.displayName = c;
	let d = t + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ ye(d), h = e.forwardRef((t, n) => {
		let { scope: r, children: i, ...a } = t, s = e.useRef(null), c = L(n, s), l = o(d, r);
		return e.useEffect(() => (l.itemMap.set(s, {
			ref: s,
			...a
		}), () => void l.itemMap.delete(s))), /* @__PURE__ */ m(p, {
			[f]: "",
			ref: c,
			children: i
		});
	});
	h.displayName = d;
	function g(n) {
		let r = o(t + "CollectionConsumer", n);
		return e.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${f}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return Ke(g, "useCollection"), [
		{
			Provider: s,
			Slot: u,
			ItemSlot: h
		},
		g,
		i
	];
}
Ke(qe, "createCollection");
var Je = /* @__PURE__ */ new WeakMap(), Ye = class e extends Map {
	static {
		Ke(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], Je.set(this, !0);
	}
	set(e, t) {
		return Je.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = Qe(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = Xe(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = Xe(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return Xe(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function Xe(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = Ze(e, t);
	return n === -1 ? void 0 : e[n];
}
Ke(Xe, "at");
function Ze(e, t) {
	let n = e.length, r = Qe(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
Ke(Ze, "toSafeIndex");
function Qe(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
Ke(Qe, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function $e(t) {
	let n = t + "CollectionProvider", [r, i] = /* @__PURE__ */ Ue(n), [a, o] = r(n, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new Ye(),
		setItemMap: /* @__PURE__ */ Ke(() => void 0, "setItemMap")
	}), s = /* @__PURE__ */ Ke(({ state: e, ...t }) => e ? /* @__PURE__ */ m(l, {
		...t,
		state: e
	}) : /* @__PURE__ */ m(c, { ...t }), "CollectionProvider");
	s.displayName = n;
	let c = /* @__PURE__ */ Ke((e) => {
		let t = _();
		return /* @__PURE__ */ m(l, {
			...e,
			state: t
		});
	}, "CollectionInit");
	c.displayName = n + "Init";
	let l = /* @__PURE__ */ Ke((t) => {
		let { scope: n, children: r, state: i } = t, o = e.useRef(null), [s, c] = e.useState(null), l = L(o, c), [u, d] = i;
		return e.useEffect(() => {
			if (!s) return;
			let e = rt(() => {});
			return e.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [s]), /* @__PURE__ */ m(a, {
			scope: n,
			itemMap: u,
			setItemMap: d,
			collectionRef: l,
			collectionRefObject: o,
			collectionElement: s,
			children: r
		});
	}, "CollectionProviderImpl");
	l.displayName = n + "Impl";
	let u = t + "CollectionSlot", d = /* @__PURE__ */ ye(u), f = e.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = L(t, o(u, n).collectionRef);
		return /* @__PURE__ */ m(d, {
			ref: i,
			children: r
		});
	});
	f.displayName = u;
	let p = t + "CollectionItemSlot", h = /* @__PURE__ */ ye(p), g = e.forwardRef((t, n) => {
		let { scope: r, children: i, ...a } = t, s = e.useRef(null), [c, l] = e.useState(null), u = L(n, s, l), { setItemMap: d } = o(p, r), f = e.useRef(a);
		et(f.current, a) || (f.current = a);
		let g = f.current;
		return e.useEffect(() => {
			let e = g;
			return d((t) => c ? t.has(c) ? t.set(c, {
				...e,
				element: c
			}).toSorted(nt) : (t.set(c, {
				...e,
				element: c
			}), t.toSorted(nt)) : t), () => {
				d((e) => !c || !e.has(c) ? e : (e.delete(c), new Ye(e)));
			};
		}, [
			c,
			g,
			d
		]), /* @__PURE__ */ m(h, {
			"data-radix-collection-item": "",
			ref: u,
			children: i
		});
	});
	g.displayName = p;
	function _() {
		return e.useState(new Ye());
	}
	Ke(_, "useInitCollection");
	function v(e) {
		let { itemMap: n } = o(t + "CollectionConsumer", e);
		return n;
	}
	return Ke(v, "useCollection"), [{
		Provider: s,
		Slot: f,
		ItemSlot: g
	}, {
		createCollectionScope: i,
		useCollection: v,
		useInitCollection: _
	}];
}
Ke($e, "createCollection");
function et(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
Ke(et, "shallowEqual");
function tt(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
Ke(tt, "isElementPreceding");
function nt(e, t) {
	return !e[1].element || !t[1].element ? 0 : tt(e[1].element, t[1].element) ? -1 : 1;
}
Ke(nt, "sortByDocumentPosition");
function rt(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
Ke(rt, "getChildListObserver");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+primitive@1.1.7/node_modules/@radix-ui/primitive/dist/index.mjs
var it = Object.defineProperty, at = (e, t) => it(e, "name", {
	value: t,
	configurable: !0
}), ot = !!(typeof window < "u" && window.document && window.document.createElement);
function z(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ at(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
at(z, "composeEventHandlers");
function st(e) {
	if (!ot) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
at(st, "getOwnerWindow");
function ct(e) {
	if (!ot) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
at(ct, "getOwnerDocument");
function lt(e, t = !1) {
	let { activeElement: n } = ct(e);
	if (!n?.nodeName) return null;
	if (ut(n) && n.contentDocument) return lt(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = ct(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
at(lt, "getActiveElement");
function ut(e) {
	return e.tagName === "IFRAME";
}
at(ut, "isFrame");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var B = globalThis?.document ? e.useLayoutEffect : () => {}, dt = Object.defineProperty, ft = (e, t) => dt(e, "name", {
	value: t,
	configurable: !0
}), pt = e.useEffectEvent, mt = e.useInsertionEffect;
function ht(t) {
	if (typeof pt == "function") return pt(t);
	let n = e.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof mt == "function" ? mt(() => {
		n.current = t;
	}) : B(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
ft(ht, "useEffectEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.6_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var gt = Object.defineProperty, _t = (e, t) => gt(e, "name", {
	value: t,
	configurable: !0
}), vt = e.useInsertionEffect || B;
function yt({ prop: t, defaultProp: n, onChange: r = /* @__PURE__ */ _t(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = bt({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0;
	return [c ? t : a, e.useCallback((e) => {
		if (c) {
			let n = xt(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
_t(yt, "useControllableState");
function bt({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return vt(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
_t(bt, "useUncontrolledState");
function xt(e) {
	return typeof e == "function";
}
_t(xt, "isFunction");
var St = Symbol("RADIX:SYNC_STATE");
function Ct(t, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = ht(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = e.useReducer((e, n) => {
		if (n.type === St) return {
			...e,
			state: n.state
		};
		let r = t(e, n);
		return l && !Object.is(r.state, e.state) && u(r.state), r;
	}, ...d), m = f.state, h = e.useRef(m);
	e.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = e.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return e.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: St,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
_t(Ct, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-presence@1.1.10_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19._le2queyd54w4los2cqbhdgwup4/node_modules/@radix-ui/react-presence/dist/index.mjs
var wt = Object.defineProperty, Tt = (e, t) => wt(e, "name", {
	value: t,
	configurable: !0
});
function Et(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
Tt(Et, "useStateMachine");
var Dt = /* @__PURE__ */ Tt((t) => {
	let { present: n, children: r } = t, i = Ot(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = At(i.ref, Mt(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
}, "Presence");
function Ot(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), s = e.useRef(void 0), [c, l] = Et(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? jt(i.current), s.current = void 0) : o.current = "none";
	}, [c]), B(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = jt(e);
			t ? (s.current = i, l("MOUNT")) : i === "none" || e?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, l]), B(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ Tt((r) => {
				let o = jt(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (l("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Tt((e) => {
				e.target === n && (o.current = jt(i.current));
			}, "handleAnimationStart");
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		}
		l("ANIMATION_END");
	}, [n, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: e.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = jt(t);
			} else i.current = null;
			r(e);
		}, [])
	};
}
Tt(Ot, "usePresence");
function kt(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Tt(kt, "setRef");
function At(...t) {
	let n = e.useRef(t);
	return n.current = t, e.useCallback((e) => {
		let t = n.current, r = !1, i = t.map((t) => {
			let n = kt(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let n = i[e];
				typeof n == "function" ? n() : kt(t[e], null);
			}
		};
	}, []);
}
Tt(At, "useStableComposedRefs");
function jt(e) {
	return e?.animationName || "none";
}
Tt(jt, "getAnimationName");
function Mt(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Tt(Mt, "getElementRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-id@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-id/dist/index.mjs
var Nt = Object.defineProperty, Pt = (e, t) => Nt(e, "name", {
	value: t,
	configurable: !0
}), Ft = e.useId || (() => void 0), It = 0;
function V(t) {
	let [n, r] = e.useState(Ft());
	return B(() => {
		t || r((e) => e ?? String(It++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
Pt(V, "useId");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-collapsible@1.1.20_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_nngmx7inaoypyavrj3hqtmzi2q/node_modules/@radix-ui/react-collapsible/dist/index.mjs
var Lt = Object.defineProperty, Rt = (e, t) => Lt(e, "name", {
	value: t,
	configurable: !0
}), zt = "Collapsible", [Bt, Vt] = /* @__PURE__ */ Ue(zt), [Ht, Ut] = Bt(zt), Wt = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rt(function(t, n) {
	let { __scopeCollapsible: r, open: i, defaultOpen: a, disabled: o, onOpenChange: s, ...c } = t, [l, u] = yt({
		prop: i,
		defaultProp: a ?? !1,
		onChange: s,
		caller: zt
	});
	return /* @__PURE__ */ m(Ht, {
		scope: r,
		disabled: o,
		contentId: V(),
		open: l,
		onOpenToggle: e.useCallback(() => u((e) => !e), [u]),
		children: /* @__PURE__ */ m(R.div, {
			"data-state": Xt(l),
			"data-disabled": o ? "" : void 0,
			...c,
			ref: n
		})
	});
}, "Collapsible")), Gt = "CollapsibleTrigger", Kt = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rt(function(e, t) {
	let { __scopeCollapsible: n, ...r } = e, i = Ut(Gt, n);
	return /* @__PURE__ */ m(R.button, {
		type: "button",
		"aria-controls": i.open ? i.contentId : void 0,
		"aria-expanded": i.open || !1,
		"data-state": Xt(i.open),
		"data-disabled": i.disabled ? "" : void 0,
		disabled: i.disabled,
		...r,
		ref: t,
		onClick: z(e.onClick, i.onOpenToggle)
	});
}, "CollapsibleTrigger")), qt = "CollapsibleContent", Jt = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rt(function(e, t) {
	let { forceMount: n, ...r } = e, i = Ut(qt, e.__scopeCollapsible);
	return /* @__PURE__ */ m(Dt, {
		present: n || i.open,
		children: ({ present: e }) => /* @__PURE__ */ m(Yt, {
			...r,
			ref: t,
			present: e
		})
	});
}, "CollapsibleContent")), Yt = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Rt(function(t, n) {
	let { __scopeCollapsible: r, present: i, children: a, ...o } = t, s = Ut(qt, r), [c, l] = e.useState(i), u = e.useRef(null), d = L(n, u), f = e.useRef(0), p = f.current, h = e.useRef(0), g = h.current, _ = s.open || c, v = e.useRef(_), y = e.useRef(void 0);
	return e.useEffect(() => {
		let e = requestAnimationFrame(() => v.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), B(() => {
		let e = u.current;
		if (e) {
			y.current = y.current || {
				transitionDuration: e.style.transitionDuration,
				animationName: e.style.animationName
			}, e.style.transitionDuration = "0s", e.style.animationName = "none";
			let t = e.getBoundingClientRect();
			f.current = t.height, h.current = t.width, v.current || (e.style.transitionDuration = y.current.transitionDuration, e.style.animationName = y.current.animationName), l(i);
		}
	}, [s.open, i]), /* @__PURE__ */ m(R.div, {
		"data-state": Xt(s.open),
		"data-disabled": s.disabled ? "" : void 0,
		id: s.contentId,
		hidden: !_,
		...o,
		ref: d,
		style: {
			"--radix-collapsible-content-height": p ? `${p}px` : void 0,
			"--radix-collapsible-content-width": g ? `${g}px` : void 0,
			...t.style
		},
		children: _ && a
	});
}, "CollapsibleContentImpl"));
function Xt(e) {
	return e ? "open" : "closed";
}
Rt(Xt, "getState");
var Zt = Wt, Qt = Kt, $t = Jt, en = Object.defineProperty, tn = (e, t) => en(e, "name", {
	value: t,
	configurable: !0
}), nn = e.createContext(void 0);
function rn(t) {
	let n = e.useContext(nn);
	return t || n || "ltr";
}
tn(rn, "useDirection");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-accordion@1.2.20_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19_cr6exzobi6pk75d6wx6xpssxgq/node_modules/@radix-ui/react-accordion/dist/index.mjs
var an = Object.defineProperty, on = (e, t) => an(e, "name", {
	value: t,
	configurable: !0
}), sn = "Accordion", cn = [
	"Home",
	"End",
	"ArrowDown",
	"ArrowUp",
	"ArrowLeft",
	"ArrowRight"
], [ln, un, dn] = /* @__PURE__ */ qe(sn), [fn, pn] = /* @__PURE__ */ Ue(sn, [dn, Vt]), mn = Vt(), hn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(e, t) {
	let { type: n, ...r } = e, i = r, a = r;
	return /* @__PURE__ */ m(ln.Provider, {
		scope: e.__scopeAccordion,
		children: n === "multiple" ? /* @__PURE__ */ m(xn, {
			...a,
			ref: t
		}) : /* @__PURE__ */ m(bn, {
			...i,
			ref: t
		})
	});
}, "Accordion")), [gn, _n] = fn(sn), [vn, yn] = fn(sn, { collapsible: !1 }), bn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(t, n) {
	let { value: r, defaultValue: i, onValueChange: a = /* @__PURE__ */ on(() => {}, "onValueChange"), collapsible: o = !1, ...s } = t, [c, l] = yt({
		prop: r,
		defaultProp: i ?? "",
		onChange: a,
		caller: sn
	});
	return /* @__PURE__ */ m(gn, {
		scope: t.__scopeAccordion,
		value: e.useMemo(() => c ? [c] : [], [c]),
		onItemOpen: l,
		onItemClose: e.useCallback(() => o && l(""), [o, l]),
		children: /* @__PURE__ */ m(vn, {
			scope: t.__scopeAccordion,
			collapsible: o,
			children: /* @__PURE__ */ m(wn, {
				...s,
				ref: n
			})
		})
	});
}, "AccordionImplSingle")), xn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(t, n) {
	let { value: r, defaultValue: i, onValueChange: a = /* @__PURE__ */ on(() => {}, "onValueChange"), ...o } = t, [s, c] = yt({
		prop: r,
		defaultProp: i ?? [],
		onChange: a,
		caller: sn
	}), l = e.useCallback((e) => c((t = []) => [...t, e]), [c]), u = e.useCallback((e) => c((t = []) => t.filter((t) => t !== e)), [c]);
	return /* @__PURE__ */ m(gn, {
		scope: t.__scopeAccordion,
		value: s,
		onItemOpen: l,
		onItemClose: u,
		children: /* @__PURE__ */ m(vn, {
			scope: t.__scopeAccordion,
			collapsible: !0,
			children: /* @__PURE__ */ m(wn, {
				...o,
				ref: n
			})
		})
	});
}, "AccordionImplMultiple")), [Sn, Cn] = fn(sn), wn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(t, n) {
	let { __scopeAccordion: r, disabled: i, dir: a, orientation: o = "vertical", ...s } = t, c = L(e.useRef(null), n), l = un(r), u = rn(a) === "ltr", d = z(t.onKeyDown, (e) => {
		if (!cn.includes(e.key)) return;
		let t = e.target, n = l().filter((e) => !e.ref.current?.disabled), r = n.findIndex((e) => e.ref.current === t), i = n.length;
		if (r === -1) return;
		e.preventDefault();
		let a = r, s = i - 1, c = /* @__PURE__ */ on(() => {
			a = r + 1, a > s && (a = 0);
		}, "moveNext"), d = /* @__PURE__ */ on(() => {
			a = r - 1, a < 0 && (a = s);
		}, "movePrev");
		switch (e.key) {
			case "Home":
				a = 0;
				break;
			case "End":
				a = s;
				break;
			case "ArrowRight":
				o === "horizontal" && (u ? c() : d());
				break;
			case "ArrowDown":
				o === "vertical" && c();
				break;
			case "ArrowLeft":
				o === "horizontal" && (u ? d() : c());
				break;
			case "ArrowUp": o === "vertical" && d();
		}
		n[a % i].ref.current?.focus();
	});
	return /* @__PURE__ */ m(Sn, {
		scope: r,
		disabled: i,
		direction: a,
		orientation: o,
		children: /* @__PURE__ */ m(ln.Slot, {
			scope: r,
			children: /* @__PURE__ */ m(R.div, {
				...s,
				"data-orientation": o,
				ref: c,
				onKeyDown: i ? void 0 : d
			})
		})
	});
}, "AccordionImpl")), Tn = "AccordionItem", [En, Dn] = fn(Tn), On = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(e, t) {
	let { __scopeAccordion: n, value: r, ...i } = e, a = Cn(Tn, n), o = _n(Tn, n), s = mn(n), c = V(), l = r && o.value.includes(r) || !1, u = a.disabled || e.disabled;
	return /* @__PURE__ */ m(En, {
		scope: n,
		open: l,
		disabled: u,
		triggerId: c,
		children: /* @__PURE__ */ m(Zt, {
			"data-orientation": a.orientation,
			"data-state": Fn(l),
			...s,
			...i,
			ref: t,
			disabled: u,
			open: l,
			onOpenChange: (e) => {
				e ? o.onItemOpen(r) : o.onItemClose(r);
			}
		})
	});
}, "AccordionItem")), kn = "AccordionHeader", An = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = Cn(sn, n), a = Dn(kn, n);
	return /* @__PURE__ */ m(R.h3, {
		"data-orientation": i.orientation,
		"data-state": Fn(a.open),
		"data-disabled": a.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "AccordionHeader")), jn = "AccordionTrigger", Mn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = Cn(sn, n), a = Dn(jn, n), o = yn(jn, n), s = mn(n);
	return /* @__PURE__ */ m(ln.ItemSlot, {
		scope: n,
		children: /* @__PURE__ */ m(Qt, {
			"aria-disabled": a.open && !o.collapsible || void 0,
			"data-orientation": i.orientation,
			id: a.triggerId,
			...s,
			...r,
			ref: t
		})
	});
}, "AccordionTrigger")), Nn = "AccordionContent", Pn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ on(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = Cn(sn, n), a = Dn(Nn, n), o = mn(n);
	return /* @__PURE__ */ m($t, {
		role: "region",
		"aria-labelledby": a.triggerId,
		"data-orientation": i.orientation,
		...o,
		...r,
		ref: t,
		style: {
			"--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
			"--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
			...e.style
		}
	});
}, "AccordionContent"));
function Fn(e) {
	return e ? "open" : "closed";
}
on(Fn, "getState");
var In = hn, Ln = On, Rn = An, zn = Mn, Bn = Pn, Vn = Object.defineProperty, Hn = (e, t) => Vn(e, "name", {
	value: t,
	configurable: !0
});
function H(t) {
	let n = e.useRef(t);
	return e.useEffect(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
Hn(H, "useCallbackRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-dismissable-layer@1.1.19_@types+react-dom@19.3.0_@types+react@19.3.0__@types+_tnxy3uok6ztholiu3mnfmvjzpe/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Un = Object.defineProperty, Wn = (e, t) => Un(e, "name", {
	value: t,
	configurable: !0
}), Gn = "dismissableLayer.update", Kn = "dismissableLayer.pointerDownOutside", qn = "dismissableLayer.focusOutside", Jn, Yn = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Xn = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Wn(function(t, n) {
	let { disableOutsidePointerEvents: r = !1, deferPointerDownOutside: i = !1, onEscapeKeyDown: a, onPointerDownOutside: o, onFocusOutside: s, onInteractOutside: c, onDismiss: l, ...u } = t, d = e.useContext(Yn), [f, p] = e.useState(null), h = f?.ownerDocument ?? globalThis?.document, [, g] = e.useState({}), _ = L(n, p), v = Array.from(d.layers), [y] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), b = y ? v.indexOf(y) : -1, x = f ? v.indexOf(f) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, C = x >= b, w = e.useRef(!1), T = $n((e) => {
		o?.(e), c?.(e), e.defaultPrevented || l?.();
	}, {
		ownerDocument: h,
		deferPointerDownOutside: i,
		isDeferredPointerDownOutsideRef: w,
		dismissableSurfaces: d.dismissableSurfaces,
		shouldHandlePointerDownOutside: e.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...d.branches].some((t) => t.contains(e));
			return C && !t;
		}, [d.branches, C])
	}), E = er((e) => {
		if (i && w.current) return;
		let t = e.target;
		[...d.branches].some((e) => e.contains(t)) || (s?.(e), c?.(e), e.defaultPrevented || l?.());
	}, h), D = f ? x === v.length - 1 : !1, O = H((e) => {
		e.key === "Escape" && (a?.(e), !e.defaultPrevented && l && (e.preventDefault(), l()));
	});
	return e.useEffect(() => {
		if (D) return h.addEventListener("keydown", O, { capture: !0 }), () => h.removeEventListener("keydown", O, { capture: !0 });
	}, [
		h,
		D,
		O
	]), e.useEffect(() => {
		if (f) return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Jn = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), tr(), () => {
			r && (d.layersWithOutsidePointerEventsDisabled.delete(f), d.layersWithOutsidePointerEventsDisabled.size === 0 && (h.body.style.pointerEvents = Jn));
		};
	}, [
		f,
		h,
		r,
		d
	]), e.useEffect(() => () => {
		f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), tr());
	}, [f, d]), e.useEffect(() => {
		let e = /* @__PURE__ */ Wn(() => g({}), "handleUpdate");
		return document.addEventListener(Gn, e), () => document.removeEventListener(Gn, e);
	}, []), /* @__PURE__ */ m(R.div, {
		...u,
		ref: _,
		style: {
			pointerEvents: S ? C ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: z(t.onFocusCapture, E.onFocusCapture),
		onBlurCapture: z(t.onBlurCapture, E.onBlurCapture),
		onPointerDownCapture: z(t.onPointerDownCapture, T.onPointerDownCapture)
	});
}, "DismissableLayer"));
function Zn() {
	let t = e.useContext(Yn), [n, r] = e.useState(null);
	return e.useEffect(() => {
		if (n) return t.dismissableSurfaces.add(n), () => {
			t.dismissableSurfaces.delete(n);
		};
	}, [n, t.dismissableSurfaces]), r;
}
Wn(Zn, "useDismissableLayerSurface");
var Qn = /* @__PURE__ */ Wn(() => !0, "IS_TRUE");
function $n(t, n) {
	let { ownerDocument: r = globalThis?.document, deferPointerDownOutside: i = !1, isDeferredPointerDownOutsideRef: a, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = Qn } = n, c = H(t), l = e.useRef(!1), u = e.useRef(!1), d = e.useRef(/* @__PURE__ */ new Map()), f = e.useRef(() => {});
	return e.useEffect(() => {
		function e() {
			u.current = !1, a.current = !1, d.current.clear();
		}
		Wn(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		Wn(t, "isOutsideInteractionIntercepted");
		function n(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && f.current();
			}, 0);
		}
		Wn(n, "handleInteractionCapture");
		function p(e) {
			u.current && d.current.set(e.type, !1);
		}
		Wn(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ Wn((n) => {
			if (n.target && !l.current) {
				let o = function() {
					r.removeEventListener("click", f.current);
					let n = t();
					e(), n || nr(Kn, c, p, { discrete: !0 });
				};
				if (Wn(o, "handleAndDispatchPointerDownOutsideEvent"), !s(n.target)) {
					r.removeEventListener("click", f.current), e(), l.current = !1;
					return;
				}
				let p = { originalEvent: n };
				u.current = !0, a.current = i && n.button === 0, d.current.clear(), !i || n.button !== 0 ? o() : (r.removeEventListener("click", f.current), f.current = o, r.addEventListener("click", f.current, { once: !0 }));
			} else r.removeEventListener("click", f.current), e();
			l.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) r.addEventListener(e, n, !0), r.addEventListener(e, p);
		let g = window.setTimeout(() => {
			r.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), r.removeEventListener("pointerdown", m), r.removeEventListener("click", f.current);
			for (let e of h) r.removeEventListener(e, n, !0), r.removeEventListener(e, p);
		};
	}, [
		r,
		c,
		i,
		a,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ Wn(() => l.current = !0, "onPointerDownCapture") };
}
Wn($n, "usePointerDownOutside");
function er(t, n = globalThis?.document) {
	let r = H(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ Wn((e) => {
			e.target && !i.current && nr(qn, r, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: /* @__PURE__ */ Wn(() => i.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ Wn(() => i.current = !1, "onBlurCapture")
	};
}
Wn(er, "useFocusOutside");
function tr() {
	let e = new CustomEvent(Gn);
	document.dispatchEvent(e);
}
Wn(tr, "dispatchUpdate");
function nr(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? Fe(i, a) : i.dispatchEvent(a);
}
Wn(nr, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-scope@1.1.16_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@_o6qtbyfrzoj4d2uame34ov5cay/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var rr = Object.defineProperty, ir = (e, t) => rr(e, "name", {
	value: t,
	configurable: !0
}), ar = "focusScope.autoFocusOnMount", or = "focusScope.autoFocusOnUnmount", sr = {
	bubbles: !1,
	cancelable: !0
}, cr = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ir(function(t, n) {
	let { loop: r = !1, trapped: i = !1, onMountAutoFocus: a, onUnmountAutoFocus: o, ...s } = t, [c, l] = e.useState(null), u = H(a), d = H(o), f = e.useRef(null), p = L(n, l), h = e.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	e.useEffect(() => {
		if (i) {
			let e = function(e) {
				if (h.paused || !c) return;
				let t = e.target;
				c.contains(t) ? f.current = t : hr(f.current, { select: !0 });
			}, t = function(e) {
				if (h.paused || !c) return;
				let t = e.relatedTarget;
				t !== null && (c.contains(t) || hr(f.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && hr(c);
			};
			ir(e, "handleFocusIn"), ir(t, "handleFocusOut"), ir(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return c && r.observe(c, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		i,
		c,
		h.paused
	]), e.useEffect(() => {
		if (c) {
			gr.add(h);
			let e = document.activeElement;
			if (!c.contains(e)) {
				let t = new CustomEvent(ar, sr);
				c.addEventListener(ar, u), c.dispatchEvent(t), t.defaultPrevented || (lr(yr(dr(c)), { select: !0 }), document.activeElement === e && hr(c));
			}
			return () => {
				c.removeEventListener(ar, u), setTimeout(() => {
					let t = new CustomEvent(or, sr);
					c.addEventListener(or, d), c.dispatchEvent(t), t.defaultPrevented || hr(e ?? document.body, { select: !0 }), c.removeEventListener(or, d), gr.remove(h);
				}, 0);
			};
		}
	}, [
		c,
		u,
		d,
		h
	]);
	let g = e.useCallback((e) => {
		if (!r && !i || h.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = ur(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && hr(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && hr(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		i,
		h.paused
	]);
	return /* @__PURE__ */ m(R.div, {
		tabIndex: -1,
		...s,
		ref: p,
		onKeyDown: g
	});
}, "FocusScope"));
function lr(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (hr(r, { select: t }), document.activeElement !== n) return;
}
ir(lr, "focusFirst");
function ur(e) {
	let t = dr(e);
	return [fr(t, e), fr(t.reverse(), e)];
}
ir(ur, "getTabbableEdges");
function dr(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ ir((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
ir(dr, "getTabbableCandidates");
function fr(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : pr(r, { upTo: t }))) return r;
}
ir(fr, "findVisible");
function pr(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
ir(pr, "isHidden");
function mr(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
ir(mr, "isSelectableInput");
function hr(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && mr(e) && t && e.select();
	}
}
ir(hr, "focus");
var gr = _r();
function _r() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = vr(e, t), e.unshift(t);
		},
		remove(t) {
			e = vr(e, t), e[0]?.resume();
		}
	};
}
ir(_r, "createFocusScopesStack");
function vr(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
ir(vr, "arrayRemove");
function yr(e) {
	return e.filter((e) => e.tagName !== "A");
}
ir(yr, "removeLinks");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-portal@1.1.17_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3._k2mrxhjbwbr5vl3gwk4zbzzley/node_modules/@radix-ui/react-portal/dist/index.mjs
var br = Object.defineProperty, xr = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => br(e, "name", {
	value: t,
	configurable: !0
}))(function(t, n) {
	let { container: r, ...i } = t, [a, o] = e.useState(!1);
	B(() => o(!0), []);
	let s = r || a && globalThis?.document?.body;
	return s ? f.createPortal(/* @__PURE__ */ m(R.div, {
		...i,
		ref: n
	}), s) : null;
}, "Portal")), Sr = Object.defineProperty, Cr = (e, t) => Sr(e, "name", {
	value: t,
	configurable: !0
}), wr = 0, Tr = null;
function Er(e) {
	return Dr(), e.children;
}
Cr(Er, "FocusGuards");
function Dr() {
	e.useEffect(() => {
		Tr ||= {
			start: Or(),
			end: Or()
		};
		let { start: e, end: t } = Tr;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), wr++, () => {
			wr === 1 && (Tr?.start.remove(), Tr?.end.remove(), Tr = null), wr = Math.max(0, wr - 1);
		};
	}, []);
}
Cr(Dr, "useFocusGuards");
function Or() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Cr(Or, "createFocusGuard");
//#endregion
//#region ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var kr = function() {
	return kr = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, kr.apply(this, arguments);
};
function Ar(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function jr(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Mr = "right-scroll-bar-position", Nr = "width-before-scroll-bar", Pr = "with-scroll-bars-hidden", Fr = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/assignRef.js
function Ir(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/useRef.js
function Lr(e, t) {
	var n = d(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.3.0_react@19.3.0/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var Rr = typeof window < "u" ? e.useLayoutEffect : e.useEffect, zr = /* @__PURE__ */ new WeakMap();
function Br(e, t) {
	var n = Lr(t || null, function(t) {
		return e.forEach(function(e) {
			return Ir(e, t);
		});
	});
	return Rr(function() {
		var t = zr.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Ir(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Ir(e, a);
			});
		}
		zr.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.3.0_react@19.3.0/node_modules/use-sidecar/dist/es2015/medium.js
function Vr(e) {
	return e;
}
function Hr(e, t) {
	t === void 0 && (t = Vr);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function Ur(e) {
	e === void 0 && (e = {});
	var t = Hr(null);
	return t.options = kr({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.3.0_react@19.3.0/node_modules/use-sidecar/dist/es2015/exports.js
var Wr = function(t) {
	var n = t.sideCar, r = Ar(t, ["sideCar"]);
	if (!n) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = n.read();
	if (!i) throw Error("Sidecar medium not found");
	return e.createElement(i, kr({}, r));
};
Wr.isSideCarExport = !0;
function Gr(e, t) {
	return e.useMedium(t), Wr;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll/dist/es2015/medium.js
var Kr = Ur(), qr = function() {}, Jr = e.forwardRef(function(t, n) {
	var r = e.useRef(null), i = e.useState({
		onScrollCapture: qr,
		onWheelCapture: qr,
		onTouchMoveCapture: qr
	}), a = i[0], o = i[1], s = t.forwardProps, c = t.children, l = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, p = t.sideCar, m = t.noRelative, h = t.noIsolation, g = t.inert, _ = t.allowPinchZoom, v = t.as, y = v === void 0 ? "div" : v, b = t.gapMode, x = Ar(t, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = Br([r, n]), w = kr(kr({}, x), a);
	return e.createElement(e.Fragment, null, d && e.createElement(S, {
		sideCar: Kr,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: r,
		gapMode: b
	}), s ? e.cloneElement(e.Children.only(c), kr(kr({}, w), { ref: C })) : e.createElement(y, kr({}, w, {
		className: l,
		ref: C
	}), c));
});
Jr.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, Jr.classNames = {
	fullWidth: Nr,
	zeroRight: Mr
};
//#endregion
//#region ../../node_modules/.pnpm/get-nonce@1.0.1/node_modules/get-nonce/dist/es2015/index.js
var Yr = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.3.0_react@19.3.0/node_modules/react-style-singleton/dist/es2015/singleton.js
function Xr() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Yr();
	return t && e.setAttribute("nonce", t), e;
}
function Zr(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Qr(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var $r = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Xr()) && (Zr(t, n), Qr(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, ei = function() {
	var t = $r();
	return function(n, r) {
		e.useEffect(function() {
			return t.add(n), function() {
				t.remove();
			};
		}, [n && r]);
	};
}, ti = function() {
	var e = ei();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, ni = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, ri = function(e) {
	return parseInt(e || "", 10) || 0;
}, ii = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		ri(n),
		ri(r),
		ri(i)
	];
}, ai = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return ni;
	var t = ii(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, oi = ti(), si = "data-scroll-locked", ci = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Pr} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${si}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Mr} {
    right: ${s}px ${r};
  }
  
  .${Nr} {
    margin-right: ${s}px ${r};
  }
  
  .${Mr} .${Mr} {
    right: 0 ${r};
  }
  
  .${Nr} .${Nr} {
    margin-right: 0 ${r};
  }
  
  body[${si}] {
    ${Fr}: ${s}px;
  }
`;
}, li = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, ui = function() {
	e.useEffect(function() {
		return document.body.setAttribute(si, (li() + 1).toString()), function() {
			var e = li() - 1;
			e <= 0 ? document.body.removeAttribute(si) : document.body.setAttribute(si, e.toString());
		};
	}, []);
}, di = function(t) {
	var n = t.noRelative, r = t.noImportant, i = t.gapMode, a = i === void 0 ? "margin" : i;
	ui();
	var o = e.useMemo(function() {
		return ai(a);
	}, [a]);
	return e.createElement(oi, { styles: ci(o, !n, a, r ? "" : "!important") });
}, fi = !1;
if (typeof window < "u") try {
	var pi = Object.defineProperty({}, "passive", { get: function() {
		return fi = !0, !0;
	} });
	window.addEventListener("test", pi, pi), window.removeEventListener("test", pi, pi);
} catch {
	fi = !1;
}
var mi = fi ? { passive: !1 } : !1, hi = function(e) {
	return e.tagName === "TEXTAREA";
}, gi = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !hi(e) && n[t] === "visible");
}, _i = function(e) {
	return gi(e, "overflowY");
}, vi = function(e) {
	return gi(e, "overflowX");
}, yi = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Si(e, r)) {
			var i = Ci(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, bi = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, xi = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Si = function(e, t) {
	return e === "v" ? _i(t) : vi(t);
}, Ci = function(e, t) {
	return e === "v" ? bi(t) : xi(t);
}, wi = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Ti = function(e, t, n, r, i) {
	var a = wi(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Ci(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Si(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Ei = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Di = function(e) {
	return [e.deltaX, e.deltaY];
}, Oi = function(e) {
	return e && "current" in e ? e.current : e;
}, ki = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Ai = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, ji = 0, Mi = [];
function Ni(t) {
	var n = e.useRef([]), r = e.useRef([0, 0]), i = e.useRef(), a = e.useState(ji++)[0], o = e.useState(ti)[0], s = e.useRef(t);
	e.useEffect(function() {
		s.current = t;
	}, [t]), e.useEffect(function() {
		if (t.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var e = jr([t.lockRef.current], (t.shards || []).map(Oi), !0).filter(Boolean);
			return e.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), e.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		t.inert,
		t.lockRef.current,
		t.shards
	]);
	var c = e.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var n = Ei(e), a = r.current, o = "deltaX" in e ? e.deltaX : a[0] - n[0], c = "deltaY" in e ? e.deltaY : a[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = yi(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = yi(d, u)), !m) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var h = i.current || l;
		return Ti(h, t, e, h === "h" ? o : c, !0);
	}, []), l = e.useCallback(function(e) {
		var t = e;
		if (Mi.length && Mi[Mi.length - 1] === o) {
			var r = "deltaY" in t ? Di(t) : Ei(t), i = n.current.filter(function(e) {
				return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && ki(e.delta, r);
			})[0];
			if (i && i.should) {
				t.cancelable && t.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(Oi).filter(Boolean).filter(function(e) {
					return e.contains(t.target);
				});
				(a.length > 0 ? c(t, a[0]) : !s.current.noIsolation) && t.cancelable && t.preventDefault();
			}
		}
	}, []), u = e.useCallback(function(e, t, r, i) {
		var a = {
			name: e,
			delta: t,
			target: r,
			should: i,
			shadowParent: Pi(r)
		};
		n.current.push(a), setTimeout(function() {
			n.current = n.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = e.useCallback(function(e) {
		r.current = Ei(e), i.current = void 0;
	}, []), f = e.useCallback(function(e) {
		u(e.type, Di(e), e.target, c(e, t.lockRef.current));
	}, []), p = e.useCallback(function(e) {
		u(e.type, Ei(e), e.target, c(e, t.lockRef.current));
	}, []);
	e.useEffect(function() {
		return Mi.push(o), t.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, mi), document.addEventListener("touchmove", l, mi), document.addEventListener("touchstart", d, mi), function() {
			Mi = Mi.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, mi), document.removeEventListener("touchmove", l, mi), document.removeEventListener("touchstart", d, mi);
		};
	}, []);
	var m = t.removeScrollBar, h = t.inert;
	return e.createElement(e.Fragment, null, h ? e.createElement(o, { styles: Ai(a) }) : null, m ? e.createElement(di, {
		noRelative: t.noRelative,
		gapMode: t.gapMode
	}) : null);
}
function Pi(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.3.0_react@19.3.0/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var Fi = Gr(Kr, Ni), Ii = e.forwardRef(function(t, n) {
	return e.createElement(Jr, kr({}, t, {
		ref: n,
		sideCar: Fi
	}));
});
Ii.classNames = Jr.classNames;
//#endregion
//#region ../../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var Li = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, Ri = /* @__PURE__ */ new WeakMap(), zi = /* @__PURE__ */ new WeakMap(), Bi = {}, Vi = 0, Hi = function(e) {
	return e && (e.host || Hi(e.parentNode));
}, Ui = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = Hi(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Wi = function(e, t, n, r) {
	var i = Ui(t, Array.isArray(e) ? e : [e]);
	Bi[n] || (Bi[n] = /* @__PURE__ */ new WeakMap());
	var a = Bi[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (Ri.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				Ri.set(e, c), a.set(e, l), o.push(e), c === 1 && i && zi.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Vi++, function() {
		o.forEach(function(e) {
			var t = Ri.get(e) - 1, i = a.get(e) - 1;
			Ri.set(e, t), a.set(e, i), t || (zi.has(e) || e.removeAttribute(r), zi.delete(e)), i || e.removeAttribute(n);
		}), Vi--, Vi || (Ri = /* @__PURE__ */ new WeakMap(), Ri = /* @__PURE__ */ new WeakMap(), zi = /* @__PURE__ */ new WeakMap(), Bi = {});
	};
}, Gi = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Li(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Wi(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Ki = Object.defineProperty, qi = (e, t) => Ki(e, "name", {
	value: t,
	configurable: !0
}), Ji = "Dialog", [Yi, Xi] = /* @__PURE__ */ Ue(Ji), [Zi, Qi] = Yi(Ji), $i = /* @__PURE__ */ qi((t) => {
	let { __scopeDialog: n, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: s = !0 } = t, c = e.useRef(null), l = e.useRef(null), [u, d] = yt({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: Ji
	}), [f, p] = e.useState(0), [h, g] = e.useState(0);
	return /* @__PURE__ */ m(Zi, {
		scope: n,
		triggerRef: c,
		contentRef: l,
		contentId: V(),
		titleId: V(),
		descriptionId: V(),
		titlePresent: f > 0,
		descriptionPresent: h > 0,
		setTitleCount: p,
		setDescriptionCount: g,
		open: u,
		onOpenChange: d,
		onOpenToggle: e.useCallback(() => d((e) => !e), [d]),
		modal: s,
		children: r
	});
}, "Dialog"), ea = "DialogTrigger", ta = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Qi(ea, n), a = L(t, i.triggerRef);
	return /* @__PURE__ */ m(R.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": xa(i.open),
		...r,
		ref: a,
		onClick: z(e.onClick, i.onOpenToggle)
	});
}, "DialogTrigger")), na = "DialogPortal", [ra, ia] = Yi(na, { forceMount: void 0 }), aa = /* @__PURE__ */ qi((t) => {
	let { __scopeDialog: n, forceMount: r, children: i, container: a } = t, o = Qi(na, n);
	return /* @__PURE__ */ m(ra, {
		scope: n,
		forceMount: r,
		children: e.Children.map(i, (e) => /* @__PURE__ */ m(Dt, {
			present: r || o.open,
			children: /* @__PURE__ */ m(xr, {
				asChild: !0,
				container: a,
				children: e
			})
		}))
	});
}, "DialogPortal"), oa = "DialogOverlay", sa = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let n = ia(oa, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Qi(oa, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ m(Dt, {
		present: r || a.open,
		children: /* @__PURE__ */ m(la, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), ca = /* @__PURE__ */ ye("DialogOverlay.RemoveScroll"), la = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Qi(oa, n), a = L(t, Zn());
	return /* @__PURE__ */ m(Ii, {
		as: ca,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ m(R.div, {
			"data-state": xa(i.open),
			...r,
			ref: a,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), ua = "DialogContent", da = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let n = ia(ua, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Qi(ua, e.__scopeDialog);
	return /* @__PURE__ */ m(Dt, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ m(fa, {
			...i,
			ref: t
		}) : /* @__PURE__ */ m(pa, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), fa = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(t, n) {
	let r = Qi(ua, t.__scopeDialog), i = e.useRef(null), a = L(n, r.contentRef, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Gi(e);
	}, []), /* @__PURE__ */ m(ma, {
		...t,
		ref: a,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		onCloseAutoFocus: z(t.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: z(t.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: z(t.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), pa = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(t, n) {
	let r = Qi(ua, t.__scopeDialog), i = e.useRef(!1), a = e.useRef(!1);
	return /* @__PURE__ */ m(ma, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && a.current && e.preventDefault();
		}
	});
}, "DialogContentNonModal")), ma = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = Qi(ua, n);
	return Dr(), /* @__PURE__ */ m(p, { children: /* @__PURE__ */ m(cr, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ m(Xn, {
			role: "dialog",
			id: s.contentId,
			"aria-describedby": s.descriptionPresent ? s.descriptionId : void 0,
			"aria-labelledby": s.titlePresent ? s.titleId : void 0,
			"data-state": xa(s.open),
			...o,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => s.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), ha = "DialogTitle", ga = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Qi(ha, n), { setTitleCount: a } = i;
	return B(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ m(R.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), _a = "DialogDescription", va = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Qi(_a, n), { setDescriptionCount: a } = i;
	return B(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ m(R.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), ya = "DialogClose", ba = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qi(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = Qi(ya, n);
	return /* @__PURE__ */ m(R.button, {
		type: "button",
		...r,
		ref: t,
		onClick: z(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function xa(e) {
	return e ? "open" : "closed";
}
qi(xa, "getState");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-alert-dialog@1.1.23_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react_ydntzbhbisfeo5rmuynxcrv45a/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs
var Sa = Object.defineProperty, Ca = (e, t) => Sa(e, "name", {
	value: t,
	configurable: !0
}), [wa, Ta] = /* @__PURE__ */ Ue("AlertDialog", [Xi]), Ea = Xi(), Da = /* @__PURE__ */ Ca((e) => {
	let { __scopeAlertDialog: t, ...n } = e, r = Ea(t);
	return /* @__PURE__ */ m($i, {
		...r,
		...n,
		modal: !0
	});
}, "AlertDialog"), Oa = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, i = Ea(n);
	return /* @__PURE__ */ m(ta, {
		...i,
		...r,
		ref: t
	});
}, "AlertDialogTrigger")), ka = /* @__PURE__ */ Ca((e) => {
	let { __scopeAlertDialog: t, ...n } = e, r = Ea(t);
	return /* @__PURE__ */ m(aa, {
		...r,
		...n
	});
}, "AlertDialogPortal"), Aa = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, i = Ea(n);
	return /* @__PURE__ */ m(sa, {
		...i,
		...r,
		ref: t
	});
}, "AlertDialogOverlay")), [ja, Ma] = wa("AlertDialogContent"), Na = e.forwardRef(/* @__PURE__ */ Ca(function(t, n) {
	let { __scopeAlertDialog: r, children: i, ...a } = t, o = Ea(r), s = L(n, e.useRef(null)), c = e.useRef(null);
	return /* @__PURE__ */ m(ja, {
		scope: r,
		cancelRef: c,
		children: /* @__PURE__ */ m(da, {
			role: "alertdialog",
			...o,
			...a,
			ref: s,
			onOpenAutoFocus: z(a.onOpenAutoFocus, (e) => {
				e.preventDefault(), c.current?.focus({ preventScroll: !0 });
			}),
			onPointerDownOutside: (e) => e.preventDefault(),
			onInteractOutside: (e) => e.preventDefault(),
			children: i
		})
	});
}, "AlertDialogContent")), Pa = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, i = Ea(n);
	return /* @__PURE__ */ m(ga, {
		...i,
		...r,
		ref: t
	});
}, "AlertDialogTitle")), Fa = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, i = Ea(n);
	return /* @__PURE__ */ m(va, {
		...i,
		...r,
		ref: t
	});
}, "AlertDialogDescription")), Ia = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, i = Ea(n);
	return /* @__PURE__ */ m(ba, {
		...i,
		...r,
		ref: t
	});
}, "AlertDialogAction")), La = "AlertDialogCancel", Ra = e.forwardRef(/* @__PURE__ */ Ca(function(e, t) {
	let { __scopeAlertDialog: n, ...r } = e, { cancelRef: i } = Ma(La, n), a = Ea(n), o = L(t, i);
	return /* @__PURE__ */ m(ba, {
		...a,
		...r,
		ref: o
	});
}, "AlertDialogCancel")), za = Da, Ba = Oa, Va = ka, Ha = Aa, Ua = Na, Wa = Ia, Ga = Ra, Ka = Pa, qa = Fa, Ja = Object.defineProperty, Ya = (e, t) => Ja(e, "name", {
	value: t,
	configurable: !0
}), Xa = "Avatar", [Za, Qa] = /* @__PURE__ */ Ue(Xa), $a = [0, () => void 0], [eo, to] = Za(Xa), no = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Ya(function(t, n) {
	let { __scopeAvatar: r, ...i } = t, [a, o] = e.useState("idle"), [s, c] = lo();
	return /* @__PURE__ */ m(eo, {
		scope: r,
		imageLoadingStatus: a,
		setImageLoadingStatus: o,
		imageCount: s,
		setImageCount: c,
		children: /* @__PURE__ */ m(R.span, {
			...i,
			ref: n
		})
	});
}, "Avatar")), ro = "AvatarImage", io = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Ya(function(t, n) {
	let { __scopeAvatar: r, src: i, onLoadingStatusChange: a, ...o } = t, s = to(ro, r);
	s.setImageCount;
	let c = so(i, {
		referrerPolicy: o.referrerPolicy,
		crossOrigin: o.crossOrigin,
		loadingStatus: s.imageLoadingStatus,
		setLoadingStatus: s.setImageLoadingStatus
	}), l = H((e) => {
		a?.(e);
	}), u = e.useRef(c);
	return B(() => {
		let e = u.current;
		u.current = c, c !== e && l(c);
	}, [c, l]), c === "loaded" ? /* @__PURE__ */ m(R.img, {
		...o,
		ref: n,
		src: i
	}) : null;
}, "AvatarImage")), ao = "AvatarFallback", oo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Ya(function(t, n) {
	let { __scopeAvatar: r, delayMs: i, ...a } = t, o = to(ao, r), [s, c] = e.useState(i === void 0);
	return e.useEffect(() => {
		if (i !== void 0) {
			let e = window.setTimeout(() => c(!0), i);
			return () => window.clearTimeout(e);
		}
	}, [i]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ m(R.span, {
		...a,
		ref: n
	}) : null;
}, "AvatarFallback"));
function so(e, { loadingStatus: t, setLoadingStatus: n, referrerPolicy: r, crossOrigin: i }) {
	return B(() => {
		if (!e) {
			n("error");
			return;
		}
		let t = new window.Image(), a = /* @__PURE__ */ Ya((e) => {
			let t = e.currentTarget;
			n(co(t));
		}, "handleLoad"), o = /* @__PURE__ */ Ya(() => n("error"), "handleError");
		return t.addEventListener("load", a), t.addEventListener("error", o), r && (t.referrerPolicy = r), t.crossOrigin = i ?? null, t.src = e, n(co(t)), () => {
			t.removeEventListener("load", a), t.removeEventListener("error", o), n("idle");
		};
	}, [
		e,
		i,
		r,
		n
	]), t;
}
Ya(so, "useImageLoadingStatus");
function co(e) {
	return e.complete ? e.naturalWidth > 0 ? "loaded" : "error" : "loading";
}
Ya(co, "getImageLoadingStatus");
function lo() {
	return $a;
}
Ya(lo, "useImageCount");
function uo(e) {}
Ya(uo, "useUpdateImageCount");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-size@1.1.4_@types+react@19.3.0_react@19.3.0/node_modules/@radix-ui/react-use-size/dist/index.mjs
var fo = Object.defineProperty, po = (e, t) => fo(e, "name", {
	value: t,
	configurable: !0
});
function mo(t) {
	let [n, r] = e.useState(void 0);
	return B(() => {
		if (t) {
			r({
				width: t.offsetWidth,
				height: t.offsetHeight
			});
			let e = new ResizeObserver((e) => {
				if (!Array.isArray(e) || !e.length) return;
				let n = e[0], i, a;
				if ("borderBoxSize" in n) {
					let e = n.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = t.offsetWidth, a = t.offsetHeight;
				r({
					width: i,
					height: a
				});
			});
			return e.observe(t, { box: "border-box" }), () => e.unobserve(t);
		}
		r(void 0);
	}, [t]), n;
}
po(mo, "useSize");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-checkbox@1.3.11_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19._iwjvxjojfbccoxfic3j6l5maoy/node_modules/@radix-ui/react-checkbox/dist/index.mjs
var ho = Object.defineProperty, go = (e, t) => ho(e, "name", {
	value: t,
	configurable: !0
}), _o = "Checkbox", [vo, yo] = /* @__PURE__ */ Ue(_o), [bo, xo] = vo(_o);
function So(t) {
	let { __scopeCheckbox: n, checked: r, children: i, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: l, required: u, value: d = "on", internal_do_not_use_render: f } = t, [p, h] = yt({
		prop: r,
		defaultProp: a ?? !1,
		onChange: l,
		caller: _o
	}), [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useRef(!1), [x, S] = e.useReducer((e) => e + 1, 0), C = !g || !!s || !!g.closest("form"), w = {
		checked: p,
		disabled: o,
		setChecked: h,
		control: g,
		setControl: _,
		name: c,
		form: s,
		value: d,
		hasConsumerStoppedPropagationRef: b,
		userInteractionCount: x,
		onUserInteraction: S,
		required: u,
		defaultChecked: !jo(a) && a,
		isFormControl: C,
		bubbleInput: v,
		setBubbleInput: y
	};
	return /* @__PURE__ */ m(bo, {
		scope: n,
		...w,
		children: Ao(f) ? f(w) : i
	});
}
go(So, "CheckboxProvider");
var Co = "CheckboxTrigger", wo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ go(function({ __scopeCheckbox: t, onKeyDown: n, onClick: r, ...i }, a) {
	let { control: o, value: s, disabled: c, checked: l, required: u, setControl: d, setChecked: f, hasConsumerStoppedPropagationRef: p, onUserInteraction: h, isFormControl: g, bubbleInput: _ } = xo(Co, t), v = L(a, d), y = e.useRef(l);
	return e.useEffect(() => {
		let e = o?.form;
		if (e) {
			let t = /* @__PURE__ */ go(() => f(y.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [o, f]), /* @__PURE__ */ m(R.button, {
		type: "button",
		role: "checkbox",
		"aria-checked": jo(l) ? "mixed" : l,
		"aria-required": u,
		"data-state": Mo(l),
		"data-disabled": c ? "" : void 0,
		disabled: c,
		value: s,
		...i,
		ref: v,
		onKeyDown: z(n, (e) => {
			e.key === "Enter" && e.preventDefault();
		}),
		onClick: z(r, (e) => {
			h(), f((e) => jo(e) ? !0 : !e), _ && g && (p.current = e.isPropagationStopped(), p.current || e.stopPropagation());
		})
	});
}, "CheckboxTrigger")), To = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ go(function(e, t) {
	let { __scopeCheckbox: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: u, ...d } = e;
	return /* @__PURE__ */ m(So, {
		__scopeCheckbox: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: u,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(wo, {
			...d,
			ref: t,
			__scopeCheckbox: n
		}), e && /* @__PURE__ */ m(ko, { __scopeCheckbox: n })] })
	});
}, "Checkbox")), Eo = "CheckboxIndicator", Do = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ go(function(e, t) {
	let { __scopeCheckbox: n, forceMount: r, ...i } = e, a = xo(Eo, n);
	return /* @__PURE__ */ m(Dt, {
		present: r || jo(a.checked) || a.checked === !0,
		children: /* @__PURE__ */ m(R.span, {
			"data-state": Mo(a.checked),
			"data-disabled": a.disabled ? "" : void 0,
			...i,
			ref: t,
			style: {
				pointerEvents: "none",
				...e.style
			}
		})
	});
}, "CheckboxIndicator")), Oo = "CheckboxBubbleInput", ko = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ go(function({ __scopeCheckbox: t, onClick: n, ...r }, i) {
	let { control: a, hasConsumerStoppedPropagationRef: o, userInteractionCount: s, checked: c, defaultChecked: l, required: u, disabled: d, name: f, value: p, form: h, bubbleInput: g, setBubbleInput: _ } = xo(Oo, t), v = L(i, _), y = mo(a), b = e.useRef(!1), x = e.useRef(c), S = e.useRef(s);
	e.useEffect(() => {
		let e = g;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = s !== S.current;
		S.current = s;
		let i = x.current !== c;
		x.current = c;
		let a = !(r && o.current);
		if (i && n) {
			b.current = !r;
			let t = new Event("click", { bubbles: a });
			e.indeterminate = jo(c), n.call(e, !jo(c) && c), e.dispatchEvent(t), b.current = !1;
		}
	}, [
		g,
		c,
		o,
		s
	]);
	let C = e.useRef(!jo(c) && c);
	return /* @__PURE__ */ m(R.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: l ?? C.current,
		required: u,
		disabled: d,
		name: f,
		value: p,
		form: h,
		...r,
		tabIndex: -1,
		ref: v,
		onClick: z(n, (e) => {
			b.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...y,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "CheckboxBubbleInput"));
function Ao(e) {
	return typeof e == "function";
}
go(Ao, "isFunction");
function jo(e) {
	return e === "indeterminate";
}
go(jo, "isIndeterminate");
function Mo(e) {
	return jo(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
go(Mo, "getState");
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var No = [
	"top",
	"right",
	"bottom",
	"left"
], Po = Math.min, Fo = Math.max, Io = Math.round, Lo = Math.floor, Ro = (e) => ({
	x: e,
	y: e
}), zo = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function Bo(e, t, n) {
	return Fo(e, Po(t, n));
}
function Vo(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Ho(e) {
	return e.split("-")[0];
}
function Uo(e) {
	return e.split("-")[1];
}
function Wo(e) {
	return e === "x" ? "y" : "x";
}
function Go(e) {
	return e === "y" ? "height" : "width";
}
function Ko(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function qo(e) {
	return Wo(Ko(e));
}
function Jo(e, t, n) {
	n === void 0 && (n = !1);
	let r = Uo(e), i = qo(e), a = Go(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = rs(o)), [o, rs(o)];
}
function Yo(e) {
	let t = rs(e);
	return [
		Xo(e),
		t,
		Xo(t)
	];
}
function Xo(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var Zo = ["left", "right"], Qo = ["right", "left"], $o = ["top", "bottom"], es = ["bottom", "top"];
function ts(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Qo : Zo : t ? Zo : Qo;
		case "left":
		case "right": return t ? $o : es;
		default: return [];
	}
}
function ns(e, t, n, r) {
	let i = Uo(e), a = ts(Ho(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Xo)))), a;
}
function rs(e) {
	let t = Ho(e);
	return zo[t] + e.slice(t.length);
}
function is(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function as(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : is(e);
}
function os(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function ss(e, t, n) {
	let { reference: r, floating: i } = e, a = Ko(t), o = qo(t), s = Go(o), c = Ho(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = Uo(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function cs(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = Vo(t, e), p = as(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = os(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = os(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var ls = 50, us = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: cs
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = ss(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < ls && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = ss(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, ds = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = Vo(e, t) || {};
		if (l == null) return {};
		let d = as(u), f = {
			x: n,
			y: r
		}, p = qo(i), m = Go(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = Po(d[_], T), D = Po(d[v], T), O = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = Bo(E, k, O), j = !c.arrow && Uo(i) != null && k !== A && a.reference[m] / 2 - (k < E ? E : D) - h[m] / 2 < 0, M = j ? k < E ? k - E : k - O : 0;
		return {
			[p]: f[p] + M,
			data: {
				[p]: A,
				centerOffset: k - A - M,
				...j && { alignmentOffset: M }
			},
			reset: j
		};
	}
}), fs = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = Vo(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = Ho(r), _ = Ko(o), v = Ho(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [rs(o)] : Yo(o)), x = p !== "none";
			!d && x && b.push(...ns(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Jo(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === Ko(t) || T.every((e) => Ko(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Ko(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
};
function ps(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function ms(e) {
	return No.some((t) => e[t] >= 0);
}
var hs = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n, platform: r } = t, { strategy: i = "referenceHidden", ...a } = Vo(e, t);
			switch (i) {
				case "referenceHidden": {
					let e = ps(await r.detectOverflow(t, {
						...a,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: ms(e)
					} };
				}
				case "escaped": {
					let e = ps(await r.detectOverflow(t, {
						...a,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: ms(e)
					} };
				}
				default: return {};
			}
		}
	};
}, gs = /*#__PURE__*/ new Set(["left", "top"]);
async function _s(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Ho(n), s = Uo(n), c = Ko(n) === "y", l = gs.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = Vo(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var vs = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await _s(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, ys = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = Vo(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = Ko(i), p = Wo(f), m = u[p], h = u[f], g = (e, t) => Bo(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
}, bs = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = Vo(e, t), u = {
				x: n,
				y: r
			}, d = Ko(i), f = Wo(d), p = u[f], m = u[d], h = Vo(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: h.mainAxis ?? 0,
				crossAxis: h.crossAxis ?? 0
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = gs.has(Ho(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, xs = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = Vo(e, t), c = await i.detectOverflow(t, s), l = Ho(n), u = Uo(n), d = Ko(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c.top - c.bottom, _ = f - c.left - c.right, v = Po(p - c[m], g), y = Po(f - c[h], _), b = t.middlewareData.shift, x = !b, S = v, C = y;
			b != null && b.enabled.x && (C = _), b != null && b.enabled.y && (S = g), x && !u && (d ? C = f - 2 * Fo(c.left, c.right) : S = p - 2 * Fo(c.top, c.bottom)), await o({
				...t,
				availableWidth: C,
				availableHeight: S
			});
			let w = await i.getDimensions(a.floating);
			return f !== w.width || p !== w.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Ss() {
	return typeof window < "u";
}
function Cs(e) {
	return Es(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ws(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ts(e) {
	return ((Es(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Es(e) {
	return Ss() ? e instanceof Node || e instanceof ws(e).Node : !1;
}
function Ds(e) {
	return Ss() ? e instanceof Element || e instanceof ws(e).Element : !1;
}
function Os(e) {
	return Ss() ? e instanceof HTMLElement || e instanceof ws(e).HTMLElement : !1;
}
function ks(e) {
	return !Ss() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ws(e).ShadowRoot;
}
function As(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Vs(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function js(e) {
	return /^(table|td|th)$/.test(Cs(e));
}
function Ms(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Ns = /transform|translate|scale|rotate|perspective|filter/, Ps = /paint|layout|strict|content/, Fs = (e) => !!e && e !== "none", Is;
function Ls(e) {
	let t = Ds(e) ? Vs(e) : e;
	return Fs(t.transform) || Fs(t.translate) || Fs(t.scale) || Fs(t.rotate) || Fs(t.perspective) || !zs() && (Fs(t.backdropFilter) || Fs(t.filter)) || Ns.test(t.willChange || "") || Ps.test(t.contain || "");
}
function Rs(e) {
	let t = Us(e);
	for (; Os(t) && !Bs(t);) {
		if (Ls(t)) return t;
		if (Ms(t)) return null;
		t = Us(t);
	}
	return null;
}
function zs() {
	return Is ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), Is;
}
function Bs(e) {
	return /^(html|body|#document)$/.test(Cs(e));
}
function Vs(e) {
	return ws(e).getComputedStyle(e);
}
function Hs(e) {
	return Ds(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Us(e) {
	if (Cs(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || ks(e) && e.host || Ts(e);
	return ks(t) ? t.host : t;
}
function Ws(e) {
	let t = Us(e);
	return Bs(t) ? (e.ownerDocument || e).body : Os(t) && As(t) ? t : Ws(t);
}
function Gs(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = Ws(e), i = r === e.ownerDocument?.body, a = ws(r);
	if (i) {
		let e = Ks(a);
		return t.concat(a, a.visualViewport || [], As(r) ? r : [], e && n ? Gs(e) : []);
	}
	return t.concat(r, Gs(r, [], n));
}
function Ks(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function qs(e) {
	let t = Vs(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Os(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Io(n) !== a || Io(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function Js(e) {
	return Ds(e) ? e : e.contextElement;
}
function Ys(e) {
	let t = Js(e);
	if (!Os(t)) return Ro(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = qs(t), o = (a ? Io(n.width) : n.width) / r, s = (a ? Io(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var Xs = /*#__PURE__*/ Ro(0);
function Zs(e) {
	let t = ws(e);
	return !zs() || !t.visualViewport ? Xs : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function Qs(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === ws(e);
}
function $s(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = Js(e), o = Ro(1);
	t && (r ? Ds(r) && (o = Ys(r)) : o = Ys(e));
	let s = Qs(a, n, r) ? Zs(a) : Ro(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = ws(a), t = Ds(r) ? ws(r) : r, n = e, i = Ks(n);
		for (; i && t !== n;) {
			let e = Ys(i), t = i.getBoundingClientRect(), r = Vs(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = ws(i), i = Ks(n);
		}
	}
	return os({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function ec(e, t) {
	let n = Hs(e).scrollLeft;
	return t ? t.left + n : $s(Ts(e)).left + n;
}
function tc(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - ec(e, n),
		y: n.top + t.scrollTop
	};
}
function nc(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Ts(r), s = t ? Ms(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = Ro(1), u = Ro(0), d = Os(r);
	if ((d || !a) && ((Cs(r) !== "body" || As(o)) && (c = Hs(r)), d)) {
		let e = $s(r);
		l = Ys(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? tc(o, c) : Ro(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function rc(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function ic(e) {
	let t = Hs(e), n = e.ownerDocument.body, r = Fo(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = Fo(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + ec(e), o = -t.scrollTop;
	return Vs(n).direction === "rtl" && (a += Fo(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var ac = 25;
function oc(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = ws(e), a = Ts(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !zs() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (ec(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= ac && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function sc(e, t) {
	let n = $s(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Ys(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function cc(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = oc(e, n, t);
	else if (t === "document") r = ic(Ts(e));
	else if (Ds(t)) r = sc(t, n);
	else {
		let n = Zs(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return os(r);
}
function lc(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = Gs(e, [], !1).filter((e) => Ds(e) && Cs(e) !== "body"), i = null, a = Vs(e).position === "fixed", o = a ? Us(e) : e;
	for (; Ds(o) && !Bs(o);) {
		let e = Vs(o), t = Ls(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = Us(o);
	}
	return t.set(e, r), r;
}
function uc(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Ms(t) ? [] : lc(t, this._c) : [].concat(n), r], o = cc(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = cc(t, a[e], i);
		s = Fo(n.top, s), c = Po(n.right, c), l = Po(n.bottom, l), u = Fo(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function dc(e) {
	let { width: t, height: n } = qs(e);
	return {
		width: t,
		height: n
	};
}
function fc(e, t, n) {
	let r = Os(t), i = Ts(t), a = n === "fixed", o = $s(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = Ro(0);
	if ((r || !a) && ((Cs(t) !== "body" || As(i)) && (s = Hs(t)), r)) {
		let e = $s(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = ec(i));
	let l = i && !r && !a ? tc(i, s) : Ro(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function pc(e) {
	return Vs(e).position === "static";
}
function mc(e, t) {
	if (!Os(e) || Vs(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Ts(e) === n && (n = n.ownerDocument.body), n;
}
function hc(e, t) {
	let n = ws(e);
	if (Ms(e)) return n;
	if (!Os(e)) {
		let t = Us(e);
		for (; t && !Bs(t);) {
			if (Ds(t) && !pc(t)) return t;
			t = Us(t);
		}
		return n;
	}
	let r = mc(e, t);
	for (; r && js(r) && pc(r);) r = mc(r, t);
	return r && Bs(r) && pc(r) && !Ls(r) ? n : r || Rs(e) || n;
}
var gc = async function(e) {
	let t = this.getOffsetParent || hc, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: fc(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function _c(e) {
	return Vs(e).direction === "rtl";
}
var vc = {
	convertOffsetParentRelativeRectToViewportRelativeRect: nc,
	getDocumentElement: Ts,
	getClippingRect: uc,
	getOffsetParent: hc,
	getElementRects: gc,
	getClientRects: rc,
	getDimensions: dc,
	getScale: Ys,
	isElement: Ds,
	isRTL: _c
};
function yc(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function bc(e, t, n) {
	let r = null, i, a = Ts(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = Lo(d), h = Lo(a.clientWidth - (u + f)), g = Lo(a.clientHeight - (d + p)), _ = Lo(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: Fo(0, Po(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!yc(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = ws(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function xc(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = Js(e), u = i || a ? [...l ? Gs(l) : [], ...t ? Gs(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? bc(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? $s(e) : null;
	c && g();
	function g() {
		let t = $s(e);
		h && !yc(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Sc = vs, Cc = ys, wc = fs, Tc = xs, Ec = hs, Dc = ds, Oc = bs, kc = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...vc,
		...i.platform,
		_c: r
	};
	return us(e, t, {
		...i,
		platform: a
	});
}, Ac = typeof document < "u" ? c : function() {};
function jc(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!jc(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !jc(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function Mc(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Nc(e, t) {
	let n = Mc(e);
	return Math.round(t * n) / n;
}
function Pc(t) {
	let n = e.useRef(t);
	return Ac(() => {
		n.current = t;
	}), n;
}
function Fc(t) {
	t === void 0 && (t = {});
	let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: l, open: u } = t, [d, p] = e.useState({
		x: 0,
		y: 0,
		strategy: r,
		placement: n,
		middlewareData: {},
		isPositioned: !1
	}), [m, h] = e.useState(i);
	jc(m, i) || h(i);
	let [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = e.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = o || g, C = s || v, w = e.useRef(null), T = e.useRef(null), E = e.useRef(d), D = l != null, O = Pc(l), k = Pc(a), A = Pc(u), j = e.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: n,
			strategy: r,
			middleware: m
		};
		k.current && (e.platform = k.current), kc(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !jc(E.current, t) && (E.current = t, f.flushSync(() => {
				p(t);
			}));
		});
	}, [
		m,
		n,
		r,
		k,
		A
	]);
	Ac(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, p((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let M = e.useRef(!1);
	Ac(() => (M.current = !0, () => {
		M.current = !1;
	}), []), Ac(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (O.current) return O.current(S, C, j);
			j();
		}
	}, [
		S,
		C,
		j,
		O,
		D
	]);
	let ee = e.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), N = e.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), te = e.useMemo(() => {
		let e = {
			position: r,
			left: 0,
			top: 0
		};
		if (!N.floating) return e;
		let t = Nc(N.floating, d.x), n = Nc(N.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...Mc(N.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: r,
			left: t,
			top: n
		};
	}, [
		r,
		c,
		N.floating,
		d.x,
		d.y
	]);
	return e.useMemo(() => ({
		...d,
		update: j,
		refs: ee,
		elements: N,
		floatingStyles: te
	}), [
		d,
		j,
		ee,
		N,
		te
	]);
}
var Ic = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Dc({
				element: r.current,
				padding: i
			}).fn(n) : r ? Dc({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Lc = (e, t) => {
	let n = Sc(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Rc = (e, t) => {
	let n = Cc(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, zc = (e, t) => ({
	fn: Oc(e).fn,
	options: [e, t]
}), Bc = (e, t) => {
	let n = wc(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Vc = (e, t) => {
	let n = Tc(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Hc = (e, t) => {
	let n = Ec(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Uc = (e, t) => {
	let n = Ic(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Wc = Object.defineProperty, Gc = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => Wc(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { children: n, width: r = 10, height: i = 5, ...a } = e;
	return /* @__PURE__ */ m(R.svg, {
		...a,
		ref: t,
		width: r,
		height: i,
		viewBox: "0 0 30 10",
		preserveAspectRatio: "none",
		children: e.asChild ? n : /* @__PURE__ */ m("polygon", { points: "0,0 30,0 15,10" })
	});
}, "Arrow")), Kc = Object.defineProperty, qc = (e, t) => Kc(e, "name", {
	value: t,
	configurable: !0
}), Jc = "Popper", [Yc, Xc] = /* @__PURE__ */ Ue(Jc), [Zc, Qc] = Yc(Jc), $c = /* @__PURE__ */ qc((t) => {
	let { __scopePopper: n, children: r } = t, [i, a] = e.useState(null), [o, s] = e.useState(void 0);
	return /* @__PURE__ */ m(Zc, {
		scope: n,
		anchor: i,
		onAnchorChange: a,
		placementState: o,
		setPlacementState: s,
		children: r
	});
}, "Popper"), el = "PopperAnchor", tl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qc(function(t, n) {
	let { __scopePopper: r, virtualRef: i, ...a } = t, o = Qc(el, r), s = e.useRef(null), c = o.onAnchorChange, l = L(n, e.useCallback((e) => {
		s.current = e, e && c(e);
	}, [c])), u = e.useRef(null);
	e.useEffect(() => {
		if (!i) return;
		let e = u.current;
		u.current = i.current, e !== u.current && c(u.current);
	});
	let d = o.placementState && dl(o.placementState), f = d?.[0], p = d?.[1];
	return i ? null : /* @__PURE__ */ m(R.div, {
		"data-radix-popper-side": f,
		"data-radix-popper-align": p,
		...a,
		ref: l
	});
}, "PopperAnchor")), nl = "PopperContent", [rl, il] = Yc(nl), al = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qc(function(t, n) {
	let { __scopePopper: r, side: i = "bottom", sideOffset: a = 0, align: o = "center", alignOffset: s = 0, arrowPadding: c = 0, avoidCollisions: l = !0, collisionBoundary: u = [], collisionPadding: d = 0, sticky: f = "partial", hideWhenDetached: p = !1, updatePositionStrategy: h = "optimized", onPlaced: g, ..._ } = t, v = Qc(nl, r), [y, b] = e.useState(null), x = L(n, b), [S, C] = e.useState(null), w = mo(S), T = w?.width ?? 0, E = w?.height ?? 0, D = i + (o === "center" ? "" : "-" + o), O = typeof d == "number" ? d : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...d
	}, k = Array.isArray(u) ? u : [u], A = k.length > 0, j = {
		padding: O,
		boundary: k.filter(ll),
		altBoundary: A
	}, { refs: M, floatingStyles: ee, placement: N, isPositioned: te, middlewareData: P } = Fc({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: /* @__PURE__ */ qc((...e) => xc(...e, { animationFrame: h === "always" }), "whileElementsMounted"),
		elements: { reference: v.anchor },
		middleware: [
			Lc({
				mainAxis: a + E,
				alignmentAxis: s
			}),
			l && Rc({
				mainAxis: !0,
				crossAxis: !1,
				limiter: f === "partial" ? zc() : void 0,
				...j
			}),
			l && Bc({ ...j }),
			Vc({
				...j,
				apply: /* @__PURE__ */ qc(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			S && Uc({
				element: S,
				padding: c
			}),
			ul({
				arrowWidth: T,
				arrowHeight: E
			}),
			p && Hc({
				strategy: "referenceHidden",
				...j,
				boundary: A ? j.boundary : void 0
			})
		]
	}), ne = v.setPlacementState;
	B(() => (ne(N), () => {
		ne(void 0);
	}), [N, ne]);
	let [re, ie] = dl(N), ae = H(g);
	B(() => {
		te && ae?.();
	}, [te, ae]);
	let F = P.arrow?.x, oe = P.arrow?.y, se = P.arrow?.centerOffset !== 0, [ce, I] = e.useState();
	return B(() => {
		y && I(window.getComputedStyle(y).zIndex);
	}, [y]), /* @__PURE__ */ m("div", {
		ref: M.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...ee,
			transform: te ? ee.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: ce,
			"--radix-popper-transform-origin": [P.transformOrigin?.x, P.transformOrigin?.y].join(" "),
			...P.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: t.dir,
		children: /* @__PURE__ */ m(rl, {
			scope: r,
			placedSide: re,
			placedAlign: ie,
			onArrowChange: C,
			arrowX: F,
			arrowY: oe,
			shouldHideArrow: se,
			children: /* @__PURE__ */ m(R.div, {
				"data-side": re,
				"data-align": ie,
				..._,
				ref: x,
				style: {
					..._.style,
					animation: te ? _.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent")), ol = "PopperArrow", sl = {
	top: "bottom",
	right: "left",
	bottom: "top",
	left: "right"
}, cl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ qc(function(e, t) {
	let { __scopePopper: n, ...r } = e, i = il(ol, n), a = sl[i.placedSide];
	return /* @__PURE__ */ m("span", {
		ref: i.onArrowChange,
		style: {
			position: "absolute",
			left: i.arrowX,
			top: i.arrowY,
			[a]: 0,
			transformOrigin: {
				top: "",
				right: "0 0",
				bottom: "center 0",
				left: "100% 0"
			}[i.placedSide],
			transform: {
				top: "translateY(100%)",
				right: "translateY(50%) rotate(90deg) translateX(-50%)",
				bottom: "rotate(180deg)",
				left: "translateY(50%) rotate(-90deg) translateX(50%)"
			}[i.placedSide],
			visibility: i.shouldHideArrow ? "hidden" : void 0
		},
		children: /* @__PURE__ */ m(Gc, {
			...r,
			ref: t,
			style: {
				...r.style,
				display: "block"
			}
		})
	});
}, "PopperArrow"));
function ll(e) {
	return e !== null;
}
qc(ll, "isNotNull");
var ul = /* @__PURE__ */ qc((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = dl(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function dl(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
qc(dl, "getSideAndAlignFromPlacement");
var fl = $c, pl = tl, ml = al, hl = cl, gl = Object.defineProperty, _l = (e, t) => gl(e, "name", {
	value: t,
	configurable: !0
}), vl = !1;
function yl() {
	let [t, n] = e.useState(vl);
	return e.useEffect(() => {
		vl || (vl = !0, n(!0));
	}, []), t;
}
_l(yl, "useIsHydrated");
var bl = e.useSyncExternalStore;
function xl() {
	return () => {};
}
_l(xl, "subscribe");
function Sl() {
	return bl(xl, () => !0, () => !1);
}
_l(Sl, "useIsHydratedModern");
var Cl = typeof bl == "function" ? Sl : yl, wl = Object.defineProperty, Tl = (e, t) => wl(e, "name", {
	value: t,
	configurable: !0
}), El = "rovingFocusGroup.onEntryFocus", Dl = {
	bubbles: !1,
	cancelable: !0
}, Ol = "RovingFocusGroup", [kl, Al, jl] = /* @__PURE__ */ qe(Ol), [Ml, Nl] = /* @__PURE__ */ Ue(Ol, [jl]), [Pl, Fl] = Ml(Ol), Il = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Tl(function(e, t) {
	return /* @__PURE__ */ m(kl.Provider, {
		scope: e.__scopeRovingFocusGroup,
		children: /* @__PURE__ */ m(kl.Slot, {
			scope: e.__scopeRovingFocusGroup,
			children: /* @__PURE__ */ m(Ll, {
				...e,
				ref: t
			})
		})
	});
}, "RovingFocusGroup")), Ll = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Tl(function(t, n) {
	let { __scopeRovingFocusGroup: r, orientation: i, loop: a = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: c, onCurrentTabStopIdChange: l, onEntryFocus: u, preventScrollOnEntryFocus: d = !1, ...f } = t, p = e.useRef(null), h = L(n, p), g = rn(o), [_, v] = yt({
		prop: s,
		defaultProp: c ?? null,
		onChange: l,
		caller: Ol
	}), [y, b] = e.useState(!1), x = H(u), S = Al(r), C = e.useRef(!1), [w, T] = e.useState(0);
	return e.useEffect(() => {
		let e = p.current;
		if (e) return e.addEventListener(El, x), () => e.removeEventListener(El, x);
	}, [x]), /* @__PURE__ */ m(Pl, {
		scope: r,
		orientation: i,
		dir: g,
		loop: a,
		currentTabStopId: _,
		onItemFocus: e.useCallback((e) => v(e), [v]),
		onItemShiftTab: e.useCallback(() => b(!0), []),
		onFocusableItemAdd: e.useCallback(() => T((e) => e + 1), []),
		onFocusableItemRemove: e.useCallback(() => T((e) => e - 1), []),
		children: /* @__PURE__ */ m(R.div, {
			tabIndex: y || w === 0 ? -1 : 0,
			"data-orientation": i,
			...f,
			ref: h,
			style: {
				outline: "none",
				...t.style
			},
			onMouseDown: z(t.onMouseDown, () => {
				C.current = !0;
			}),
			onFocus: z(t.onFocus, (e) => {
				let t = !C.current;
				if (e.target === e.currentTarget && t && !y) {
					let t = new CustomEvent(El, Dl);
					if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
						let e = S().filter((e) => e.focusable);
						Ul([
							e.find((e) => e.active),
							e.find((e) => e.id === _),
							...e
						].filter(Boolean).map((e) => e.ref.current), d);
					}
				}
				C.current = !1;
			}),
			onBlur: z(t.onBlur, () => b(!1))
		})
	});
}, "RovingFocusGroupImpl")), Rl = "RovingFocusGroupItem", zl = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Tl(function(t, n) {
	let { __scopeRovingFocusGroup: r, focusable: i = !0, active: a = !1, tabStopId: o, children: s, ...c } = t, l = V(), u = o || l, d = Fl(Rl, r), f = d.currentTabStopId === u, p = Al(r), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: _ } = d, v = Cl();
	return B(() => {
		if (v && i) return h(), () => g();
	}, [
		v,
		i,
		h,
		g
	]), e.useEffect(() => {
		if (!v && i) return h(), () => g();
	}, [
		v,
		i,
		h,
		g
	]), /* @__PURE__ */ m(kl.ItemSlot, {
		scope: r,
		id: u,
		focusable: i,
		active: a,
		children: /* @__PURE__ */ m(R.span, {
			tabIndex: f ? 0 : -1,
			"data-orientation": d.orientation,
			...c,
			ref: n,
			onMouseDown: z(t.onMouseDown, (e) => {
				i ? d.onItemFocus(u) : e.preventDefault();
			}),
			onFocus: z(t.onFocus, () => d.onItemFocus(u)),
			onKeyDown: z(t.onKeyDown, (e) => {
				if (e.key === "Tab" && e.shiftKey) {
					d.onItemShiftTab();
					return;
				}
				if (e.target !== e.currentTarget) return;
				let t = Hl(e, d.orientation, d.dir);
				if (t !== void 0) {
					if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
					e.preventDefault();
					let n = p().filter((e) => e.focusable).map((e) => e.ref.current);
					if (t === "last") n.reverse();
					else if (t === "prev" || t === "next") {
						t === "prev" && n.reverse();
						let r = n.indexOf(e.currentTarget);
						n = d.loop ? Wl(n, r + 1) : n.slice(r + 1);
					}
					setTimeout(() => Ul(n));
				}
			}),
			children: typeof s == "function" ? s({
				isCurrentTabStop: f,
				hasTabStop: _ != null
			}) : s
		})
	});
}, "RovingFocusGroupItem")), Bl = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function Vl(e, t) {
	return t === "rtl" ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
Tl(Vl, "getDirectionAwareKey");
function Hl(e, t, n) {
	let r = Vl(e.key, n);
	if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return Bl[r];
}
Tl(Hl, "getFocusIntent");
function Ul(e, t = !1) {
	let n = document.activeElement;
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
Tl(Ul, "focusFirst");
function Wl(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
Tl(Wl, "wrapArray");
var Gl = Il, Kl = zl, ql = Object.defineProperty, U = (e, t) => ql(e, "name", {
	value: t,
	configurable: !0
}), Jl = ["Enter", " "], Yl = [
	"ArrowDown",
	"PageUp",
	"Home"
], Xl = [
	"ArrowUp",
	"PageDown",
	"End"
], Zl = [...Yl, ...Xl], Ql = {
	ltr: [...Jl, "ArrowRight"],
	rtl: [...Jl, "ArrowLeft"]
}, $l = {
	ltr: ["ArrowLeft"],
	rtl: ["ArrowRight"]
}, eu = "Menu", [tu, nu, ru] = /* @__PURE__ */ qe(eu), [iu, au] = /* @__PURE__ */ Ue(eu, [
	ru,
	Xc,
	Nl
]), ou = Xc(), su = Nl(), [cu, lu] = iu(eu), [uu, du] = iu(eu), fu = /* @__PURE__ */ U((t) => {
	let { __scopeMenu: n, open: r = !1, children: i, dir: a, onOpenChange: o, modal: s = !0 } = t, c = ou(n), [l, u] = e.useState(null), d = e.useRef(!1), f = H(o), p = rn(a);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ U(() => {
			d.current = !0, document.addEventListener("pointerdown", t, {
				capture: !0,
				once: !0
			}), document.addEventListener("pointermove", t, {
				capture: !0,
				once: !0
			});
		}, "handleKeyDown"), t = /* @__PURE__ */ U(() => d.current = !1, "handlePointer");
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 }), document.removeEventListener("pointerdown", t, { capture: !0 }), document.removeEventListener("pointermove", t, { capture: !0 });
		};
	}, []), e.useEffect(() => {
		if (!r) return;
		let e = /* @__PURE__ */ U(() => f(!1), "handleBlur");
		return window.addEventListener("blur", e), () => window.removeEventListener("blur", e);
	}, [r, f]), /* @__PURE__ */ m(fl, {
		...c,
		children: /* @__PURE__ */ m(cu, {
			scope: n,
			open: r,
			onOpenChange: f,
			content: l,
			onContentChange: u,
			children: /* @__PURE__ */ m(uu, {
				scope: n,
				onClose: e.useCallback(() => f(!1), [f]),
				isUsingKeyboardRef: d,
				dir: p,
				modal: s,
				children: i
			})
		})
	});
}, "Menu"), pu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { __scopeMenu: n, ...r } = e, i = ou(n);
	return /* @__PURE__ */ m(pl, {
		...i,
		...r,
		ref: t
	});
}, "MenuAnchor")), mu = "MenuPortal", [hu, gu] = iu(mu, { forceMount: void 0 }), _u = /* @__PURE__ */ U((e) => {
	let { __scopeMenu: t, forceMount: n, children: r, container: i } = e, a = lu(mu, t);
	return /* @__PURE__ */ m(hu, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ m(Dt, {
			present: n || a.open,
			children: /* @__PURE__ */ m(xr, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "MenuPortal"), vu = "MenuContent", [yu, bu] = iu(vu), xu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let n = gu(vu, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, a = lu(vu, e.__scopeMenu), o = du(vu, e.__scopeMenu);
	return /* @__PURE__ */ m(tu.Provider, {
		scope: e.__scopeMenu,
		children: /* @__PURE__ */ m(Dt, {
			present: r || a.open,
			children: /* @__PURE__ */ m(tu.Slot, {
				scope: e.__scopeMenu,
				children: o.modal ? /* @__PURE__ */ m(Su, {
					...i,
					ref: t
				}) : /* @__PURE__ */ m(Cu, {
					...i,
					ref: t
				})
			})
		})
	});
}, "MenuContent")), Su = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let r = lu(vu, t.__scopeMenu), i = e.useRef(null), a = L(n, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Gi(e);
	}, []), /* @__PURE__ */ m(Tu, {
		...t,
		ref: a,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		disableOutsideScroll: !0,
		onFocusOutside: z(t.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 }),
		onDismiss: () => r.onOpenChange(!1)
	});
}, "MenuRootContentModal")), Cu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let n = lu(vu, e.__scopeMenu);
	return /* @__PURE__ */ m(Tu, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		disableOutsideScroll: !1,
		onDismiss: () => n.onOpenChange(!1)
	});
}, "MenuRootContentNonModal")), wu = /* @__PURE__ */ ye("MenuContent.ScrollLock"), Tu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let { __scopeMenu: r, loop: i = !1, trapFocus: a, onOpenAutoFocus: o, onCloseAutoFocus: s, disableOutsidePointerEvents: c, onEntryFocus: l, onEscapeKeyDown: u, onPointerDownOutside: d, onFocusOutside: f, onInteractOutside: p, onDismiss: h, disableOutsideScroll: g, ..._ } = t, v = lu(vu, r), y = du(vu, r), b = ou(r), x = su(r), S = nu(r), [C, w] = e.useState(null), T = e.useRef(null), E = L(n, T, v.onContentChange), D = e.useRef(0), O = e.useRef(""), k = e.useRef(0), A = e.useRef(null), j = e.useRef("right"), M = e.useRef(0), ee = g ? Ii : e.Fragment, N = g ? {
		as: wu,
		allowPinchZoom: !0
	} : void 0, te = /* @__PURE__ */ U((e) => {
		let t = O.current + e, n = S().filter((e) => !e.disabled), r = document.activeElement, i = n.find((e) => e.ref.current === r)?.textValue, a = nd(n.map((e) => e.textValue), t, i), o = n.find((e) => e.textValue === a)?.ref.current;
		(/* @__PURE__ */ U((function e(t) {
			O.current = t, window.clearTimeout(D.current), t !== "" && (D.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(t), o && setTimeout(() => o.focus());
	}, "handleTypeaheadSearch");
	e.useEffect(() => () => window.clearTimeout(D.current), []), Dr();
	let P = e.useCallback((e) => j.current === A.current?.side && id(e, A.current?.area), []);
	return /* @__PURE__ */ m(yu, {
		scope: r,
		searchRef: O,
		onItemEnter: e.useCallback((e) => {
			P(e) && e.preventDefault();
		}, [P]),
		onItemLeave: e.useCallback((e) => {
			P(e) || (T.current?.focus(), w(null));
		}, [P]),
		onTriggerLeave: e.useCallback((e) => {
			P(e) && e.preventDefault();
		}, [P]),
		pointerGraceTimerRef: k,
		onPointerGraceIntentChange: e.useCallback((e) => {
			A.current = e;
		}, []),
		children: /* @__PURE__ */ m(ee, {
			...N,
			children: /* @__PURE__ */ m(cr, {
				asChild: !0,
				trapped: a,
				onMountAutoFocus: z(o, (e) => {
					e.preventDefault(), T.current?.focus({ preventScroll: !0 });
				}),
				onUnmountAutoFocus: s,
				children: /* @__PURE__ */ m(Xn, {
					asChild: !0,
					disableOutsidePointerEvents: c,
					onEscapeKeyDown: u,
					onPointerDownOutside: d,
					onFocusOutside: f,
					onInteractOutside: p,
					onDismiss: h,
					children: /* @__PURE__ */ m(Gl, {
						asChild: !0,
						...x,
						dir: y.dir,
						orientation: "vertical",
						loop: i,
						currentTabStopId: C,
						onCurrentTabStopIdChange: w,
						onEntryFocus: z(l, (e) => {
							y.isUsingKeyboardRef.current || e.preventDefault();
						}),
						preventScrollOnEntryFocus: !0,
						children: /* @__PURE__ */ m(ml, {
							role: "menu",
							"aria-orientation": "vertical",
							"data-state": Zu(v.open),
							"data-radix-menu-content": "",
							dir: y.dir,
							...b,
							..._,
							ref: E,
							style: {
								outline: "none",
								..._.style
							},
							onKeyDown: z(_.onKeyDown, (e) => {
								let t = e.target.closest("[data-radix-menu-content]") === e.currentTarget, n = e.ctrlKey || e.altKey || e.metaKey, r = e.key.length === 1;
								t && (e.key === "Tab" && e.preventDefault(), !n && r && te(e.key));
								let i = T.current;
								if (e.target !== i || !Zl.includes(e.key)) return;
								e.preventDefault();
								let a = S().filter((e) => !e.disabled).map((e) => e.ref.current);
								Xl.includes(e.key) && a.reverse(), ed(a);
							}),
							onBlur: z(t.onBlur, (e) => {
								e.currentTarget.contains(e.target) || (window.clearTimeout(D.current), O.current = "");
							}),
							onPointerMove: z(t.onPointerMove, ad((e) => {
								let t = e.target, n = M.current !== e.clientX;
								if (e.currentTarget.contains(t) && n) {
									let t = e.clientX > M.current ? "right" : "left";
									j.current = t, M.current = e.clientX;
								}
							}))
						})
					})
				})
			})
		})
	});
}, "MenuContentImpl")), Eu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ m(R.div, {
		role: "group",
		...r,
		ref: t
	});
}, "MenuGroup")), Du = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ m(R.div, {
		...r,
		ref: t
	});
}, "MenuLabel")), Ou = "MenuItem", ku = "menu.itemSelect", Au = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let { disabled: r = !1, onSelect: i, ...a } = t, o = e.useRef(null), s = du(Ou, t.__scopeMenu), c = bu(Ou, t.__scopeMenu), l = L(n, o), u = e.useRef(!1), d = /* @__PURE__ */ U(() => {
		let e = o.current;
		if (!r && e) {
			let t = new CustomEvent(ku, {
				bubbles: !0,
				cancelable: !0
			});
			e.addEventListener(ku, (e) => i?.(e), { once: !0 }), Fe(e, t), t.defaultPrevented ? u.current = !1 : s.onClose();
		}
	}, "handleSelect");
	return /* @__PURE__ */ m(ju, {
		...a,
		ref: l,
		disabled: r,
		onClick: z(t.onClick, d),
		onPointerDown: (e) => {
			t.onPointerDown?.(e), u.current = !0;
		},
		onPointerUp: z(t.onPointerUp, (e) => {
			u.current || e.currentTarget?.click();
		}),
		onKeyDown: z(t.onKeyDown, (e) => {
			r || e.target !== e.currentTarget || (c.searchRef.current === "" || e.key !== " ") && Jl.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
		})
	});
}, "MenuItem")), ju = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let { __scopeMenu: r, disabled: i = !1, textValue: a, ...o } = t, s = bu(Ou, r), c = su(r), l = e.useRef(null), u = L(n, l), [d, f] = e.useState(!1), [p, h] = e.useState("");
	return e.useEffect(() => {
		let e = l.current;
		e && h((e.textContent ?? "").trim());
	}, [o.children]), /* @__PURE__ */ m(tu.ItemSlot, {
		scope: r,
		disabled: i,
		textValue: a ?? p,
		children: /* @__PURE__ */ m(Kl, {
			asChild: !0,
			...c,
			focusable: !i,
			children: /* @__PURE__ */ m(R.div, {
				role: "menuitem",
				"data-highlighted": d ? "" : void 0,
				"aria-disabled": i || void 0,
				"data-disabled": i ? "" : void 0,
				...o,
				ref: u,
				onPointerMove: z(t.onPointerMove, ad((e) => {
					i ? s.onItemLeave(e) : (s.onItemEnter(e), e.defaultPrevented || e.currentTarget.focus({ preventScroll: !0 }));
				})),
				onPointerLeave: z(t.onPointerLeave, ad((e) => s.onItemLeave(e))),
				onFocus: z(t.onFocus, () => f(!0)),
				onBlur: z(t.onBlur, () => f(!1))
			})
		})
	});
}, "MenuItemImpl")), Mu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { checked: n = !1, onCheckedChange: r, ...i } = e;
	return /* @__PURE__ */ m(zu, {
		scope: e.__scopeMenu,
		checked: n,
		children: /* @__PURE__ */ m(Au, {
			role: "menuitemcheckbox",
			"aria-checked": Qu(n) ? "mixed" : n,
			...i,
			ref: t,
			"data-state": $u(n),
			onSelect: z(i.onSelect, () => r?.(Qu(n) ? !0 : !n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuCheckboxItem")), [Nu, Pu] = iu("MenuRadioGroup", {
	value: void 0,
	onValueChange: /* @__PURE__ */ U(() => {}, "onValueChange")
}), Fu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { value: n, onValueChange: r, ...i } = e, a = H(r);
	return /* @__PURE__ */ m(Nu, {
		scope: e.__scopeMenu,
		value: n,
		onValueChange: a,
		children: /* @__PURE__ */ m(Eu, {
			...i,
			ref: t
		})
	});
}, "MenuRadioGroup")), Iu = "MenuRadioItem", Lu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { value: n, ...r } = e, i = Pu(Iu, e.__scopeMenu), a = n === i.value;
	return /* @__PURE__ */ m(zu, {
		scope: e.__scopeMenu,
		checked: a,
		children: /* @__PURE__ */ m(Au, {
			role: "menuitemradio",
			"aria-checked": a,
			...r,
			ref: t,
			"data-state": $u(a),
			onSelect: z(r.onSelect, () => i.onValueChange?.(n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuRadioItem")), Ru = "MenuItemIndicator", [zu, Bu] = iu(Ru, { checked: !1 }), Vu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { __scopeMenu: n, forceMount: r, ...i } = e, a = Bu(Ru, n);
	return /* @__PURE__ */ m(Dt, {
		present: r || Qu(a.checked) || a.checked === !0,
		children: /* @__PURE__ */ m(R.span, {
			...i,
			ref: t,
			"data-state": $u(a.checked)
		})
	});
}, "MenuItemIndicator")), Hu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ m(R.div, {
		role: "separator",
		"aria-orientation": "horizontal",
		...r,
		ref: t
	});
}, "MenuSeparator")), Uu = "MenuSub", [Wu, Gu] = iu(Uu), Ku = /* @__PURE__ */ U((t) => {
	let { __scopeMenu: n, children: r, open: i = !1, onOpenChange: a } = t, o = lu(Uu, n), s = ou(n), [c, l] = e.useState(null), [u, d] = e.useState(null), f = H(a);
	return e.useEffect(() => (o.open === !1 && f(!1), () => f(!1)), [o.open, f]), /* @__PURE__ */ m(fl, {
		...s,
		children: /* @__PURE__ */ m(cu, {
			scope: n,
			open: i,
			onOpenChange: f,
			content: u,
			onContentChange: d,
			children: /* @__PURE__ */ m(Wu, {
				scope: n,
				contentId: V(),
				triggerId: V(),
				trigger: c,
				onTriggerChange: l,
				children: r
			})
		})
	});
}, "MenuSub"), qu = "MenuSubTrigger", Ju = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let r = lu(qu, t.__scopeMenu), i = du(qu, t.__scopeMenu), a = Gu(qu, t.__scopeMenu), o = bu(qu, t.__scopeMenu), s = e.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: l } = o, u = { __scopeMenu: t.__scopeMenu }, d = e.useCallback(() => {
		s.current && window.clearTimeout(s.current), s.current = null;
	}, []);
	e.useEffect(() => d, [d]), e.useEffect(() => {
		let e = c.current;
		return () => {
			window.clearTimeout(e), l(null);
		};
	}, [c, l]);
	let f = L(n, a.onTriggerChange);
	return /* @__PURE__ */ m(pu, {
		asChild: !0,
		...u,
		children: /* @__PURE__ */ m(ju, {
			id: a.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": r.open,
			"aria-controls": r.open ? a.contentId : void 0,
			"data-state": Zu(r.open),
			...t,
			ref: f,
			onClick: (e) => {
				t.onClick?.(e), !(t.disabled || e.defaultPrevented) && (e.currentTarget.focus(), r.open || r.onOpenChange(!0));
			},
			onPointerMove: z(t.onPointerMove, ad((e) => {
				o.onItemEnter(e), !e.defaultPrevented && !t.disabled && !r.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
					r.onOpenChange(!0), d();
				}, 100));
			})),
			onPointerLeave: z(t.onPointerLeave, ad((e) => {
				d();
				let t = r.content?.getBoundingClientRect();
				if (t) {
					let n = r.content?.dataset.side, i = n === "right", a = i ? -5 : 5, s = t[i ? "left" : "right"], l = t[i ? "right" : "left"];
					o.onPointerGraceIntentChange({
						area: [
							{
								x: e.clientX + a,
								y: e.clientY
							},
							{
								x: s,
								y: t.top
							},
							{
								x: l,
								y: t.top
							},
							{
								x: l,
								y: t.bottom
							},
							{
								x: s,
								y: t.bottom
							}
						],
						side: n
					}), window.clearTimeout(c.current), c.current = window.setTimeout(() => o.onPointerGraceIntentChange(null), 300);
				} else {
					if (o.onTriggerLeave(e), e.defaultPrevented) return;
					o.onPointerGraceIntentChange(null);
				}
			})),
			onKeyDown: z(t.onKeyDown, (e) => {
				t.disabled || e.target !== e.currentTarget || (o.searchRef.current === "" || e.key !== " ") && Ql[i.dir].includes(e.key) && (r.onOpenChange(!0), r.content?.focus(), e.preventDefault());
			})
		})
	});
}, "MenuSubTrigger")), Yu = "MenuSubContent", Xu = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ U(function(t, n) {
	let r = gu(vu, t.__scopeMenu), { forceMount: i = r.forceMount, align: a = "start", ...o } = t, s = lu(vu, t.__scopeMenu), c = du(vu, t.__scopeMenu), l = Gu(Yu, t.__scopeMenu), u = e.useRef(null), d = L(n, u);
	return /* @__PURE__ */ m(tu.Provider, {
		scope: t.__scopeMenu,
		children: /* @__PURE__ */ m(Dt, {
			present: i || s.open,
			children: /* @__PURE__ */ m(tu.Slot, {
				scope: t.__scopeMenu,
				children: /* @__PURE__ */ m(Tu, {
					id: l.contentId,
					"aria-labelledby": l.triggerId,
					...o,
					ref: d,
					align: a,
					side: c.dir === "rtl" ? "left" : "right",
					disableOutsidePointerEvents: !1,
					disableOutsideScroll: !1,
					trapFocus: !1,
					onOpenAutoFocus: (e) => {
						c.isUsingKeyboardRef.current && u.current?.focus(), e.preventDefault();
					},
					onCloseAutoFocus: (e) => e.preventDefault(),
					onFocusOutside: z(t.onFocusOutside, (e) => {
						e.target !== l.trigger && s.onOpenChange(!1);
					}),
					onEscapeKeyDown: z(t.onEscapeKeyDown, (e) => {
						c.onClose(), e.preventDefault();
					}),
					onKeyDown: z(t.onKeyDown, (e) => {
						let t = e.currentTarget.contains(e.target), n = $l[c.dir].includes(e.key);
						t && n && (s.onOpenChange(!1), l.trigger?.focus(), e.preventDefault());
					})
				})
			})
		})
	});
}, "MenuSubContent"));
function Zu(e) {
	return e ? "open" : "closed";
}
U(Zu, "getOpenState");
function Qu(e) {
	return e === "indeterminate";
}
U(Qu, "isIndeterminate");
function $u(e) {
	return Qu(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
U($u, "getCheckedState");
function ed(e) {
	let t = document.activeElement;
	for (let n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
U(ed, "focusFirst");
function td(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
U(td, "wrapArray");
function nd(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = td(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
U(nd, "getNextMatch");
function rd(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
U(rd, "isPointInPolygon");
function id(e, t) {
	return t ? rd({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
U(id, "isPointerInGraceArea");
function ad(e) {
	return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
U(ad, "whenMouse");
var od = fu, sd = pu, cd = _u, ld = xu, ud = Eu, dd = Du, fd = Au, pd = Mu, md = Fu, hd = Lu, gd = Vu, _d = Hu, vd = Ku, yd = Ju, bd = Xu, xd = Object.defineProperty, Sd = (e, t) => xd(e, "name", {
	value: t,
	configurable: !0
}), Cd = "DropdownMenu", [wd, Td] = /* @__PURE__ */ Ue(Cd, [au]), Ed = au(), [Dd, Od] = wd(Cd), kd = /* @__PURE__ */ Sd((t) => {
	let { __scopeDropdownMenu: n, children: r, dir: i, open: a, defaultOpen: o, onOpenChange: s, modal: c = !0 } = t, l = Ed(n), u = e.useRef(null), [d, f] = yt({
		prop: a,
		defaultProp: o ?? !1,
		onChange: s,
		caller: Cd
	});
	return /* @__PURE__ */ m(Dd, {
		scope: n,
		triggerId: V(),
		triggerRef: u,
		contentId: V(),
		open: d,
		onOpenChange: f,
		onOpenToggle: e.useCallback(() => f((e) => !e), [f]),
		modal: c,
		children: /* @__PURE__ */ m(od, {
			...l,
			open: d,
			onOpenChange: f,
			dir: i,
			modal: c,
			children: r
		})
	});
}, "DropdownMenu"), Ad = "DropdownMenuTrigger", jd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, a = Od(Ad, n), o = Ed(n), s = L(t, a.triggerRef);
	return /* @__PURE__ */ m(sd, {
		asChild: !0,
		...o,
		children: /* @__PURE__ */ m(R.button, {
			type: "button",
			id: a.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": a.open,
			"aria-controls": a.open ? a.contentId : void 0,
			"data-state": a.open ? "open" : "closed",
			"data-disabled": r ? "" : void 0,
			disabled: r,
			...i,
			ref: s,
			onPointerDown: z(e.onPointerDown, (e) => {
				!r && e.button === 0 && e.ctrlKey === !1 && (a.onOpenToggle(), a.open || e.preventDefault());
			}),
			onKeyDown: z(e.onKeyDown, (e) => {
				r || (["Enter", " "].includes(e.key) && a.onOpenToggle(), e.key === "ArrowDown" && a.onOpenChange(!0), [
					"Enter",
					" ",
					"ArrowDown"
				].includes(e.key) && e.preventDefault());
			})
		})
	});
}, "DropdownMenuTrigger")), Md = /* @__PURE__ */ Sd((e) => {
	let { __scopeDropdownMenu: t, ...n } = e, r = Ed(t);
	return /* @__PURE__ */ m(cd, {
		...r,
		...n
	});
}, "DropdownMenuPortal"), Nd = "DropdownMenuContent", Pd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(t, n) {
	let { __scopeDropdownMenu: r, ...i } = t, a = Od(Nd, r), o = Ed(r), s = e.useRef(!1);
	return /* @__PURE__ */ m(ld, {
		id: a.contentId,
		"aria-labelledby": a.triggerId,
		...o,
		...i,
		ref: n,
		onCloseAutoFocus: z(t.onCloseAutoFocus, (e) => {
			s.current || a.triggerRef.current?.focus(), s.current = !1, e.preventDefault();
		}),
		onInteractOutside: z(t.onInteractOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
			(!a.modal || r) && (s.current = !0);
		}),
		style: {
			...t.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuContent")), Fd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(ud, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuGroup")), Id = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(dd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuLabel")), Ld = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(fd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuItem")), Rd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(pd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuCheckboxItem")), zd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(md, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuRadioGroup")), Bd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(hd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuRadioItem")), Vd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(gd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuItemIndicator")), Hd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(_d, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuSeparator")), Ud = /* @__PURE__ */ Sd((e) => {
	let { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: i, defaultOpen: a } = e, o = Ed(t), [s, c] = yt({
		prop: r,
		defaultProp: a ?? !1,
		onChange: i,
		caller: "DropdownMenuSub"
	});
	return /* @__PURE__ */ m(vd, {
		...o,
		open: s,
		onOpenChange: c,
		children: n
	});
}, "DropdownMenuSub"), Wd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(yd, {
		...i,
		...r,
		ref: t
	});
}, "DropdownMenuSubTrigger")), Gd = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Sd(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e, i = Ed(n);
	return /* @__PURE__ */ m(bd, {
		...i,
		...r,
		ref: t,
		style: {
			...e.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuSubContent")), Kd = kd, qd = jd, Jd = Md, Yd = Pd, Xd = Fd, Zd = Id, Qd = Ld, $d = Rd, ef = zd, tf = Bd, nf = Vd, rf = Hd, af = Ud, of = Wd, sf = Gd, cf = Object.defineProperty, lf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => cf(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	return /* @__PURE__ */ m(R.label, {
		...e,
		ref: t,
		onMouseDown: (t) => {
			t.target.closest("button, input, select, textarea") || (e.onMouseDown?.(t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
		}
	});
}, "Label")), uf = Object.defineProperty, df = (e, t) => uf(e, "name", {
	value: t,
	configurable: !0
});
function ff(t) {
	let n = e.useRef({
		value: t,
		previous: t
	});
	return e.useMemo(() => (n.current.value !== t && (n.current.previous = n.current.value, n.current.value = t), n.current.previous), [t]);
}
df(ff, "usePrevious");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+number@1.1.3/node_modules/@radix-ui/number/dist/index.mjs
var pf = Object.defineProperty, mf = (e, t) => pf(e, "name", {
	value: t,
	configurable: !0
});
function hf(e, [t, n]) {
	return Math.min(n, Math.max(t, e));
}
mf(hf, "clamp");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-popover@1.1.23_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3_s25yfztiraxytn7osjhm3itvpe/node_modules/@radix-ui/react-popover/dist/index.mjs
var gf = Object.defineProperty, _f = (e, t) => gf(e, "name", {
	value: t,
	configurable: !0
}), vf = "Popover", [yf, bf] = /* @__PURE__ */ Ue(vf, [Xc]), xf = Xc(), [Sf, Cf] = yf(vf), wf = /* @__PURE__ */ _f((t) => {
	let { __scopePopover: n, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: s = !1 } = t, c = xf(n), l = e.useRef(null), [u, d] = e.useState(!1), [f, p] = yt({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: vf
	});
	return /* @__PURE__ */ m(fl, {
		...c,
		children: /* @__PURE__ */ m(Sf, {
			scope: n,
			contentId: V(),
			triggerRef: l,
			open: f,
			onOpenChange: p,
			onOpenToggle: e.useCallback(() => p((e) => !e), [p]),
			hasCustomAnchor: u,
			onCustomAnchorAdd: e.useCallback(() => d(!0), []),
			onCustomAnchorRemove: e.useCallback(() => d(!1), []),
			modal: s,
			children: r
		})
	});
}, "Popover"), Tf = "PopoverTrigger", Ef = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ _f(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = Cf(Tf, n), a = xf(n), o = L(t, i.triggerRef), s = /* @__PURE__ */ m(R.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": Lf(i.open),
		...r,
		ref: o,
		onClick: z(e.onClick, i.onOpenToggle)
	});
	return i.hasCustomAnchor ? s : /* @__PURE__ */ m(pl, {
		asChild: !0,
		...a,
		children: s
	});
}, "PopoverTrigger")), Df = "PopoverPortal", [Of, kf] = yf(Df, { forceMount: void 0 }), Af = /* @__PURE__ */ _f((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = Cf(Df, t);
	return /* @__PURE__ */ m(Of, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ m(Dt, {
			present: n || a.open,
			children: /* @__PURE__ */ m(xr, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), jf = "PopoverContent", Mf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ _f(function(e, t) {
	let n = kf(jf, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = Cf(jf, e.__scopePopover);
	return /* @__PURE__ */ m(Dt, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ m(Pf, {
			...i,
			ref: t
		}) : /* @__PURE__ */ m(Ff, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), Nf = /* @__PURE__ */ ye("PopoverContent.RemoveScroll"), Pf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ _f(function(t, n) {
	let r = Cf(jf, t.__scopePopover), i = e.useRef(null), a = L(n, i), o = e.useRef(!1);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Gi(e);
	}, []), /* @__PURE__ */ m(Ii, {
		as: Nf,
		allowPinchZoom: !0,
		children: /* @__PURE__ */ m(If, {
			...t,
			ref: a,
			trapFocus: r.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: z(t.onCloseAutoFocus, (e) => {
				e.preventDefault(), o.current || r.triggerRef.current?.focus();
			}),
			onPointerDownOutside: z(t.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				o.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: z(t.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), Ff = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ _f(function(t, n) {
	let r = Cf(jf, t.__scopePopover), i = e.useRef(!1), a = e.useRef(!1);
	return /* @__PURE__ */ m(If, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && a.current && e.preventDefault();
		}
	});
}, "PopoverContentNonModal")), If = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ _f(function(e, t) {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = Cf(jf, n), p = xf(n);
	return Dr(), /* @__PURE__ */ m(cr, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ m(Xn, {
			asChild: !0,
			disableOutsidePointerEvents: o,
			onInteractOutside: u,
			onEscapeKeyDown: s,
			onPointerDownOutside: c,
			onFocusOutside: l,
			onDismiss: () => f.onOpenChange(!1),
			deferPointerDownOutside: !0,
			children: /* @__PURE__ */ m(ml, {
				"data-state": Lf(f.open),
				role: "dialog",
				id: f.contentId,
				...p,
				...d,
				ref: t,
				style: {
					...d.style,
					"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
					"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
					"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
					"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
					"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
				}
			})
		})
	});
}, "PopoverContentImpl"));
function Lf(e) {
	return e ? "open" : "closed";
}
_f(Lf, "getState");
var Rf = wf, zf = Ef, Bf = Af, Vf = Mf, Hf = Object.defineProperty, Uf = (e, t) => Hf(e, "name", {
	value: t,
	configurable: !0
}), Wf = "Progress", Gf = 100, [Kf, qf] = /* @__PURE__ */ Ue(Wf), [Jf, Yf] = Kf(Wf), Xf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Uf(function(e, t) {
	let { __scopeProgress: n, value: r = null, max: i, getValueLabel: a = $f, ...o } = e;
	(i || i === 0) && !np(i) && console.error(ip(`${i}`, "Progress"));
	let s = np(i) ? i : Gf;
	r !== null && !rp(r, s) && console.error(ap(`${r}`, "Progress"));
	let c = rp(r, s) ? r : null, l = tp(c) ? a(c, s) : void 0;
	return /* @__PURE__ */ m(Jf, {
		scope: n,
		value: c,
		max: s,
		children: /* @__PURE__ */ m(R.div, {
			"aria-valuemax": s,
			"aria-valuemin": 0,
			"aria-valuenow": tp(c) ? c : void 0,
			"aria-valuetext": l,
			role: "progressbar",
			"data-state": ep(c, s),
			"data-value": c ?? void 0,
			"data-max": s,
			...o,
			ref: t
		})
	});
}, "Progress")), Zf = "ProgressIndicator", Qf = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Uf(function(e, t) {
	let { __scopeProgress: n, ...r } = e, i = Yf(Zf, n);
	return /* @__PURE__ */ m(R.div, {
		"data-state": ep(i.value, i.max),
		"data-value": i.value ?? void 0,
		"data-max": i.max,
		...r,
		ref: t
	});
}, "ProgressIndicator"));
function $f(e, t) {
	return `${Math.round(e / t * 100)}%`;
}
Uf($f, "defaultGetValueLabel");
function ep(e, t) {
	return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
Uf(ep, "getProgressState");
function tp(e) {
	return typeof e == "number";
}
Uf(tp, "isNumber");
function np(e) {
	return tp(e) && !isNaN(e) && e > 0;
}
Uf(np, "isValidMaxNumber");
function rp(e, t) {
	return tp(e) && !isNaN(e) && e <= t && e >= 0;
}
Uf(rp, "isValidValueNumber");
function ip(e, t) {
	return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Gf}\`.`;
}
Uf(ip, "getInvalidMaxError");
function ap(e, t) {
	return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Gf} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
Uf(ap, "getInvalidValueError");
var op = Xf, sp = Qf, cp = Object.defineProperty, W = (e, t) => cp(e, "name", {
	value: t,
	configurable: !0
});
function lp(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
W(lp, "useStateMachine");
var up = "ScrollArea", [dp, fp] = /* @__PURE__ */ Ue(up), [pp, mp] = dp(up), hp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { __scopeScrollArea: r, type: i = "hover", dir: a, scrollHideDelay: o = 600, ...s } = t, [c, l] = e.useState(null), [u, d] = e.useState(null), [f, p] = e.useState(null), [h, g] = e.useState(null), [_, v] = e.useState(null), [y, b] = e.useState(0), [x, S] = e.useState(0), [C, w] = e.useState(!1), [T, E] = e.useState(!1), D = L(n, l), O = rn(a);
	return /* @__PURE__ */ m(pp, {
		scope: r,
		type: i,
		dir: O,
		scrollHideDelay: o,
		scrollArea: c,
		viewport: u,
		onViewportChange: d,
		content: f,
		onContentChange: p,
		scrollbarX: h,
		onScrollbarXChange: g,
		scrollbarXEnabled: C,
		onScrollbarXEnabledChange: w,
		scrollbarY: _,
		onScrollbarYChange: v,
		scrollbarYEnabled: T,
		onScrollbarYEnabledChange: E,
		onCornerWidthChange: b,
		onCornerHeightChange: S,
		children: /* @__PURE__ */ m(R.div, {
			dir: O,
			...s,
			ref: D,
			style: {
				position: "relative",
				"--radix-scroll-area-corner-width": y + "px",
				"--radix-scroll-area-corner-height": x + "px",
				...t.style
			}
		})
	});
}, "ScrollArea")), gp = "ScrollAreaViewport", _p = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { __scopeScrollArea: r, children: i, nonce: a, ...o } = t, s = mp(gp, r), c = L(n, e.useRef(null), s.onViewportChange);
	return /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(vp, { nonce: a }), /* @__PURE__ */ m(R.div, {
		"data-radix-scroll-area-viewport": "",
		...o,
		ref: c,
		style: {
			overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
			overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
			...t.style
		},
		children: /* @__PURE__ */ m("div", {
			ref: s.onContentChange,
			style: {
				minWidth: "100%",
				display: "table"
			},
			children: i
		})
	})] });
}, "ScrollAreaViewport")), vp = /* @__PURE__ */ e.memo(/* @__PURE__ */ W(function({ nonce: e }) {
	return /* @__PURE__ */ m("style", {
		dangerouslySetInnerHTML: { __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}" },
		nonce: e
	});
}, "ScrollAreaViewportStyle"), (e, t) => e.nonce === t.nonce), yp = "ScrollAreaScrollbar", bp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { forceMount: r, ...i } = t, a = mp(yp, t.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: s } = a, c = t.orientation === "horizontal";
	return e.useEffect(() => (c ? o(!0) : s(!0), () => {
		c ? o(!1) : s(!1);
	}), [
		c,
		o,
		s
	]), a.type === "hover" ? /* @__PURE__ */ m(xp, {
		...i,
		ref: n,
		forceMount: r
	}) : a.type === "scroll" ? /* @__PURE__ */ m(Sp, {
		...i,
		ref: n,
		forceMount: r
	}) : a.type === "auto" ? /* @__PURE__ */ m(Cp, {
		...i,
		ref: n,
		forceMount: r
	}) : a.type === "always" ? /* @__PURE__ */ m(wp, {
		...i,
		ref: n,
		"data-state": "visible"
	}) : null;
}, "ScrollAreaScrollbar")), xp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { forceMount: r, ...i } = t, a = mp(yp, t.__scopeScrollArea), [o, s] = e.useState(!1);
	return e.useEffect(() => {
		let e = a.scrollArea, t = 0;
		if (e) {
			let n = /* @__PURE__ */ W(() => {
				window.clearTimeout(t), s(!0);
			}, "handlePointerEnter"), r = /* @__PURE__ */ W(() => {
				t = window.setTimeout(() => s(!1), a.scrollHideDelay);
			}, "handlePointerLeave");
			return e.addEventListener("pointerenter", n), e.addEventListener("pointerleave", r), () => {
				window.clearTimeout(t), e.removeEventListener("pointerenter", n), e.removeEventListener("pointerleave", r);
			};
		}
	}, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ m(Dt, {
		present: r || o,
		children: /* @__PURE__ */ m(Cp, {
			"data-state": o ? "visible" : "hidden",
			...i,
			ref: n
		})
	});
}, "ScrollAreaScrollbarHover")), Sp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { forceMount: r, ...i } = t, a = mp(yp, t.__scopeScrollArea), o = t.orientation === "horizontal", s = Wp(() => l("SCROLL_END"), 100), [c, l] = lp("hidden", {
		hidden: { SCROLL: "scrolling" },
		scrolling: {
			SCROLL_END: "idle",
			POINTER_ENTER: "interacting"
		},
		interacting: {
			SCROLL: "interacting",
			POINTER_LEAVE: "idle"
		},
		idle: {
			HIDE: "hidden",
			SCROLL: "scrolling",
			POINTER_ENTER: "interacting"
		}
	});
	return e.useEffect(() => {
		if (c === "idle") {
			let e = window.setTimeout(() => l("HIDE"), a.scrollHideDelay);
			return () => window.clearTimeout(e);
		}
	}, [
		c,
		a.scrollHideDelay,
		l
	]), e.useEffect(() => {
		let e = a.viewport, t = o ? "scrollLeft" : "scrollTop";
		if (e) {
			let n = e[t], r = /* @__PURE__ */ W(() => {
				let r = e[t];
				n !== r && (l("SCROLL"), s()), n = r;
			}, "handleScroll");
			return e.addEventListener("scroll", r), () => e.removeEventListener("scroll", r);
		}
	}, [
		a.viewport,
		o,
		l,
		s
	]), /* @__PURE__ */ m(Dt, {
		present: r || c !== "hidden",
		children: /* @__PURE__ */ m(wp, {
			"data-state": c === "hidden" ? "hidden" : "visible",
			...i,
			ref: n,
			onPointerEnter: z(t.onPointerEnter, () => l("POINTER_ENTER")),
			onPointerLeave: z(t.onPointerLeave, () => l("POINTER_LEAVE"))
		})
	});
}, "ScrollAreaScrollbarScroll")), Cp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let r = mp(yp, t.__scopeScrollArea), { forceMount: i, ...a } = t, [o, s] = e.useState(!1), c = t.orientation === "horizontal", l = Wp(() => {
		if (r.viewport) {
			let e = r.viewport.offsetWidth < r.viewport.scrollWidth, t = r.viewport.offsetHeight < r.viewport.scrollHeight;
			s(c ? e : t);
		}
	}, 10);
	return Gp(r.viewport, l), Gp(r.content, l), /* @__PURE__ */ m(Dt, {
		present: i || o,
		children: /* @__PURE__ */ m(wp, {
			"data-state": o ? "visible" : "hidden",
			...a,
			ref: n
		})
	});
}, "ScrollAreaScrollbarAuto")), wp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { orientation: r = "vertical", ...i } = t, a = mp(yp, t.__scopeScrollArea), o = e.useRef(null), s = e.useRef(0), [c, l] = e.useState({
		content: 0,
		viewport: 0,
		scrollbar: {
			size: 0,
			paddingStart: 0,
			paddingEnd: 0
		}
	}), u = Lp(c.viewport, c.content), d = {
		...i,
		sizes: c,
		onSizesChange: l,
		hasThumb: u > 0 && u < 1,
		onThumbChange: /* @__PURE__ */ W((e) => o.current = e, "onThumbChange"),
		onThumbPointerUp: /* @__PURE__ */ W(() => s.current = 0, "onThumbPointerUp"),
		onThumbPointerDown: /* @__PURE__ */ W((e) => s.current = e, "onThumbPointerDown")
	};
	function f(e, t) {
		return zp(e, s.current, c, t);
	}
	return W(f, "getScrollPosition"), r === "horizontal" ? /* @__PURE__ */ m(Tp, {
		...d,
		ref: n,
		onThumbPositionChange: () => {
			if (a.viewport && o.current) {
				let e = a.viewport.scrollLeft, t = Bp(e, c, a.dir);
				o.current.style.transform = `translate3d(${t}px, 0, 0)`;
			}
		},
		onWheelScroll: (e) => {
			a.viewport && (a.viewport.scrollLeft = e);
		},
		onDragScroll: (e) => {
			a.viewport && (a.viewport.scrollLeft = f(e, a.dir));
		}
	}) : r === "vertical" ? /* @__PURE__ */ m(Ep, {
		...d,
		ref: n,
		onThumbPositionChange: () => {
			if (a.viewport && o.current) {
				let e = a.viewport.scrollTop, t = Bp(e, c);
				o.current.style.transform = `translate3d(0, ${t}px, 0)`;
			}
		},
		onWheelScroll: (e) => {
			a.viewport && (a.viewport.scrollTop = e);
		},
		onDragScroll: (e) => {
			a.viewport && (a.viewport.scrollTop = f(e));
		}
	}) : null;
}, "ScrollAreaScrollbarVisible")), Tp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { sizes: r, onSizesChange: i, ...a } = t, o = mp(yp, t.__scopeScrollArea), [s, c] = e.useState(), l = e.useRef(null), u = L(n, l, o.onScrollbarXChange);
	return e.useEffect(() => {
		l.current && c(getComputedStyle(l.current));
	}, [l]), /* @__PURE__ */ m(kp, {
		"data-orientation": "horizontal",
		...a,
		ref: u,
		sizes: r,
		style: {
			bottom: 0,
			left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
			right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
			"--radix-scroll-area-thumb-width": Rp(r) + "px",
			...t.style
		},
		onThumbPointerDown: (e) => t.onThumbPointerDown(e.x),
		onDragScroll: (e) => t.onDragScroll(e.x),
		onWheelScroll: (e, n) => {
			if (o.viewport) {
				let r = o.viewport.scrollLeft + e.deltaX;
				t.onWheelScroll(r), Hp(r, n) && e.preventDefault();
			}
		},
		onResize: () => {
			l.current && o.viewport && s && i({
				content: o.viewport.scrollWidth,
				viewport: o.viewport.offsetWidth,
				scrollbar: {
					size: l.current.clientWidth,
					paddingStart: Ip(s.paddingLeft),
					paddingEnd: Ip(s.paddingRight)
				}
			});
		}
	});
}, "ScrollAreaScrollbarX")), Ep = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { sizes: r, onSizesChange: i, ...a } = t, o = mp(yp, t.__scopeScrollArea), [s, c] = e.useState(), l = e.useRef(null), u = L(n, l, o.onScrollbarYChange);
	return e.useEffect(() => {
		l.current && c(getComputedStyle(l.current));
	}, [l]), /* @__PURE__ */ m(kp, {
		"data-orientation": "vertical",
		...a,
		ref: u,
		sizes: r,
		style: {
			top: 0,
			right: o.dir === "ltr" ? 0 : void 0,
			left: o.dir === "rtl" ? 0 : void 0,
			bottom: "var(--radix-scroll-area-corner-height)",
			"--radix-scroll-area-thumb-height": Rp(r) + "px",
			...t.style
		},
		onThumbPointerDown: (e) => t.onThumbPointerDown(e.y),
		onDragScroll: (e) => t.onDragScroll(e.y),
		onWheelScroll: (e, n) => {
			if (o.viewport) {
				let r = o.viewport.scrollTop + e.deltaY;
				t.onWheelScroll(r), Hp(r, n) && e.preventDefault();
			}
		},
		onResize: () => {
			l.current && o.viewport && s && i({
				content: o.viewport.scrollHeight,
				viewport: o.viewport.offsetHeight,
				scrollbar: {
					size: l.current.clientHeight,
					paddingStart: Ip(s.paddingTop),
					paddingEnd: Ip(s.paddingBottom)
				}
			});
		}
	});
}, "ScrollAreaScrollbarY")), [Dp, Op] = dp(yp), kp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { __scopeScrollArea: r, sizes: i, hasThumb: a, onThumbChange: o, onThumbPointerUp: s, onThumbPointerDown: c, onThumbPositionChange: l, onDragScroll: u, onWheelScroll: d, onResize: f, ...p } = t, h = mp(yp, r), [g, _] = e.useState(null), v = L(n, _), y = e.useRef(null), b = e.useRef(""), x = h.viewport, S = i.content - i.viewport, C = H(d), w = H(l), T = Wp(f, 10);
	function E(e) {
		if (y.current) {
			let t = e.clientX - y.current.left, n = e.clientY - y.current.top;
			u({
				x: t,
				y: n
			});
		}
	}
	return W(E, "handleDragScroll"), e.useEffect(() => {
		let e = /* @__PURE__ */ W((e) => {
			let t = e.target;
			g?.contains(t) && C(e, S);
		}, "handleWheel");
		return document.addEventListener("wheel", e, { passive: !1 }), () => document.removeEventListener("wheel", e, { passive: !1 });
	}, [
		x,
		g,
		S,
		C
	]), e.useEffect(w, [i, w]), Gp(g, T), Gp(h.content, T), /* @__PURE__ */ m(Dp, {
		scope: r,
		scrollbar: g,
		hasThumb: a,
		onThumbChange: H(o),
		onThumbPointerUp: H(s),
		onThumbPositionChange: w,
		onThumbPointerDown: H(c),
		children: /* @__PURE__ */ m(R.div, {
			...p,
			ref: v,
			style: {
				position: "absolute",
				...p.style
			},
			onPointerDown: z(t.onPointerDown, (e) => {
				e.button === 0 && (e.target.setPointerCapture(e.pointerId), y.current = g.getBoundingClientRect(), b.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), E(e));
			}),
			onPointerMove: z(t.onPointerMove, E),
			onPointerUp: z(t.onPointerUp, (e) => {
				let t = e.target;
				t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = b.current, h.viewport && (h.viewport.style.scrollBehavior = ""), y.current = null;
			})
		})
	});
}, "ScrollAreaScrollbarImpl")), Ap = "ScrollAreaThumb", jp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let { forceMount: n, ...r } = e, i = Op(Ap, e.__scopeScrollArea);
	return /* @__PURE__ */ m(Dt, {
		present: n || i.hasThumb,
		children: /* @__PURE__ */ m(Mp, {
			ref: t,
			...r
		})
	});
}, "ScrollAreaThumb")), Mp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { __scopeScrollArea: r, style: i, ...a } = t, o = mp(Ap, r), s = Op(Ap, r), { onThumbPositionChange: c } = s, l = L(n, s.onThumbChange), u = e.useRef(void 0), d = Wp(() => {
		u.current &&= (u.current(), void 0);
	}, 100);
	return e.useEffect(() => {
		let e = o.viewport;
		if (e) {
			let t = /* @__PURE__ */ W(() => {
				if (d(), !u.current) {
					let t = Up(e, c);
					u.current = t, c();
				}
			}, "handleScroll");
			return c(), e.addEventListener("scroll", t), () => e.removeEventListener("scroll", t);
		}
	}, [
		o.viewport,
		d,
		c
	]), /* @__PURE__ */ m(R.div, {
		"data-state": s.hasThumb ? "visible" : "hidden",
		...a,
		ref: l,
		style: {
			width: "var(--radix-scroll-area-thumb-width)",
			height: "var(--radix-scroll-area-thumb-height)",
			...i
		},
		onPointerDownCapture: z(t.onPointerDownCapture, (e) => {
			let t = e.target.getBoundingClientRect(), n = e.clientX - t.left, r = e.clientY - t.top;
			s.onThumbPointerDown({
				x: n,
				y: r
			});
		}),
		onPointerUp: z(t.onPointerUp, s.onThumbPointerUp)
	});
}, "ScrollAreaThumbImpl")), Np = "ScrollAreaCorner", Pp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(e, t) {
	let n = mp(Np, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
	return n.type !== "scroll" && r ? /* @__PURE__ */ m(Fp, {
		...e,
		ref: t
	}) : null;
}, "ScrollAreaCorner")), Fp = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ W(function(t, n) {
	let { __scopeScrollArea: r, ...i } = t, a = mp(Np, r), [o, s] = e.useState(0), [c, l] = e.useState(0), u = !!(o && c), { onCornerWidthChange: d, onCornerHeightChange: f } = a;
	return Gp(a.scrollbarX, () => {
		let e = a.scrollbarX?.offsetHeight || 0;
		a.onCornerHeightChange(e), l(e);
	}), Gp(a.scrollbarY, () => {
		let e = a.scrollbarY?.offsetWidth || 0;
		a.onCornerWidthChange(e), s(e);
	}), e.useEffect(() => () => {
		d(0), f(0);
	}, [d, f]), u ? /* @__PURE__ */ m(R.div, {
		...i,
		ref: n,
		style: {
			width: o,
			height: c,
			position: "absolute",
			right: a.dir === "ltr" ? 0 : void 0,
			left: a.dir === "rtl" ? 0 : void 0,
			bottom: 0,
			...t.style
		}
	}) : null;
}, "ScrollAreaCornerImpl"));
function Ip(e) {
	return e ? parseInt(e, 10) : 0;
}
W(Ip, "toInt");
function Lp(e, t) {
	let n = e / t;
	return isNaN(n) ? 0 : n;
}
W(Lp, "getThumbRatio");
function Rp(e) {
	let t = Lp(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
	return Math.max(r, 18);
}
W(Rp, "getThumbSize");
function zp(e, t, n, r = "ltr") {
	let i = Rp(n), a = i / 2, o = t || a, s = i - o, c = n.scrollbar.paddingStart + o, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
	return Vp([c, l], d)(e);
}
W(zp, "getScrollPositionFromPointer");
function Bp(e, t, n = "ltr") {
	let r = Rp(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - i, o = t.content - t.viewport, s = a - r, c = hf(e, n === "ltr" ? [0, o] : [o * -1, 0]);
	return Vp([0, o], [0, s])(c);
}
W(Bp, "getThumbOffsetFromScroll");
function Vp(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
W(Vp, "linearScale");
function Hp(e, t) {
	return e > 0 && e < t;
}
W(Hp, "isScrollingWithinScrollbarBounds");
var Up = /* @__PURE__ */ W((e, t = () => {}) => {
	let n = {
		left: e.scrollLeft,
		top: e.scrollTop
	}, r = 0;
	return (/* @__PURE__ */ W((function i() {
		let a = {
			left: e.scrollLeft,
			top: e.scrollTop
		}, o = n.left !== a.left, s = n.top !== a.top;
		(o || s) && t(), n = a, r = window.requestAnimationFrame(i);
	}), "loop"))(), () => window.cancelAnimationFrame(r);
}, "addUnlinkedScrollListener");
function Wp(t, n) {
	let r = H(t), i = e.useRef(0);
	return e.useEffect(() => () => window.clearTimeout(i.current), []), e.useCallback(() => {
		window.clearTimeout(i.current), i.current = window.setTimeout(r, n);
	}, [r, n]);
}
W(Wp, "useDebounceCallback");
function Gp(e, t) {
	let n = H(t);
	B(() => {
		let t = 0;
		if (e) {
			let r = new ResizeObserver(() => {
				cancelAnimationFrame(t), t = window.requestAnimationFrame(n);
			});
			return r.observe(e), () => {
				window.cancelAnimationFrame(t), r.unobserve(e);
			};
		}
	}, [e, n]);
}
W(Gp, "useResizeObserver");
var Kp = hp, qp = _p, Jp = Pp, Yp = Object.defineProperty, G = (e, t) => Yp(e, "name", {
	value: t,
	configurable: !0
}), Xp = [
	" ",
	"Enter",
	"ArrowUp",
	"ArrowDown"
], Zp = [" ", "Enter"], Qp = "Select", [$p, em, tm] = /* @__PURE__ */ qe(Qp), [nm, rm] = /* @__PURE__ */ Ue(Qp, [tm, Xc]), im = Xc(), [am, om] = nm(Qp), [sm, cm] = nm(Qp);
function lm(t) {
	let { __scopeSelect: n, children: r, open: i, defaultOpen: a, onOpenChange: o, value: s, defaultValue: c, onValueChange: l, dir: u, name: d, autoComplete: f, disabled: p, required: h, form: g, internal_do_not_use_render: _ } = t, v = im(n), [y, b] = e.useState(null), [x, S] = e.useState(null), [C, w] = e.useState(!1), T = rn(u), [E, D] = yt({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: Qp
	}), [O, k] = yt({
		prop: s,
		defaultProp: c,
		onChange: l,
		caller: Qp
	}), A = e.useRef(null), j = e.useRef(O);
	e.useEffect(() => {
		let e = g ? y?.ownerDocument.getElementById(g) : y?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ G(() => k(j.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		g,
		y,
		k
	]);
	let M = !y || !!g || !!y.closest("form"), [ee, N] = e.useState(/* @__PURE__ */ new Set()), te = V(), P = Array.from(ee).map((e) => e.props.value).join(";"), ne = e.useCallback((e) => {
		N((t) => new Set(t).add(e));
	}, []), re = e.useCallback((e) => {
		N((t) => {
			let n = new Set(t);
			return n.delete(e), n;
		});
	}, []), ie = {
		required: h,
		trigger: y,
		onTriggerChange: b,
		valueNode: x,
		onValueNodeChange: S,
		valueNodeHasChildren: C,
		onValueNodeHasChildrenChange: w,
		contentId: te,
		value: O,
		onValueChange: k,
		open: E,
		onOpenChange: D,
		dir: T,
		triggerPointerDownPosRef: A,
		disabled: p,
		name: d,
		autoComplete: f,
		form: g,
		nativeOptions: ee,
		nativeSelectKey: P,
		isFormControl: M
	};
	return /* @__PURE__ */ m(fl, {
		...v,
		children: /* @__PURE__ */ m(am, {
			scope: n,
			...ie,
			children: /* @__PURE__ */ m($p.Provider, {
				scope: n,
				children: /* @__PURE__ */ m(sm, {
					scope: n,
					onNativeOptionAdd: ne,
					onNativeOptionRemove: re,
					children: eh(_) ? _(ie) : r
				})
			})
		})
	});
}
G(lm, "SelectProvider");
var um = /* @__PURE__ */ G((e) => {
	let { __scopeSelect: t, children: n, ...r } = e;
	return /* @__PURE__ */ m(lm, {
		__scopeSelect: t,
		...r,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ h(p, { children: [n, e ? /* @__PURE__ */ m($m, { __scopeSelect: t }) : null] })
	});
}, "Select"), dm = "SelectTrigger", fm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, disabled: i = !1, ...a } = t, o = im(r), s = om(dm, r), c = s.disabled || i, l = L(n, s.onTriggerChange), u = em(r), d = e.useRef("touch"), [f, p, h] = nh((e) => {
		let t = u().filter((e) => !e.disabled), n = rh(t, e, t.find((e) => e.value === s.value));
		n !== void 0 && s.onValueChange(n.value);
	}), g = /* @__PURE__ */ G((e) => {
		c || (s.onOpenChange(!0), h()), e && (s.triggerPointerDownPosRef.current = {
			x: Math.round(e.pageX),
			y: Math.round(e.pageY)
		});
	}, "handleOpen");
	return /* @__PURE__ */ m(pl, {
		asChild: !0,
		...o,
		children: /* @__PURE__ */ m(R.button, {
			type: "button",
			role: "combobox",
			"aria-controls": s.open ? s.contentId : void 0,
			"aria-expanded": s.open,
			"aria-required": s.required,
			"aria-autocomplete": "none",
			dir: s.dir,
			"data-state": s.open ? "open" : "closed",
			disabled: c,
			"data-disabled": c ? "" : void 0,
			"data-placeholder": th(s.value) ? "" : void 0,
			...a,
			ref: l,
			onClick: z(a.onClick, (e) => {
				e.currentTarget.focus(), d.current !== "mouse" && g(e);
			}),
			onPointerDown: z(a.onPointerDown, (e) => {
				d.current = e.pointerType;
				let t = e.target;
				t.hasPointerCapture(e.pointerId) && t.releasePointerCapture(e.pointerId), e.button === 0 && e.ctrlKey === !1 && e.pointerType === "mouse" && (g(e), e.preventDefault());
			}),
			onKeyDown: z(a.onKeyDown, (e) => {
				let t = f.current !== "";
				!(e.ctrlKey || e.altKey || e.metaKey) && e.key.length === 1 && p(e.key), !(t && e.key === " ") && Xp.includes(e.key) && (g(), e.preventDefault());
			})
		})
	});
}, "SelectTrigger")), pm = "SelectValue", mm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, className: i, style: a, children: o, placeholder: s = "", ...c } = t, l = om(pm, r), { onValueNodeHasChildrenChange: u } = l, d = o !== void 0, f = L(n, l.onValueNodeChange);
	B(() => {
		u(d);
	}, [u, d]);
	let p = th(l.value);
	return /* @__PURE__ */ m(R.span, {
		...c,
		asChild: !p && c.asChild,
		ref: f,
		style: { pointerEvents: "none" },
		children: /* @__PURE__ */ m(e.Fragment, { children: p ? s : o }, p ? "placeholder" : "value")
	});
}, "SelectValue")), hm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, children: r, ...i } = e;
	return /* @__PURE__ */ m(R.span, {
		"aria-hidden": !0,
		...i,
		ref: t,
		children: r || "▼"
	});
}, "SelectIcon")), [gm, _m] = nm("SelectPortal", { forceMount: void 0 }), vm = /* @__PURE__ */ G((e) => {
	let { __scopeSelect: t, forceMount: n, ...r } = e;
	return /* @__PURE__ */ m(gm, {
		scope: e.__scopeSelect,
		forceMount: n,
		children: /* @__PURE__ */ m(xr, {
			asChild: !0,
			...r
		})
	});
}, "SelectPortal"), ym = "SelectContent", bm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let r = _m(ym, t.__scopeSelect), { forceMount: i = r.forceMount, ...a } = t, o = om(ym, t.__scopeSelect), [s, c] = e.useState();
	return B(() => {
		c(new DocumentFragment());
	}, []), /* @__PURE__ */ m(Dt, {
		present: i || o.open,
		children: ({ present: e }) => e ? /* @__PURE__ */ m(Em, {
			...a,
			ref: n
		}) : /* @__PURE__ */ m(xm, {
			...a,
			fragment: s
		})
	});
}, "SelectContent")), xm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, children: r, fragment: i } = e;
	return i ? f.createPortal(/* @__PURE__ */ m(Cm, {
		scope: n,
		children: /* @__PURE__ */ m($p.Slot, {
			scope: n,
			children: /* @__PURE__ */ m("div", {
				ref: t,
				children: r
			})
		})
	}), i) : null;
}, "SelectContentFragment")), Sm = 10, [Cm, wm] = nm(ym), Tm = /* @__PURE__ */ ye("SelectContent.RemoveScroll"), Em = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r } = t, { position: i = "item-aligned", onCloseAutoFocus: a, onEscapeKeyDown: o, onPointerDownOutside: s, side: c, sideOffset: l, align: u, alignOffset: d, arrowPadding: f, collisionBoundary: p, collisionPadding: h, sticky: g, hideWhenDetached: _, avoidCollisions: v, ...y } = t, b = om(ym, r), [x, S] = e.useState(null), [C, w] = e.useState(null), T = L(n, S), [E, D] = e.useState(null), [O, k] = e.useState(null), A = em(r), [j, M] = e.useState(!1), ee = e.useRef(!1);
	e.useEffect(() => {
		if (x) return Gi(x);
	}, [x]), Dr();
	let N = e.useCallback((e) => {
		let [t, ...n] = A().map((e) => e.ref.current), [r] = n.slice(-1), i = document.activeElement;
		for (let n of e) if (n === i || (n?.scrollIntoView({ block: "nearest" }), n === t && C && (C.scrollTop = 0), n === r && C && (C.scrollTop = C.scrollHeight), n?.focus(), document.activeElement !== i)) return;
	}, [A, C]), te = e.useCallback(() => N([E, x]), [
		N,
		E,
		x
	]);
	e.useEffect(() => {
		j && te();
	}, [j, te]);
	let { onOpenChange: P, triggerPointerDownPosRef: ne } = b;
	e.useEffect(() => {
		if (x) {
			let e = {
				x: 0,
				y: 0
			}, t = /* @__PURE__ */ G((t) => {
				e = {
					x: Math.abs(Math.round(t.pageX) - (ne.current?.x ?? 0)),
					y: Math.abs(Math.round(t.pageY) - (ne.current?.y ?? 0))
				};
			}, "handlePointerMove"), n = /* @__PURE__ */ G((n) => {
				e.x <= 10 && e.y <= 10 ? n.preventDefault() : n.composedPath().includes(x) || P(!1), document.removeEventListener("pointermove", t), ne.current = null;
			}, "handlePointerUp");
			return ne.current !== null && (document.addEventListener("pointermove", t), document.addEventListener("pointerup", n, {
				capture: !0,
				once: !0
			})), () => {
				document.removeEventListener("pointermove", t), document.removeEventListener("pointerup", n, { capture: !0 });
			};
		}
	}, [
		x,
		P,
		ne
	]), e.useEffect(() => {
		let e = /* @__PURE__ */ G(() => P(!1), "close");
		return window.addEventListener("blur", e), window.addEventListener("resize", e), () => {
			window.removeEventListener("blur", e), window.removeEventListener("resize", e);
		};
	}, [P]);
	let [re, ie] = nh((e) => {
		let t = A().filter((e) => !e.disabled), n = rh(t, e, t.find((e) => e.ref.current === document.activeElement));
		n && setTimeout(() => n.ref.current?.focus());
	}), ae = e.useCallback((e, t, n) => {
		let r = !ee.current && !n;
		(b.value !== void 0 && b.value === t || r) && (D(e), r && (ee.current = !0));
	}, [b.value]), F = e.useCallback(() => x?.focus(), [x]), oe = e.useCallback((e, t, n) => {
		let r = !ee.current && !n;
		(b.value !== void 0 && b.value === t || r) && k(e);
	}, [b.value]), se = i === "popper" ? Om : Dm, ce = se === Om ? {
		side: c,
		sideOffset: l,
		align: u,
		alignOffset: d,
		arrowPadding: f,
		collisionBoundary: p,
		collisionPadding: h,
		sticky: g,
		hideWhenDetached: _,
		avoidCollisions: v
	} : {};
	return /* @__PURE__ */ m(Cm, {
		scope: r,
		content: x,
		viewport: C,
		onViewportChange: w,
		itemRefCallback: ae,
		selectedItem: E,
		onItemLeave: F,
		itemTextRefCallback: oe,
		focusSelectedItem: te,
		selectedItemText: O,
		position: i,
		isPositioned: j,
		searchRef: re,
		children: /* @__PURE__ */ m(Ii, {
			as: Tm,
			allowPinchZoom: !0,
			children: /* @__PURE__ */ m(cr, {
				asChild: !0,
				trapped: b.open,
				onMountAutoFocus: (e) => {
					e.preventDefault();
				},
				onUnmountAutoFocus: z(a, (e) => {
					b.trigger?.focus({ preventScroll: !0 }), e.preventDefault();
				}),
				children: /* @__PURE__ */ m(Xn, {
					asChild: !0,
					disableOutsidePointerEvents: !0,
					onEscapeKeyDown: o,
					onPointerDownOutside: s,
					onFocusOutside: (e) => e.preventDefault(),
					onDismiss: () => b.onOpenChange(!1),
					children: /* @__PURE__ */ m(se, {
						role: "listbox",
						id: b.contentId,
						"data-state": b.open ? "open" : "closed",
						dir: b.dir,
						onContextMenu: (e) => e.preventDefault(),
						...y,
						...ce,
						onPlaced: () => M(!0),
						ref: T,
						style: {
							display: "flex",
							flexDirection: "column",
							outline: "none",
							...y.style
						},
						onKeyDown: z(y.onKeyDown, (e) => {
							let t = e.ctrlKey || e.altKey || e.metaKey;
							if (e.key === "Tab" && e.preventDefault(), !t && e.key.length === 1 && ie(e.key), [
								"ArrowUp",
								"ArrowDown",
								"Home",
								"End"
							].includes(e.key)) {
								let t = A().filter((e) => !e.disabled).map((e) => e.ref.current);
								if (["ArrowUp", "End"].includes(e.key) && (t = t.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(e.key)) {
									let n = e.target, r = t.indexOf(n);
									t = t.slice(r + 1);
								}
								setTimeout(() => N(t)), e.preventDefault();
							}
						})
					})
				})
			})
		})
	});
}, "SelectContentImpl")), Dm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, onPlaced: i, ...a } = t, o = om(ym, r), s = wm(ym, r), [c, l] = e.useState(null), [u, d] = e.useState(null), f = L(n, d), p = em(r), h = e.useRef(!1), g = e.useRef(!0), { viewport: _, selectedItem: v, selectedItemText: y, focusSelectedItem: b } = s, x = e.useCallback(() => {
		if (o.trigger && o.valueNode && c && u && _ && v && y) {
			let e = o.trigger.getBoundingClientRect(), t = u.getBoundingClientRect(), n = o.valueNode.getBoundingClientRect(), r = y.getBoundingClientRect();
			if (o.dir !== "rtl") {
				let i = r.left - t.left, a = n.left - i, o = e.left - a, s = e.width + o, l = Math.max(s, t.width), u = window.innerWidth - Sm, d = hf(a, [Sm, Math.max(Sm, u - l)]);
				c.style.minWidth = s + "px", c.style.left = d + "px";
			} else {
				let i = t.right - r.right, a = window.innerWidth - n.right - i, o = window.innerWidth - e.right - a, s = e.width + o, l = Math.max(s, t.width), u = window.innerWidth - Sm, d = hf(a, [Sm, Math.max(Sm, u - l)]);
				c.style.minWidth = s + "px", c.style.right = d + "px";
			}
			let a = p(), s = window.innerHeight - Sm * 2, l = _.scrollHeight, d = window.getComputedStyle(u), f = parseInt(d.borderTopWidth, 10), m = parseInt(d.paddingTop, 10), g = parseInt(d.borderBottomWidth, 10), b = parseInt(d.paddingBottom, 10), x = f + m + l + b + g, S = Math.min(v.offsetHeight * 5, x), C = window.getComputedStyle(_), w = parseInt(C.paddingTop, 10), T = parseInt(C.paddingBottom, 10), E = e.top + e.height / 2 - Sm, D = s - E, O = v.offsetHeight / 2, k = v.offsetTop + O, A = f + m + k, j = x - A;
			if (A <= E) {
				let e = a.length > 0 && v === a[a.length - 1].ref.current;
				c.style.bottom = "0px";
				let t = u.clientHeight - _.offsetTop - _.offsetHeight, n = A + Math.max(D, O + (e ? T : 0) + t + g);
				c.style.height = n + "px";
			} else {
				let e = a.length > 0 && v === a[0].ref.current;
				c.style.top = "0px";
				let t = Math.max(E, f + _.offsetTop + (e ? w : 0) + O) + j;
				c.style.height = t + "px", _.scrollTop = A - E + _.offsetTop;
			}
			c.style.margin = `${Sm}px 0`, c.style.minHeight = S + "px", c.style.maxHeight = s + "px", i?.(), requestAnimationFrame(() => h.current = !0);
		}
	}, [
		p,
		o.trigger,
		o.valueNode,
		c,
		u,
		_,
		v,
		y,
		o.dir,
		i
	]);
	B(() => x(), [x]);
	let [S, C] = e.useState();
	B(() => {
		u && C(window.getComputedStyle(u).zIndex);
	}, [u]);
	let w = e.useCallback((e) => {
		e && g.current === !0 && (x(), b?.(), g.current = !1);
	}, [x, b]);
	return /* @__PURE__ */ m(km, {
		scope: r,
		contentWrapper: c,
		shouldExpandOnScrollRef: h,
		onScrollButtonChange: w,
		children: /* @__PURE__ */ m("div", {
			ref: l,
			style: {
				display: "flex",
				flexDirection: "column",
				position: "fixed",
				zIndex: S
			},
			children: /* @__PURE__ */ m(R.div, {
				...a,
				ref: f,
				style: {
					boxSizing: "border-box",
					maxHeight: "100%",
					...a.style
				}
			})
		})
	});
}, "SelectItemAlignedPosition")), Om = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, align: r = "start", collisionPadding: i = Sm, ...a } = e, o = im(n);
	return /* @__PURE__ */ m(ml, {
		...o,
		...a,
		ref: t,
		align: r,
		collisionPadding: i,
		style: {
			boxSizing: "border-box",
			...a.style,
			"--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-select-content-available-width": "var(--radix-popper-available-width)",
			"--radix-select-content-available-height": "var(--radix-popper-available-height)",
			"--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "SelectPopperPosition")), [km, Am] = nm(ym, {}), jm = "SelectViewport", Mm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, nonce: i, ...a } = t, o = wm(jm, r), s = Am(jm, r), c = L(n, o.onViewportChange), l = e.useRef(0);
	return /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m("style", {
		dangerouslySetInnerHTML: { __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}" },
		nonce: i
	}), /* @__PURE__ */ m($p.Slot, {
		scope: r,
		children: /* @__PURE__ */ m(R.div, {
			"data-radix-select-viewport": "",
			role: "presentation",
			...a,
			ref: c,
			style: {
				position: "relative",
				flex: 1,
				overflow: "hidden auto",
				...a.style
			},
			onScroll: z(a.onScroll, (e) => {
				let t = e.currentTarget, { contentWrapper: n, shouldExpandOnScrollRef: r } = s;
				if (r?.current && n) {
					let e = Math.abs(l.current - t.scrollTop);
					if (e > 0) {
						let r = window.innerHeight - Sm * 2, i = parseFloat(n.style.minHeight), a = parseFloat(n.style.height), o = Math.max(i, a);
						if (o < r) {
							let i = o + e, a = Math.min(r, i), s = i - a;
							n.style.height = a + "px", n.style.bottom === "0px" && (t.scrollTop = s > 0 ? s : 0, n.style.justifyContent = "flex-end");
						}
					}
				}
				l.current = t.scrollTop;
			})
		})
	})] });
}, "SelectViewport")), [Nm, Pm] = nm("SelectGroup"), Fm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = V();
	return /* @__PURE__ */ m(Nm, {
		scope: n,
		id: i,
		children: /* @__PURE__ */ m(R.div, {
			role: "group",
			"aria-labelledby": i,
			...r,
			ref: t
		})
	});
}, "SelectGroup")), Im = "SelectLabel", Lm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, ...r } = e, i = Pm(Im, n);
	return /* @__PURE__ */ m(R.div, {
		id: i.id,
		...r,
		ref: t
	});
}, "SelectLabel")), Rm = "SelectItem", [zm, Bm] = nm(Rm), Vm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, value: i, disabled: a = !1, textValue: o, ...s } = t, c = om(Rm, r), l = wm(Rm, r), u = c.value === i, [d, f] = e.useState(o ?? ""), [p, h] = e.useState(!1), g = L(n, H((e) => l.itemRefCallback?.(e, i, a))), _ = V(), v = e.useRef("touch"), y = /* @__PURE__ */ G(() => {
		a || (c.onValueChange(i), c.onOpenChange(!1));
	}, "handleSelect");
	return /* @__PURE__ */ m(zm, {
		scope: r,
		value: i,
		disabled: a,
		textId: _,
		isSelected: u,
		onItemTextChange: e.useCallback((e) => {
			f((t) => t || (e?.textContent ?? "").trim());
		}, []),
		children: /* @__PURE__ */ m($p.ItemSlot, {
			scope: r,
			value: i,
			disabled: a,
			textValue: d,
			children: /* @__PURE__ */ m(R.div, {
				role: "option",
				"aria-labelledby": _,
				"data-highlighted": p ? "" : void 0,
				"aria-selected": u && p,
				"data-state": u ? "checked" : "unchecked",
				"aria-disabled": a || void 0,
				"data-disabled": a ? "" : void 0,
				tabIndex: a ? void 0 : -1,
				...s,
				ref: g,
				onFocus: z(s.onFocus, () => h(!0)),
				onBlur: z(s.onBlur, () => h(!1)),
				onClick: z(s.onClick, () => {
					v.current !== "mouse" && y();
				}),
				onPointerUp: z(s.onPointerUp, () => {
					v.current === "mouse" && y();
				}),
				onPointerDown: z(s.onPointerDown, (e) => {
					v.current = e.pointerType;
				}),
				onPointerMove: z(s.onPointerMove, (e) => {
					v.current = e.pointerType, a ? l.onItemLeave?.() : v.current === "mouse" && e.currentTarget.focus({ preventScroll: !0 });
				}),
				onPointerLeave: z(s.onPointerLeave, (e) => {
					e.currentTarget === document.activeElement && l.onItemLeave?.();
				}),
				onKeyDown: z(s.onKeyDown, (e) => {
					a || e.target !== e.currentTarget || (l.searchRef?.current === "" || e.key !== " ") && (Zp.includes(e.key) && y(), e.key === " " && e.preventDefault());
				})
			})
		})
	});
}, "SelectItem")), Hm = "SelectItemText", Um = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, className: i, style: a, ...o } = t, s = om(Hm, r), c = wm(Hm, r), l = Bm(Hm, r), u = cm(Hm, r), [d, g] = e.useState(null), _ = H((e) => c.itemTextRefCallback?.(e, l.value, l.disabled)), v = L(n, g, l.onItemTextChange, _), y = d?.textContent, b = e.useMemo(() => /* @__PURE__ */ m("option", {
		value: l.value,
		disabled: l.disabled,
		children: y
	}, l.value), [
		l.disabled,
		l.value,
		y
	]), { onNativeOptionAdd: x, onNativeOptionRemove: S } = u;
	return B(() => (x(b), () => S(b)), [
		x,
		S,
		b
	]), /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(R.span, {
		id: l.textId,
		...o,
		ref: v
	}), l.isSelected && s.valueNode && !s.valueNodeHasChildren && !th(s.value) ? f.createPortal(o.children, s.valueNode) : null] });
}, "SelectItemText")), Wm = "SelectItemIndicator", Gm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return Bm(Wm, n).isSelected ? /* @__PURE__ */ m(R.span, {
		"aria-hidden": !0,
		...r,
		ref: t
	}) : null;
}, "SelectItemIndicator")), Km = "SelectScrollUpButton", qm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let r = wm(Km, t.__scopeSelect), i = Am(Km, t.__scopeSelect), [a, o] = e.useState(!1), s = L(n, i.onScrollButtonChange);
	return B(() => {
		if (r.viewport && r.isPositioned) {
			let e = function() {
				let e = t.scrollTop > 0;
				o(e);
			};
			G(e, "handleScroll");
			let t = r.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ m(Xm, {
		...t,
		ref: s,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = r;
			e && t && (e.scrollTop -= t.offsetHeight);
		}
	}) : null;
}, "SelectScrollUpButton")), Jm = "SelectScrollDownButton", Ym = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let r = wm(Jm, t.__scopeSelect), i = Am(Jm, t.__scopeSelect), [a, o] = e.useState(!1), s = L(n, i.onScrollButtonChange);
	return B(() => {
		if (r.viewport && r.isPositioned) {
			let e = function() {
				let e = t.scrollHeight - t.clientHeight, n = Math.ceil(t.scrollTop) < e;
				o(n);
			};
			G(e, "handleScroll");
			let t = r.viewport;
			return e(), t.addEventListener("scroll", e), () => t.removeEventListener("scroll", e);
		}
	}, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ m(Xm, {
		...t,
		ref: s,
		onAutoScroll: () => {
			let { viewport: e, selectedItem: t } = r;
			e && t && (e.scrollTop += t.offsetHeight);
		}
	}) : null;
}, "SelectScrollDownButton")), Xm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(t, n) {
	let { __scopeSelect: r, onAutoScroll: i, ...a } = t, o = wm("SelectScrollButton", r), s = e.useRef(null), c = em(r), l = e.useCallback(() => {
		s.current !== null && (window.clearInterval(s.current), s.current = null);
	}, []);
	return e.useEffect(() => () => l(), [l]), B(() => {
		c().find((e) => e.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
	}, [c]), /* @__PURE__ */ m(R.div, {
		"aria-hidden": !0,
		...a,
		ref: n,
		style: {
			flexShrink: 0,
			...a.style
		},
		onPointerDown: z(a.onPointerDown, () => {
			s.current === null && (s.current = window.setInterval(i, 50));
		}),
		onPointerMove: z(a.onPointerMove, () => {
			o.onItemLeave?.(), s.current === null && (s.current = window.setInterval(i, 50));
		}),
		onPointerLeave: z(a.onPointerLeave, () => {
			l();
		})
	});
}, "SelectScrollButtonImpl")), Zm = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function(e, t) {
	let { __scopeSelect: n, ...r } = e;
	return /* @__PURE__ */ m(R.div, {
		"aria-hidden": !0,
		...r,
		ref: t
	});
}, "SelectSeparator")), Qm = "SelectBubbleInput", $m = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ G(function({ __scopeSelect: t, ...n }, r) {
	let i = om(Qm, t), { value: a, onValueChange: o, required: s, disabled: c, name: l, autoComplete: u, form: d } = i, { nativeOptions: f, nativeSelectKey: p } = i, g = e.useRef(null), _ = L(r, g), v = a ?? "", y = ff(v), b = Array.from(f).some((e) => (e.props.value ?? "") === "");
	return e.useEffect(() => {
		let e = g.current;
		if (!e) return;
		let t = window.HTMLSelectElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (y !== v && n) {
			let t = new Event("change", { bubbles: !0 });
			n.call(e, v), e.dispatchEvent(t);
		}
	}, [y, v]), /* @__PURE__ */ h(R.select, {
		"aria-hidden": !0,
		required: s,
		tabIndex: -1,
		name: l,
		autoComplete: u,
		disabled: c,
		form: d,
		onChange: (e) => o(e.target.value),
		...n,
		style: {
			...Re,
			...n.style
		},
		ref: _,
		defaultValue: v,
		children: [th(a) && !b ? /* @__PURE__ */ m("option", { value: "" }) : null, Array.from(f)]
	}, p);
}, "SelectBubbleInput"));
function eh(e) {
	return typeof e == "function";
}
G(eh, "isFunction");
function th(e) {
	return e === "" || e === void 0;
}
G(th, "shouldShowPlaceholder");
function nh(t) {
	let n = H(t), r = e.useRef(""), i = e.useRef(0), a = e.useCallback((e) => {
		let t = r.current + e;
		n(t), (/* @__PURE__ */ G((function e(t) {
			r.current = t, window.clearTimeout(i.current), t !== "" && (i.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(t);
	}, [n]), o = e.useCallback(() => {
		r.current = "", window.clearTimeout(i.current);
	}, []);
	return e.useEffect(() => () => window.clearTimeout(i.current), []), [
		r,
		a,
		o
	];
}
G(nh, "useTypeaheadSearch");
function rh(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = ih(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.textValue.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
G(rh, "findNextItem");
function ih(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
G(ih, "wrapArray");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-separator@1.1.15_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19_wrh35ifxvi4us3ywo3tc333j2i/node_modules/@radix-ui/react-separator/dist/index.mjs
var ah = Object.defineProperty, oh = (e, t) => ah(e, "name", {
	value: t,
	configurable: !0
}), sh = "horizontal", ch = ["horizontal", "vertical"], lh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ oh(function(e, t) {
	let { decorative: n, orientation: r = sh, ...i } = e, a = uh(r) ? r : sh, o = n ? { role: "none" } : {
		"aria-orientation": a === "vertical" ? a : void 0,
		role: "separator"
	};
	return /* @__PURE__ */ m(R.div, {
		"data-orientation": a,
		...o,
		...i,
		ref: t
	});
}, "Separator"));
function uh(e) {
	return ch.includes(e);
}
oh(uh, "isValidOrientation");
var dh = lh, fh = Object.defineProperty, K = (e, t) => fh(e, "name", {
	value: t,
	configurable: !0
}), ph = ["PageUp", "PageDown"], mh = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], hh = {
	"from-left": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-right": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowRight"
	],
	"from-bottom": [
		"Home",
		"PageDown",
		"ArrowDown",
		"ArrowLeft"
	],
	"from-top": [
		"Home",
		"PageDown",
		"ArrowUp",
		"ArrowLeft"
	]
}, gh = "Slider", [_h, vh, yh] = /* @__PURE__ */ qe(gh), [bh, xh] = /* @__PURE__ */ Ue(gh, [yh]), [Sh, Ch] = bh(gh), wh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(t, n) {
	let { name: r, min: i = 0, max: a = 100, step: o = 1, orientation: s = "horizontal", disabled: c = !1, minStepsBetweenThumbs: l = 0, defaultValue: u = [i], value: d, onValueChange: f = /* @__PURE__ */ K(() => {}, "onValueChange"), onValueCommit: p = /* @__PURE__ */ K(() => {}, "onValueCommit"), inverted: h = !1, form: g, ..._ } = t, v = e.useRef(/* @__PURE__ */ new Set()), y = e.useRef(0), b = e.useRef(!1), x = s === "horizontal" ? Dh : Oh, [S, C] = e.useState(null), w = L(n, C), [T = [], E] = yt({
		prop: d,
		defaultProp: u,
		onChange: /* @__PURE__ */ K((e) => {
			[...v.current][y.current]?.focus({
				preventScroll: !0,
				focusVisible: b.current
			}), b.current = !1, f(e);
		}, "onChange")
	}), D = e.useRef(T), O = e.useRef(T);
	e.useEffect(() => {
		let e = g ? S?.ownerDocument.getElementById(g) : S?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ K(() => E(O.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		S,
		g,
		E
	]);
	function k(e) {
		M(e, Kh(T, e));
	}
	K(k, "handleSlideStart");
	function A(e) {
		M(e, y.current);
	}
	K(A, "handleSlideMove");
	function j() {
		String(T) !== String(D.current) && p(T);
	}
	K(j, "handleSlideEnd");
	function M(e, t, { commit: n } = { commit: !1 }) {
		let r = Zh(o), s = hf(Qh(Math.round((e - i) / o) * o + i, r), [i, a]);
		E((e = []) => {
			let r = Uh(e, s, t);
			if (Yh(r, l * o)) {
				y.current = r.indexOf(s);
				let t = String(r) !== String(e);
				return t && n && p(r), t ? r : e;
			}
			return e;
		});
	}
	return K(M, "updateValues"), /* @__PURE__ */ m(Sh, {
		scope: t.__scopeSlider,
		name: r,
		disabled: c,
		min: i,
		max: a,
		valueIndexToChangeRef: y,
		thumbs: v.current,
		values: T,
		orientation: s,
		form: g,
		children: /* @__PURE__ */ m(_h.Provider, {
			scope: t.__scopeSlider,
			children: /* @__PURE__ */ m(_h.Slot, {
				scope: t.__scopeSlider,
				children: /* @__PURE__ */ m(x, {
					"aria-disabled": c,
					"data-disabled": c ? "" : void 0,
					..._,
					ref: w,
					onPointerDown: z(_.onPointerDown, () => {
						c || (D.current = T, b.current = !1);
					}),
					min: i,
					max: a,
					inverted: h,
					onSlideStart: c ? void 0 : k,
					onSlideMove: c ? void 0 : A,
					onSlideEnd: c ? void 0 : j,
					onHomeKeyDown: () => {
						c || (b.current = !0, M(i, 0, { commit: !0 }));
					},
					onEndKeyDown: () => {
						c || (b.current = !0, M(a, T.length - 1, { commit: !0 }));
					},
					onStepKeyDown: ({ event: e, direction: t }) => {
						if (!c) {
							b.current = !0;
							let n = ph.includes(e.key) || e.shiftKey && mh.includes(e.key) ? 10 : 1, r = y.current, a = T[r];
							M($h(a, {
								min: i,
								step: o,
								direction: t,
								multiplier: n
							}), r, { commit: !0 });
						}
					}
				})
			})
		})
	});
}, "Slider")), [Th, Eh] = bh(gh, {
	startEdge: "left",
	endEdge: "right",
	size: "width",
	direction: 1
}), Dh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(t, n) {
	let { min: r, max: i, dir: a, inverted: o, onSlideStart: s, onSlideMove: c, onSlideEnd: l, onStepKeyDown: u, ...d } = t, [f, p] = e.useState(null), h = L(n, p), g = e.useRef(void 0), _ = rn(a), v = _ === "ltr", y = v && !o || !v && o;
	function b(e) {
		let t = g.current || f.getBoundingClientRect(), n = Xh([0, t.width], y ? [r, i] : [i, r]);
		return g.current = t, n(e - t.left);
	}
	return K(b, "getValueFromPointer"), /* @__PURE__ */ m(Th, {
		scope: t.__scopeSlider,
		startEdge: y ? "left" : "right",
		endEdge: y ? "right" : "left",
		direction: y ? 1 : -1,
		size: "width",
		children: /* @__PURE__ */ m(kh, {
			dir: _,
			"data-orientation": "horizontal",
			...d,
			ref: h,
			style: {
				...d.style,
				"--radix-slider-thumb-transform": "translateX(-50%)"
			},
			onSlideStart: (e) => {
				let t = b(e.clientX);
				s?.(t);
			},
			onSlideMove: (e) => {
				let t = b(e.clientX);
				c?.(t);
			},
			onSlideEnd: () => {
				g.current = void 0, l?.();
			},
			onStepKeyDown: (e) => {
				let t = hh[y ? "from-left" : "from-right"].includes(e.key);
				u?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderHorizontal")), Oh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(t, n) {
	let { min: r, max: i, inverted: a, onSlideStart: o, onSlideMove: s, onSlideEnd: c, onStepKeyDown: l, ...u } = t, d = e.useRef(null), f = L(n, d), p = e.useRef(void 0), h = !a;
	function g(e) {
		let t = p.current || d.current.getBoundingClientRect(), n = Xh([0, t.height], h ? [i, r] : [r, i]);
		return p.current = t, n(e - t.top);
	}
	return K(g, "getValueFromPointer"), /* @__PURE__ */ m(Th, {
		scope: t.__scopeSlider,
		startEdge: h ? "bottom" : "top",
		endEdge: h ? "top" : "bottom",
		size: "height",
		direction: h ? 1 : -1,
		children: /* @__PURE__ */ m(kh, {
			"data-orientation": "vertical",
			...u,
			ref: f,
			style: {
				...u.style,
				"--radix-slider-thumb-transform": "translateY(50%)"
			},
			onSlideStart: (e) => {
				let t = g(e.clientY);
				o?.(t);
			},
			onSlideMove: (e) => {
				let t = g(e.clientY);
				s?.(t);
			},
			onSlideEnd: () => {
				p.current = void 0, c?.();
			},
			onStepKeyDown: (e) => {
				let t = hh[h ? "from-bottom" : "from-top"].includes(e.key);
				l?.({
					event: e,
					direction: t ? -1 : 1
				});
			}
		})
	});
}, "SliderVertical")), kh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(e, t) {
	let { __scopeSlider: n, onSlideStart: r, onSlideMove: i, onSlideEnd: a, onHomeKeyDown: o, onEndKeyDown: s, onStepKeyDown: c, ...l } = e, u = Ch(gh, n);
	return /* @__PURE__ */ m(R.span, {
		...l,
		ref: t,
		onKeyDown: z(e.onKeyDown, (e) => {
			e.key === "Home" ? (o(e), e.preventDefault()) : e.key === "End" ? (s(e), e.preventDefault()) : ph.concat(mh).includes(e.key) && (c(e), e.preventDefault());
		}),
		onPointerDown: z(e.onPointerDown, (e) => {
			let t = e.target;
			t.setPointerCapture(e.pointerId), e.preventDefault(), u.thumbs.has(t) ? t.focus({
				preventScroll: !0,
				focusVisible: !1
			}) : r(e);
		}),
		onPointerMove: z(e.onPointerMove, (e) => {
			e.target.hasPointerCapture(e.pointerId) && i(e);
		}),
		onPointerUp: z(e.onPointerUp, (e) => {
			let t = e.target;
			t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), a(e));
		})
	});
}, "SliderImpl")), Ah = "SliderTrack", jh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = Ch(Ah, n);
	return /* @__PURE__ */ m(R.span, {
		"data-disabled": i.disabled ? "" : void 0,
		"data-orientation": i.orientation,
		...r,
		ref: t
	});
}, "SliderTrack")), Mh = "SliderRange", Nh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(t, n) {
	let { __scopeSlider: r, ...i } = t, a = Ch(Mh, r), o = Eh(Mh, r), s = L(n, e.useRef(null)), c = a.values.length, l = a.values.map((e) => Wh(e, a.min, a.max)), u = c > 1 ? Math.min(...l) : 0, d = 100 - Math.max(...l);
	return /* @__PURE__ */ m(R.span, {
		"data-orientation": a.orientation,
		"data-disabled": a.disabled ? "" : void 0,
		...i,
		ref: s,
		style: {
			...t.style,
			[o.startEdge]: u + "%",
			[o.endEdge]: d + "%"
		}
	});
}, "SliderRange")), [Ph, Fh] = bh("SliderThumb"), Ih = "SliderThumbProvider";
function Lh(t) {
	let { __scopeSlider: n, name: r, children: i, internal_do_not_use_render: a } = t, o = Ch(Ih, n), s = vh(n), [c, l] = e.useState(null), u = e.useMemo(() => c ? s().findIndex((e) => e.ref.current === c) : -1, [s, c]), d = mo(c), f = !c || !!o.form || !!c.closest("form"), p = o.values[u], h = r ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0), g = p === void 0 ? 0 : Wh(p, o.min, o.max);
	e.useEffect(() => {
		if (c) return o.thumbs.add(c), () => {
			o.thumbs.delete(c);
		};
	}, [c, o.thumbs]);
	let _ = {
		value: p,
		name: h,
		form: o.form,
		isFormControl: f,
		index: u,
		thumb: c,
		onThumbChange: l,
		percent: g,
		size: d
	};
	return /* @__PURE__ */ m(Ph, {
		scope: n,
		..._,
		children: eg(a) ? a(_) : i
	});
}
K(Lh, "SliderThumbProvider");
var Rh = "SliderThumbTrigger", zh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(e, t) {
	let { __scopeSlider: n, ...r } = e, i = Ch(Rh, n), a = Eh(Rh, n), { index: o, value: s, percent: c, size: l, onThumbChange: u } = Fh(Rh, n), d = L(t, u), f = Gh(o, i.values.length), p = l?.[a.size], h = p ? qh(p, c, a.direction) : 0;
	return /* @__PURE__ */ m("span", {
		style: {
			transform: "var(--radix-slider-thumb-transform)",
			position: "absolute",
			[a.startEdge]: `calc(${c}% + ${h}px)`
		},
		children: /* @__PURE__ */ m(_h.ItemSlot, {
			scope: n,
			children: /* @__PURE__ */ m(R.span, {
				role: "slider",
				"aria-label": e["aria-label"] || f,
				"aria-valuemin": i.min,
				"aria-valuenow": s,
				"aria-valuemax": i.max,
				"aria-orientation": i.orientation,
				"data-orientation": i.orientation,
				"data-disabled": i.disabled ? "" : void 0,
				tabIndex: i.disabled ? void 0 : 0,
				...r,
				ref: d,
				style: s === void 0 ? { display: "none" } : e.style,
				onFocus: z(e.onFocus, () => {
					i.valueIndexToChangeRef.current = o;
				})
			})
		})
	});
}, "SliderThumbTrigger")), Bh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function(e, t) {
	let { __scopeSlider: n, name: r, ...i } = e;
	return /* @__PURE__ */ m(Lh, {
		__scopeSlider: n,
		name: r,
		internal_do_not_use_render: ({ index: e, isFormControl: r }) => /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(zh, {
			...i,
			ref: t,
			__scopeSlider: n
		}), r ? /* @__PURE__ */ m(Hh, { __scopeSlider: n }, e) : null] })
	});
}, "SliderThumb")), Vh = "SliderBubbleInput", Hh = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ K(function({ __scopeSlider: t, ...n }, r) {
	let { value: i, name: a, form: o } = Fh(Vh, t), s = e.useRef(null), c = L(s, r), l = ff(i);
	return e.useEffect(() => {
		let e = s.current;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "value").set;
		if (l !== i && n) {
			let t = new Event("input", { bubbles: !0 });
			n.call(e, i), e.dispatchEvent(t);
		}
	}, [l, i]), /* @__PURE__ */ m(R.input, {
		style: { display: "none" },
		name: a,
		form: o,
		...n,
		ref: c,
		defaultValue: i
	});
}, "SliderBubbleInput"));
function Uh(e = [], t, n) {
	let r = [...e];
	return r[n] = t, r.sort((e, t) => e - t);
}
K(Uh, "getNextSortedValues");
function Wh(e, t, n) {
	return hf(100 / (n - t) * (e - t), [0, 100]);
}
K(Wh, "convertValueToPercentage");
function Gh(e, t) {
	if (t > 2) return `Value ${e + 1} of ${t}`;
	if (t === 2) return ["Minimum", "Maximum"][e];
}
K(Gh, "getLabel");
function Kh(e, t) {
	if (e.length === 1) return 0;
	let n = e.map((e) => Math.abs(e - t)), r = Math.min(...n);
	return n.indexOf(r);
}
K(Kh, "getClosestValueIndex");
function qh(e, t, n) {
	let r = e / 2;
	return (r - Xh([0, 50], [0, r])(t) * n) * n;
}
K(qh, "getThumbInBoundsOffset");
function Jh(e) {
	return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
K(Jh, "getStepsBetweenValues");
function Yh(e, t) {
	if (t > 0) {
		let n = Jh(e);
		return Math.min(...n) >= t;
	}
	return !0;
}
K(Yh, "hasMinStepsBetweenValues");
function Xh(e, t) {
	return (n) => {
		if (e[0] === e[1] || t[0] === t[1]) return t[0];
		let r = (t[1] - t[0]) / (e[1] - e[0]);
		return t[0] + r * (n - e[0]);
	};
}
K(Xh, "linearScale");
function Zh(e) {
	if (!Number.isFinite(e)) return 0;
	let t = e.toString();
	if (t.includes("e")) {
		let [e, n] = t.split("e"), r = e.split(".")[1] || "", i = Number(n);
		return Math.max(0, r.length - i);
	}
	let n = t.split(".")[1];
	return n ? n.length : 0;
}
K(Zh, "getDecimalCount");
function Qh(e, t) {
	let n = 10 ** t;
	return Math.round(e * n) / n;
}
K(Qh, "roundValue");
function $h(e, { min: t, step: n, direction: r, multiplier: i }) {
	let a = Zh(n), o = (e - t) / n, s = Math.round(o), c = Qh(s * n + t, a) === Qh(e, a), l;
	return l = c ? s + i * r : r > 0 ? Math.ceil(o) : Math.floor(o), Qh(l * n + t, a);
}
K($h, "getNextStepValue");
function eg(e) {
	return typeof e == "function";
}
K(eg, "isFunction");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-switch@1.3.7_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3.0_lw7tkfnuqlpnesbt5rp32q355m/node_modules/@radix-ui/react-switch/dist/index.mjs
var tg = Object.defineProperty, ng = (e, t) => tg(e, "name", {
	value: t,
	configurable: !0
}), rg = "Switch", [ig, ag] = /* @__PURE__ */ Ue(rg), [og, sg] = ig(rg);
function cg(t) {
	let { __scopeSwitch: n, checked: r, children: i, defaultChecked: a, disabled: o, form: s, name: c, onCheckedChange: l, required: u, value: d = "on", internal_do_not_use_render: f } = t, [p, h] = yt({
		prop: r,
		defaultProp: a ?? !1,
		onChange: l,
		caller: rg
	}), [g, _] = e.useState(null), [v, y] = e.useState(null), b = e.useRef(!1), [x, S] = e.useReducer((e) => e + 1, 0), C = {
		checked: p,
		setChecked: h,
		disabled: o,
		control: g,
		setControl: _,
		name: c,
		form: s,
		value: d,
		hasConsumerStoppedPropagationRef: b,
		userInteractionCount: x,
		onUserInteraction: S,
		required: u,
		defaultChecked: a,
		isFormControl: !g || !!s || !!g.closest("form"),
		bubbleInput: v,
		setBubbleInput: y
	};
	return /* @__PURE__ */ m(og, {
		scope: n,
		...C,
		children: gg(f) ? f(C) : i
	});
}
ng(cg, "SwitchProvider");
var lg = "SwitchTrigger", ug = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ng(function({ __scopeSwitch: t, onClick: n, ...r }, i) {
	let { control: a, form: o, value: s, disabled: c, checked: l, required: u, setControl: d, setChecked: f, hasConsumerStoppedPropagationRef: p, onUserInteraction: h, isFormControl: g, bubbleInput: _ } = sg(lg, t), v = L(i, d), y = e.useRef(l);
	return e.useEffect(() => {
		let e = o ? a?.ownerDocument.getElementById(o) : a?.form;
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ ng(() => f(y.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		a,
		o,
		f
	]), /* @__PURE__ */ m(R.button, {
		type: "button",
		role: "switch",
		"aria-checked": l,
		"aria-required": u,
		"data-state": _g(l),
		"data-disabled": c ? "" : void 0,
		disabled: c,
		value: s,
		...r,
		ref: v,
		onClick: z(n, (e) => {
			h(), f((e) => !e), _ && g && (p.current = e.isPropagationStopped(), p.current || e.stopPropagation());
		})
	});
}, "SwitchTrigger")), dg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ng(function(e, t) {
	let { __scopeSwitch: n, name: r, checked: i, defaultChecked: a, required: o, disabled: s, value: c, onCheckedChange: l, form: u, ...d } = e;
	return /* @__PURE__ */ m(cg, {
		__scopeSwitch: n,
		checked: i,
		defaultChecked: a,
		disabled: s,
		required: o,
		onCheckedChange: l,
		name: r,
		form: u,
		value: c,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(ug, {
			...d,
			ref: t,
			__scopeSwitch: n
		}), e && /* @__PURE__ */ m(hg, { __scopeSwitch: n })] })
	});
}, "Switch")), fg = "SwitchThumb", pg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ng(function(e, t) {
	let { __scopeSwitch: n, ...r } = e, i = sg(fg, n);
	return /* @__PURE__ */ m(R.span, {
		"data-state": _g(i.checked),
		"data-disabled": i.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "SwitchThumb")), mg = "SwitchBubbleInput", hg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ng(function({ __scopeSwitch: t, onClick: n, ...r }, i) {
	let { control: a, hasConsumerStoppedPropagationRef: o, userInteractionCount: s, checked: c, defaultChecked: l, required: u, disabled: d, name: f, value: p, form: h, bubbleInput: g, setBubbleInput: _ } = sg(mg, t), v = L(i, _), y = mo(a), b = e.useRef(!1), x = e.useRef(c), S = e.useRef(s);
	e.useEffect(() => {
		let e = g;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = s !== S.current;
		S.current = s;
		let i = x.current !== c;
		x.current = c;
		let a = !(r && o.current);
		if (i && n) {
			b.current = !r;
			let t = new Event("click", { bubbles: a });
			n.call(e, c), e.dispatchEvent(t), b.current = !1;
		}
	}, [
		g,
		c,
		o,
		s
	]);
	let C = e.useRef(c);
	return /* @__PURE__ */ m(R.input, {
		type: "checkbox",
		"aria-hidden": !0,
		defaultChecked: l ?? C.current,
		required: u,
		disabled: d,
		name: f,
		value: p,
		form: h,
		...r,
		tabIndex: -1,
		ref: v,
		onClick: z(n, (e) => {
			b.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...y,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "SwitchBubbleInput"));
function gg(e) {
	return typeof e == "function";
}
ng(gg, "isFunction");
function _g(e) {
	return e ? "checked" : "unchecked";
}
ng(_g, "getState");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-toggle@1.1.18_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3._a6mnapxqv4aklzsgkwezkxltju/node_modules/@radix-ui/react-toggle/dist/index.mjs
var vg = Object.defineProperty, yg = (e, t) => vg(e, "name", {
	value: t,
	configurable: !0
}), bg = "Toggle", xg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ yg(function(e, t) {
	let { pressed: n, defaultPressed: r, onPressedChange: i, ...a } = e, [o, s] = yt({
		prop: n,
		onChange: i,
		defaultProp: r ?? !1,
		caller: bg
	});
	return /* @__PURE__ */ m(R.button, {
		type: "button",
		"aria-pressed": o,
		"data-state": o ? "on" : "off",
		"data-disabled": e.disabled ? "" : void 0,
		...a,
		ref: t,
		onClick: z(e.onClick, () => {
			e.disabled || s(!o);
		})
	});
}, "Toggle")), Sg = xg, Cg = Object.defineProperty, wg = (e, t) => Cg(e, "name", {
	value: t,
	configurable: !0
}), Tg = "ToggleGroup", [Eg, Dg] = /* @__PURE__ */ Ue(Tg, [Nl]), Og = Nl(), kg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(e, t) {
	let { type: n, ...r } = e;
	if (n === "single") return /* @__PURE__ */ m(Mg, {
		role: "radiogroup",
		...r,
		ref: t
	});
	if (n === "multiple") return /* @__PURE__ */ m(Ng, {
		role: "toolbar",
		...r,
		ref: t
	});
	throw Error(`Missing prop \`type\` expected on \`${Tg}\``);
}, "ToggleGroup")), [Ag, jg] = Eg(Tg), Mg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(t, n) {
	let { value: r, defaultValue: i, onValueChange: a = /* @__PURE__ */ wg(() => {}, "onValueChange"), ...o } = t, [s, c] = yt({
		prop: r,
		defaultProp: i ?? "",
		onChange: a,
		caller: Tg
	});
	return /* @__PURE__ */ m(Ag, {
		scope: t.__scopeToggleGroup,
		type: "single",
		value: e.useMemo(() => s ? [s] : [], [s]),
		onItemActivate: c,
		onItemDeactivate: e.useCallback(() => c(""), [c]),
		children: /* @__PURE__ */ m(Ig, {
			...o,
			ref: n
		})
	});
}, "ToggleGroupImplSingle")), Ng = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(t, n) {
	let { value: r, defaultValue: i, onValueChange: a = /* @__PURE__ */ wg(() => {}, "onValueChange"), ...o } = t, [s, c] = yt({
		prop: r,
		defaultProp: i ?? [],
		onChange: a,
		caller: Tg
	}), l = e.useCallback((e) => c((t = []) => [...t, e]), [c]), u = e.useCallback((e) => c((t = []) => t.filter((t) => t !== e)), [c]);
	return /* @__PURE__ */ m(Ag, {
		scope: t.__scopeToggleGroup,
		type: "multiple",
		value: s,
		onItemActivate: l,
		onItemDeactivate: u,
		children: /* @__PURE__ */ m(Ig, {
			...o,
			ref: n
		})
	});
}, "ToggleGroupImplMultiple")), [Pg, Fg] = Eg(Tg), Ig = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(e, t) {
	let { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: i = !0, orientation: a, dir: o, loop: s = !0, ...c } = e, l = Og(n), u = rn(o), d = {
		dir: u,
		...c
	};
	return /* @__PURE__ */ m(Pg, {
		scope: n,
		rovingFocus: i,
		disabled: r,
		children: i ? /* @__PURE__ */ m(Gl, {
			asChild: !0,
			...l,
			orientation: a,
			dir: u,
			loop: s,
			children: /* @__PURE__ */ m(R.div, {
				...d,
				ref: t
			})
		}) : /* @__PURE__ */ m(R.div, {
			...d,
			ref: t
		})
	});
}, "ToggleGroupImpl")), Lg = "ToggleGroupItem", Rg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(t, n) {
	let r = jg(Lg, t.__scopeToggleGroup), i = Fg(Lg, t.__scopeToggleGroup), a = Og(t.__scopeToggleGroup), o = r.value.includes(t.value), s = i.disabled || t.disabled, c = {
		...t,
		pressed: o,
		disabled: s
	}, l = e.useRef(null);
	return i.rovingFocus ? /* @__PURE__ */ m(Kl, {
		asChild: !0,
		...a,
		focusable: !s,
		active: o,
		ref: l,
		children: /* @__PURE__ */ m(zg, {
			...c,
			ref: n
		})
	}) : /* @__PURE__ */ m(zg, {
		...c,
		ref: n
	});
}, "ToggleGroupItem")), zg = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ wg(function(e, t) {
	let { __scopeToggleGroup: n, value: r, ...i } = e, a = jg(Lg, n), o = {
		role: "radio",
		"aria-checked": e.pressed,
		"aria-pressed": void 0
	}, s = a.type === "single" ? o : void 0;
	return /* @__PURE__ */ m(xg, {
		...s,
		...i,
		ref: t,
		onPressedChange: (e) => {
			e ? a.onItemActivate(r) : a.onItemDeactivate(r);
		}
	});
}, "ToggleGroupItemImpl")), Bg = Object.defineProperty, Vg = (e, t) => Bg(e, "name", {
	value: t,
	configurable: !0
}), [Hg, Ug] = /* @__PURE__ */ Ue("Tooltip", [Xc]), Wg = Xc(), Gg = "TooltipProvider", Kg = 700, qg = "tooltip.open", [Jg, Yg] = Hg(Gg), Xg = /* @__PURE__ */ Vg((t) => {
	let { __scopeTooltip: n, delayDuration: r = Kg, skipDelayDuration: i = 300, disableHoverableContent: a = !1, children: o } = t, s = e.useRef(!0), c = e.useRef(!1), l = e.useRef(0);
	return e.useEffect(() => {
		let e = l.current;
		return () => window.clearTimeout(e);
	}, []), /* @__PURE__ */ m(Jg, {
		scope: n,
		isOpenDelayedRef: s,
		delayDuration: r,
		onOpen: e.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), s.current = !1);
		}, [i]),
		onClose: e.useCallback(() => {
			i <= 0 || (window.clearTimeout(l.current), l.current = window.setTimeout(() => s.current = !0, i));
		}, [i]),
		isPointerInTransitRef: c,
		onPointerInTransitChange: e.useCallback((e) => {
			c.current = e;
		}, []),
		disableHoverableContent: a,
		children: o
	});
}, "TooltipProvider"), Zg = "Tooltip", [Qg, $g] = Hg(Zg), e_ = /* @__PURE__ */ Vg((t) => {
	let { __scopeTooltip: n, children: r, open: i, defaultOpen: a, onOpenChange: o, disableHoverableContent: s, delayDuration: c } = t, l = Yg(Zg, t.__scopeTooltip), u = Wg(n), [d, f] = e.useState(null), [p, h] = e.useState(void 0), g = V(), _ = e.useRef(0), v = s ?? l.disableHoverableContent, y = c ?? l.delayDuration, b = e.useRef(!1), [x, S] = yt({
		prop: i,
		defaultProp: a ?? !1,
		onChange: /* @__PURE__ */ Vg((e) => {
			e ? (l.onOpen(), document.dispatchEvent(new CustomEvent(qg))) : l.onClose(), o?.(e);
		}, "onChange"),
		caller: Zg
	}), C = e.useMemo(() => x ? b.current ? "delayed-open" : "instant-open" : "closed", [x]), w = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, b.current = !1, S(!0);
	}, [S]), T = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = 0, S(!1);
	}, [S]), E = e.useCallback(() => {
		window.clearTimeout(_.current), _.current = window.setTimeout(() => {
			b.current = !0, S(!0), _.current = 0;
		}, y);
	}, [y, S]);
	e.useEffect(() => () => {
		_.current &&= (window.clearTimeout(_.current), 0);
	}, []);
	let D = p ?? g;
	return /* @__PURE__ */ m(fl, {
		...u,
		children: /* @__PURE__ */ m(Qg, {
			scope: n,
			contentId: D,
			setContentId: h,
			open: x,
			stateAttribute: C,
			trigger: d,
			onTriggerChange: f,
			onTriggerEnter: e.useCallback(() => {
				l.isOpenDelayedRef.current ? E() : w();
			}, [
				l.isOpenDelayedRef,
				E,
				w
			]),
			onTriggerLeave: e.useCallback(() => {
				v ? T() : (window.clearTimeout(_.current), _.current = 0);
			}, [T, v]),
			onOpen: w,
			onClose: T,
			disableHoverableContent: v,
			children: r
		})
	});
}, "Tooltip"), t_ = "TooltipTrigger", n_ = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Vg(function(t, n) {
	let { __scopeTooltip: r, ...i } = t, a = $g(t_, r), o = Yg(t_, r), s = Wg(r), c = L(n, e.useRef(null), a.onTriggerChange), l = e.useRef(!1), u = e.useRef(!1), d = e.useCallback(() => l.current = !1, []);
	return e.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ m(pl, {
		asChild: !0,
		...s,
		children: /* @__PURE__ */ m(R.button, {
			"aria-describedby": a.open ? a.contentId : void 0,
			"data-state": a.stateAttribute,
			...i,
			ref: c,
			onPointerMove: z(t.onPointerMove, (e) => {
				e.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (a.onTriggerEnter(), u.current = !0);
			}),
			onPointerLeave: z(t.onPointerLeave, () => {
				a.onTriggerLeave(), u.current = !1;
			}),
			onPointerDown: z(t.onPointerDown, () => {
				a.open && a.onClose(), l.current = !0, document.addEventListener("pointerup", d, { once: !0 });
			}),
			onFocus: z(t.onFocus, () => {
				l.current || a.onOpen();
			}),
			onBlur: z(t.onBlur, a.onClose),
			onClick: z(t.onClick, a.onClose)
		})
	});
}, "TooltipTrigger")), r_ = "TooltipPortal", [i_, a_] = Hg(r_, { forceMount: void 0 }), o_ = /* @__PURE__ */ Vg((e) => {
	let { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = $g(r_, t);
	return /* @__PURE__ */ m(i_, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ m(Dt, {
			present: n || a.open,
			children: /* @__PURE__ */ m(xr, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "TooltipPortal"), s_ = "TooltipContent", c_ = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Vg(function(e, t) {
	let n = a_(s_, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = $g(s_, e.__scopeTooltip);
	return /* @__PURE__ */ m(Dt, {
		present: r || o.open,
		children: o.disableHoverableContent ? /* @__PURE__ */ m(d_, {
			side: i,
			...a,
			ref: t
		}) : /* @__PURE__ */ m(l_, {
			side: i,
			...a,
			ref: t
		})
	});
}, "TooltipContent")), l_ = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Vg(function(t, n) {
	let r = $g(s_, t.__scopeTooltip), i = Yg(s_, t.__scopeTooltip), a = e.useRef(null), o = L(n, a), [s, c] = e.useState(null), { trigger: l, onClose: u } = r, d = a.current, { onPointerInTransitChange: f } = i, p = e.useCallback(() => {
		c(null), f(!1);
	}, [f]), h = e.useCallback((e, t) => {
		let n = e.currentTarget, r = {
			x: e.clientX,
			y: e.clientY
		}, i = m_(r, p_(r, n.getBoundingClientRect())), a = h_(t.getBoundingClientRect()), o = __([...i, ...a]);
		c(o), f(!0);
	}, [f]);
	return e.useEffect(() => () => p(), [p]), e.useEffect(() => {
		if (l && d) {
			let e = /* @__PURE__ */ Vg((e) => h(e, d), "handleTriggerLeave"), t = /* @__PURE__ */ Vg((e) => h(e, l), "handleContentLeave");
			return l.addEventListener("pointerleave", e), d.addEventListener("pointerleave", t), () => {
				l.removeEventListener("pointerleave", e), d.removeEventListener("pointerleave", t);
			};
		}
	}, [
		l,
		d,
		h,
		p
	]), e.useEffect(() => {
		if (s) {
			let e = /* @__PURE__ */ Vg((e) => {
				let t = e.target, n = {
					x: e.clientX,
					y: e.clientY
				}, r = l?.contains(t) || d?.contains(t), i = !g_(n, s);
				r ? p() : i && (p(), u());
			}, "handleTrackPointerGrace");
			return document.addEventListener("pointermove", e), () => document.removeEventListener("pointermove", e);
		}
	}, [
		l,
		d,
		s,
		u,
		p
	]), /* @__PURE__ */ m(d_, {
		...t,
		ref: o
	});
}, "TooltipContentHoverable")), u_ = /* @__PURE__ */ Se("TooltipContent"), d_ = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Vg(function(t, n) {
	let { __scopeTooltip: r, children: i, "aria-label": a, id: o, onEscapeKeyDown: s, onPointerDownOutside: c, ...l } = t, u = $g(s_, r), d = Wg(r), { onClose: f } = u;
	e.useEffect(() => (document.addEventListener(qg, f), () => document.removeEventListener(qg, f)), [f]), e.useEffect(() => {
		if (u.trigger) {
			let e = /* @__PURE__ */ Vg((e) => {
				e.target instanceof Node && e.target.contains(u.trigger) && f();
			}, "handleScroll");
			return window.addEventListener("scroll", e, { capture: !0 }), () => window.removeEventListener("scroll", e, { capture: !0 });
		}
	}, [u.trigger, f]);
	let { setContentId: p } = u;
	return B(() => (p(o), () => {
		p(void 0);
	}), [o, p]), /* @__PURE__ */ m(Xn, {
		asChild: !0,
		disableOutsidePointerEvents: !1,
		onEscapeKeyDown: s,
		onPointerDownOutside: c,
		onFocusOutside: (e) => e.preventDefault(),
		onDismiss: f,
		children: /* @__PURE__ */ h(ml, {
			"data-state": u.stateAttribute,
			role: a ? void 0 : "tooltip",
			id: a ? void 0 : u.contentId,
			...d,
			...l,
			ref: n,
			style: {
				...l.style,
				"--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
				"--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
				"--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
				"--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
				"--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
			},
			children: [/* @__PURE__ */ m(u_, { children: i }), a ? /* @__PURE__ */ m(ze, {
				id: u.contentId,
				role: "tooltip",
				children: a
			}) : null]
		})
	});
}, "TooltipContentImpl")), f_ = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Vg(function(e, t) {
	let { __scopeTooltip: n, ...r } = e, i = Wg(n);
	return /* @__PURE__ */ m(hl, {
		...i,
		...r,
		ref: t
	});
}, "TooltipArrow"));
function p_(e, t) {
	let n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
	switch (Math.min(n, r, i, a)) {
		case a: return "left";
		case i: return "right";
		case n: return "top";
		case r: return "bottom";
		default: throw Error("unreachable");
	}
}
Vg(p_, "getExitSideFromRect");
function m_(e, t, n = 5) {
	let r = [];
	switch (t) {
		case "top":
			r.push({
				x: e.x - n,
				y: e.y + n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "bottom":
			r.push({
				x: e.x - n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y - n
			});
			break;
		case "left":
			r.push({
				x: e.x + n,
				y: e.y - n
			}, {
				x: e.x + n,
				y: e.y + n
			});
			break;
		case "right": r.push({
			x: e.x - n,
			y: e.y - n
		}, {
			x: e.x - n,
			y: e.y + n
		});
	}
	return r;
}
Vg(m_, "getPaddedExitPoints");
function h_(e) {
	let { top: t, right: n, bottom: r, left: i } = e;
	return [
		{
			x: i,
			y: t
		},
		{
			x: n,
			y: t
		},
		{
			x: n,
			y: r
		},
		{
			x: i,
			y: r
		}
	];
}
Vg(h_, "getPointsFromRect");
function g_(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
Vg(g_, "isPointInPolygon");
function __(e) {
	let t = e.slice();
	return t.sort((e, t) => e.x < t.x ? -1 : e.x > t.x ? 1 : e.y < t.y ? -1 : +(e.y > t.y)), v_(t);
}
Vg(__, "getHull");
function v_(e) {
	if (e.length <= 1) return e.slice();
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (; t.length >= 2;) {
			let e = t[t.length - 1], n = t[t.length - 2];
			if ((e.x - n.x) * (r.y - n.y) >= (e.y - n.y) * (r.x - n.x)) t.pop();
			else break;
		}
		t.push(r);
	}
	t.pop();
	let n = [];
	for (let t = e.length - 1; t >= 0; t--) {
		let r = e[t];
		for (; n.length >= 2;) {
			let e = n[n.length - 1], t = n[n.length - 2];
			if ((e.x - t.x) * (r.y - t.y) >= (e.y - t.y) * (r.x - t.x)) n.pop();
			else break;
		}
		n.push(r);
	}
	return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
Vg(v_, "getHullPresorted");
var y_ = Xg, b_ = e_, x_ = n_, S_ = o_, C_ = c_, w_ = f_;
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function T_(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = T_(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function E_() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = T_(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/tailwind-merge@3.7.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var D_ = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, O_ = (e, t) => ({
	classGroupId: e,
	validator: t
}), k_ = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), A_ = "-", j_ = [], M_ = "arbitrary..", N_ = (e) => {
	let t = I_(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return F_(e);
			let n = e.split(A_);
			return P_(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? D_(i, t) : t : i || j_;
			}
			return n[e] || j_;
		}
	};
}, P_ = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = P_(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(A_) : e.slice(t).join(A_), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, F_ = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? M_ + r : void 0;
})(), I_ = (e) => {
	let { theme: t, classGroups: n } = e;
	return L_(n, t);
}, L_ = (e, t) => {
	let n = k_();
	for (let r in e) {
		let i = e[r];
		R_(i, n, r, t);
	}
	return n;
}, R_ = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		z_(i, t, n, r);
	}
}, z_ = (e, t, n, r) => {
	if (typeof e == "string") {
		B_(e, t, n);
		return;
	}
	if (typeof e == "function") {
		V_(e, t, n, r);
		return;
	}
	H_(e, t, n, r);
}, B_ = (e, t, n) => {
	let r = e === "" ? t : U_(t, e);
	r.classGroupId = n;
}, V_ = (e, t, n, r) => {
	if (W_(e)) {
		R_(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(O_(n, e));
}, H_ = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		R_(o, U_(t, a), n, r);
	}
}, U_ = (e, t) => {
	let n = e, r = t.split(A_), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = k_(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, W_ = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, G_ = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, K_ = "!", q_ = ":", J_ = [], Y_ = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), X_ = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === q_) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(K_) ? (c = s.slice(0, -1), l = !0) : s.startsWith(K_) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Y_(t, l, c, u);
	};
	if (t) {
		let e = t + q_, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Y_(J_, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Z_ = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, Q_ = (e) => ({
	cache: G_(e.cacheSize),
	parseClassName: X_(e),
	sortModifiers: Z_(e),
	postfixLookupClassGroupIds: $_(e),
	...N_(e)
}), $_ = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, ev = /\s+/, tv = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(ev), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + K_ : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, nv = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = rv(n)) && (i && (i += " "), i += r);
	return i;
}, rv = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = rv(e[r])) && (n && (n += " "), n += t);
	return n;
}, iv = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = Q_(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = tv(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(nv(...e));
}, av = [], ov = (e) => {
	let t = (t) => t[e] || av;
	return t.isThemeGetter = !0, t.themeKey = e, t;
}, sv = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, cv = /^\((?:(\w[\w-]*):)?(.+)\)$/i, lv = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, uv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, dv = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, fv = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, pv = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, mv = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, hv = (e) => lv.test(e), q = (e) => !!e && !Number.isNaN(Number(e)), gv = (e) => !!e && Number.isInteger(Number(e)), _v = (e) => e.endsWith("%") && q(e.slice(0, -1)), vv = (e) => uv.test(e), yv = () => !0, bv = (e) => dv.test(e) && !fv.test(e), xv = () => !1, Sv = (e) => pv.test(e), Cv = (e) => mv.test(e), wv = (e) => !J(e) && !Y(e), Tv = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Ev = (e) => Vv(e, Gv, xv), J = (e) => sv.test(e), Dv = (e) => Vv(e, Kv, bv), Ov = (e) => Vv(e, qv, q), kv = (e) => Vv(e, Yv, yv), Av = (e) => Vv(e, Jv, xv), jv = (e) => Vv(e, Uv, xv), Mv = (e) => Vv(e, Wv, Cv), Nv = (e) => Vv(e, Xv, Sv), Y = (e) => cv.test(e), Pv = (e) => Hv(e, Kv), Fv = (e) => Hv(e, Jv), Iv = (e) => Hv(e, Uv), Lv = (e) => Hv(e, Gv), Rv = (e) => Hv(e, Wv), zv = (e) => Hv(e, Xv, !0), Bv = (e) => Hv(e, Yv, !0), Vv = (e, t, n) => {
	let r = sv.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Hv = (e, t, n = !1) => {
	let r = cv.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Uv = (e) => e === "position" || e === "percentage", Wv = (e) => e === "image" || e === "url", Gv = (e) => e === "length" || e === "size" || e === "bg-size", Kv = (e) => e === "length", qv = (e) => e === "number", Jv = (e) => e === "family-name", Yv = (e) => e === "number" || e === "weight", Xv = (e) => e === "shadow", Zv = /*#__PURE__*/ iv(() => {
	let e = ov("color"), t = ov("font"), n = ov("text"), r = ov("font-weight"), i = ov("tracking"), a = ov("leading"), o = ov("breakpoint"), s = ov("container"), c = ov("spacing"), l = ov("radius"), u = ov("shadow"), d = ov("inset-shadow"), f = ov("text-shadow"), p = ov("drop-shadow"), m = ov("blur"), h = ov("perspective"), g = ov("aspect"), _ = ov("ease"), v = ov("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		Y,
		J
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		Y,
		J,
		c
	], T = () => [
		hv,
		"full",
		"auto",
		...w()
	], E = () => [
		gv,
		"none",
		"subgrid",
		Y,
		J
	], D = () => [
		"auto",
		{ span: [
			"full",
			gv,
			Y,
			J
		] },
		gv,
		Y,
		J
	], O = () => [
		gv,
		"auto",
		Y,
		J
	], k = () => [
		"auto",
		"min",
		"max",
		"fr",
		Y,
		J
	], A = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], j = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], M = () => ["auto", ...w()], ee = () => [
		hv,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], N = () => [
		s,
		hv,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], te = () => [
		hv,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], P = () => [
		e,
		Y,
		J
	], ne = () => [
		...b(),
		Iv,
		jv,
		{ position: [Y, J] }
	], re = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ie = () => [
		"auto",
		"cover",
		"contain",
		Lv,
		Ev,
		{ size: [Y, J] }
	], ae = () => [
		_v,
		Pv,
		Dv
	], F = () => [
		"",
		"none",
		"full",
		l,
		Y,
		J
	], oe = () => [
		"",
		q,
		Pv,
		Dv
	], se = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ce = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], I = () => [
		q,
		_v,
		Iv,
		jv
	], le = () => [
		"",
		"none",
		m,
		Y,
		J
	], ue = () => [
		"none",
		q,
		Y,
		J
	], de = () => [
		"none",
		q,
		Y,
		J
	], fe = () => [
		q,
		Y,
		J
	], pe = () => [
		hv,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [vv],
			breakpoint: [vv],
			color: [yv],
			container: [vv],
			"drop-shadow": [vv],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [wv],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [vv],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [vv],
			shadow: [vv],
			spacing: ["px", q],
			text: [vv],
			"text-shadow": [vv],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				hv,
				J,
				Y,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Y,
				J
			] }],
			"container-named": [Tv],
			columns: [{ columns: [
				q,
				"auto",
				J,
				Y,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				gv,
				"auto",
				Y,
				J
			] }],
			basis: [{ basis: [
				hv,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				q,
				hv,
				"auto",
				"initial",
				"none",
				J
			] }],
			grow: [{ grow: [
				"",
				q,
				Y,
				J
			] }],
			shrink: [{ shrink: [
				"",
				q,
				Y,
				J
			] }],
			order: [{ order: [
				gv,
				"first",
				"last",
				"none",
				Y,
				J
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": O() }],
			"col-end": [{ "col-end": O() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": O() }],
			"row-end": [{ "row-end": O() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": k() }],
			"auto-rows": [{ "auto-rows": k() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...A(), "normal"] }],
			"justify-items": [{ "justify-items": [...j(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...j()] }],
			"align-content": [{ content: ["normal", ...A()] }],
			"align-items": [{ items: [...j(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...j(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": A() }],
			"place-items": [{ "place-items": [...j(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...j()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: M() }],
			mx: [{ mx: M() }],
			my: [{ my: M() }],
			ms: [{ ms: M() }],
			me: [{ me: M() }],
			mbs: [{ mbs: M() }],
			mbe: [{ mbe: M() }],
			mt: [{ mt: M() }],
			mr: [{ mr: M() }],
			mb: [{ mb: M() }],
			ml: [{ ml: M() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: ee() }],
			"inline-size": [{ inline: ["auto", ...N()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...N()] }],
			"max-inline-size": [{ "max-inline": ["none", ...N()] }],
			"block-size": [{ block: ["auto", ...te()] }],
			"min-block-size": [{ "min-block": ["auto", ...te()] }],
			"max-block-size": [{ "max-block": ["none", ...te()] }],
			w: [{ w: [
				s,
				"screen",
				...ee()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...ee()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...ee()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...ee()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...ee()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				"none",
				...ee()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Pv,
				Dv
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Bv,
				kv
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				_v,
				J
			] }],
			"font-family": [{ font: [
				Fv,
				Av,
				t
			] }],
			"font-features": [{ "font-features": [J] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Y,
				J
			] }],
			"line-clamp": [{ "line-clamp": [
				q,
				"none",
				Y,
				Ov
			] }],
			leading: [{ leading: [
				"none",
				a,
				...w()
			] }],
			"list-image": [{ "list-image": [
				"none",
				Y,
				J
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Y,
				J
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: P() }],
			"text-color": [{ text: P() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...se(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				q,
				"from-font",
				"auto",
				Y,
				Dv
			] }],
			"text-decoration-color": [{ decoration: P() }],
			"underline-offset": [{ "underline-offset": [
				q,
				"auto",
				Y,
				J
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				gv,
				Y,
				J
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Y,
				J
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Y,
				J
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: ne() }],
			"bg-repeat": [{ bg: re() }],
			"bg-size": [{ bg: ie() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						gv,
						Y,
						J
					],
					radial: [
						"",
						Y,
						J
					],
					conic: [
						"",
						gv,
						Y,
						J
					]
				},
				Rv,
				Mv
			] }],
			"bg-color": [{ bg: P() }],
			"gradient-from-pos": [{ from: ae() }],
			"gradient-via-pos": [{ via: ae() }],
			"gradient-to-pos": [{ to: ae() }],
			"gradient-from": [{ from: P() }],
			"gradient-via": [{ via: P() }],
			"gradient-to": [{ to: P() }],
			rounded: [{ rounded: F() }],
			"rounded-s": [{ "rounded-s": F() }],
			"rounded-e": [{ "rounded-e": F() }],
			"rounded-t": [{ "rounded-t": F() }],
			"rounded-r": [{ "rounded-r": F() }],
			"rounded-b": [{ "rounded-b": F() }],
			"rounded-l": [{ "rounded-l": F() }],
			"rounded-ss": [{ "rounded-ss": F() }],
			"rounded-se": [{ "rounded-se": F() }],
			"rounded-ee": [{ "rounded-ee": F() }],
			"rounded-es": [{ "rounded-es": F() }],
			"rounded-tl": [{ "rounded-tl": F() }],
			"rounded-tr": [{ "rounded-tr": F() }],
			"rounded-br": [{ "rounded-br": F() }],
			"rounded-bl": [{ "rounded-bl": F() }],
			"border-w": [{ border: oe() }],
			"border-w-x": [{ "border-x": oe() }],
			"border-w-y": [{ "border-y": oe() }],
			"border-w-s": [{ "border-s": oe() }],
			"border-w-e": [{ "border-e": oe() }],
			"border-w-bs": [{ "border-bs": oe() }],
			"border-w-be": [{ "border-be": oe() }],
			"border-w-t": [{ "border-t": oe() }],
			"border-w-r": [{ "border-r": oe() }],
			"border-w-b": [{ "border-b": oe() }],
			"border-w-l": [{ "border-l": oe() }],
			"divide-x": [{ "divide-x": oe() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": oe() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...se(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...se(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: P() }],
			"border-color-x": [{ "border-x": P() }],
			"border-color-y": [{ "border-y": P() }],
			"border-color-s": [{ "border-s": P() }],
			"border-color-e": [{ "border-e": P() }],
			"border-color-bs": [{ "border-bs": P() }],
			"border-color-be": [{ "border-be": P() }],
			"border-color-t": [{ "border-t": P() }],
			"border-color-r": [{ "border-r": P() }],
			"border-color-b": [{ "border-b": P() }],
			"border-color-l": [{ "border-l": P() }],
			"divide-color": [{ divide: P() }],
			"outline-style": [{ outline: [
				...se(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				q,
				Y,
				J
			] }],
			"outline-w": [{ outline: [
				"",
				q,
				Pv,
				Dv
			] }],
			"outline-color": [{ outline: P() }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				u,
				zv,
				Nv
			] }],
			"shadow-color": [{ shadow: P() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				zv,
				Nv
			] }],
			"inset-shadow-color": [{ "inset-shadow": P() }],
			"ring-w": [{ ring: oe() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: P() }],
			"ring-offset-w": [{ "ring-offset": [q, Dv] }],
			"ring-offset-color": [{ "ring-offset": P() }],
			"inset-ring-w": [{ "inset-ring": oe() }],
			"inset-ring-color": [{ "inset-ring": P() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				zv,
				Nv
			] }],
			"text-shadow-color": [{ "text-shadow": P() }],
			opacity: [{ opacity: [
				q,
				Y,
				J
			] }],
			"mix-blend": [{ "mix-blend": [
				...ce(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ce() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [q] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": I() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": I() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": P() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": P() }],
			"mask-image-t-from-pos": [{ "mask-t-from": I() }],
			"mask-image-t-to-pos": [{ "mask-t-to": I() }],
			"mask-image-t-from-color": [{ "mask-t-from": P() }],
			"mask-image-t-to-color": [{ "mask-t-to": P() }],
			"mask-image-r-from-pos": [{ "mask-r-from": I() }],
			"mask-image-r-to-pos": [{ "mask-r-to": I() }],
			"mask-image-r-from-color": [{ "mask-r-from": P() }],
			"mask-image-r-to-color": [{ "mask-r-to": P() }],
			"mask-image-b-from-pos": [{ "mask-b-from": I() }],
			"mask-image-b-to-pos": [{ "mask-b-to": I() }],
			"mask-image-b-from-color": [{ "mask-b-from": P() }],
			"mask-image-b-to-color": [{ "mask-b-to": P() }],
			"mask-image-l-from-pos": [{ "mask-l-from": I() }],
			"mask-image-l-to-pos": [{ "mask-l-to": I() }],
			"mask-image-l-from-color": [{ "mask-l-from": P() }],
			"mask-image-l-to-color": [{ "mask-l-to": P() }],
			"mask-image-x-from-pos": [{ "mask-x-from": I() }],
			"mask-image-x-to-pos": [{ "mask-x-to": I() }],
			"mask-image-x-from-color": [{ "mask-x-from": P() }],
			"mask-image-x-to-color": [{ "mask-x-to": P() }],
			"mask-image-y-from-pos": [{ "mask-y-from": I() }],
			"mask-image-y-to-pos": [{ "mask-y-to": I() }],
			"mask-image-y-from-color": [{ "mask-y-from": P() }],
			"mask-image-y-to-color": [{ "mask-y-to": P() }],
			"mask-image-radial": [{ "mask-radial": [Y, J] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": I() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": I() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": P() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": P() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [q] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": I() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": I() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": P() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": P() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: ne() }],
			"mask-repeat": [{ mask: re() }],
			"mask-size": [{ mask: ie() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Y,
				J
			] }],
			filter: [{ filter: [
				"",
				"none",
				Y,
				J
			] }],
			blur: [{ blur: le() }],
			brightness: [{ brightness: [
				q,
				Y,
				J
			] }],
			contrast: [{ contrast: [
				q,
				Y,
				J
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				zv,
				Nv
			] }],
			"drop-shadow-color": [{ "drop-shadow": P() }],
			grayscale: [{ grayscale: [
				"",
				q,
				Y,
				J
			] }],
			"hue-rotate": [{ "hue-rotate": [
				q,
				Y,
				J
			] }],
			invert: [{ invert: [
				"",
				q,
				Y,
				J
			] }],
			saturate: [{ saturate: [
				q,
				Y,
				J
			] }],
			sepia: [{ sepia: [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Y,
				J
			] }],
			"backdrop-blur": [{ "backdrop-blur": le() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				q,
				Y,
				J
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				q,
				Y,
				J
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				q,
				Y,
				J
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				q,
				Y,
				J
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				q,
				Y,
				J
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				q,
				Y,
				J
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Y,
				J
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				q,
				"initial",
				Y,
				J
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				Y,
				J
			] }],
			delay: [{ delay: [
				q,
				Y,
				J
			] }],
			animate: [{ animate: [
				"none",
				v,
				Y,
				J
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Y,
				J
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ue() }],
			"rotate-x": [{ "rotate-x": ue() }],
			"rotate-y": [{ "rotate-y": ue() }],
			"rotate-z": [{ "rotate-z": ue() }],
			scale: [{ scale: de() }],
			"scale-x": [{ "scale-x": de() }],
			"scale-y": [{ "scale-y": de() }],
			"scale-z": [{ "scale-z": de() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: fe() }],
			"skew-x": [{ "skew-x": fe() }],
			"skew-y": [{ "skew-y": fe() }],
			transform: [{ transform: [
				Y,
				J,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: pe() }],
			"translate-x": [{ "translate-x": pe() }],
			"translate-y": [{ "translate-y": pe() }],
			"translate-z": [{ "translate-z": pe() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				gv,
				Y,
				J
			] }],
			accent: [{ accent: P() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: P() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Y,
				J
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": P() }],
			"scrollbar-track-color": [{ "scrollbar-track": P() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Y,
				J
			] }],
			fill: [{ fill: ["none", ...P()] }],
			"stroke-w": [{ stroke: [
				q,
				Pv,
				Dv,
				Ov
			] }],
			stroke: [{ stroke: ["none", ...P()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": [
				"start",
				"end",
				"right",
				"left"
			],
			"inset-y": [
				"inset-bs",
				"inset-be",
				"top",
				"bottom"
			],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: [
				"ps",
				"pe",
				"pr",
				"pl"
			],
			py: [
				"pbs",
				"pbe",
				"pt",
				"pb"
			],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: [
				"ms",
				"me",
				"mr",
				"ml"
			],
			my: [
				"mbs",
				"mbe",
				"mt",
				"mb"
			],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": [
				"border-w-s",
				"border-w-e",
				"border-w-r",
				"border-w-l"
			],
			"border-w-y": [
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-b"
			],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": [
				"border-color-s",
				"border-color-e",
				"border-color-r",
				"border-color-l"
			],
			"border-color-y": [
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-b"
			],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": [
				"scroll-ms",
				"scroll-me",
				"scroll-mr",
				"scroll-ml"
			],
			"scroll-my": [
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mb"
			],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": [
				"scroll-ps",
				"scroll-pe",
				"scroll-pr",
				"scroll-pl"
			],
			"scroll-py": [
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pb"
			],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/lib/utils.ts
function X(...e) {
	return Zv(E_(e));
}
//#endregion
//#region src/components/ui/accordion.tsx
function Qv({ className: e, ...t }) {
	return /* @__PURE__ */ m(In, {
		"data-slot": "accordion",
		className: X("flex w-full flex-col", e),
		...t
	});
}
function $v({ className: e, ...t }) {
	return /* @__PURE__ */ m(Ln, {
		"data-slot": "accordion-item",
		className: X("not-last:border-b", e),
		...t
	});
}
function ey({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ m(Rn, {
		className: "flex",
		children: /* @__PURE__ */ h(zn, {
			"data-slot": "accordion-trigger",
			className: X("group/accordion-trigger relative flex flex-1 items-start justify-between rounded-lg border border-transparent py-2.5 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:after:border-ring disabled:pointer-events-none disabled:opacity-50 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 **:data-[slot=accordion-trigger-icon]:text-muted-foreground", e),
			...n,
			children: [
				t,
				/* @__PURE__ */ m(ne, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
				}),
				/* @__PURE__ */ m(se, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
				})
			]
		})
	});
}
function ty({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ m(Bn, {
		"data-slot": "accordion-content",
		className: "overflow-hidden text-sm data-open:animate-accordion-down data-closed:animate-accordion-up",
		...n,
		children: /* @__PURE__ */ m("div", {
			className: X("h-(--radix-accordion-content-height) pt-0 pb-2.5 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", e),
			children: t
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var ny = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ry = E_, iy = (e, t) => (n) => {
	if (t?.variants == null) return ry(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = ny(t) || ny(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return ry(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, ay = iy("group/button inline-flex shrink-0 cursor-pointer items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
			outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
			ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
			destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
			icon: "size-8",
			"icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
			"icon-lg": "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function oy({ className: e, variant: t = "default", size: n = "default", asChild: r = !1, ...i }) {
	return /* @__PURE__ */ m(r ? be : "button", {
		"data-slot": "button",
		"data-variant": t,
		"data-size": n,
		className: X(ay({
			variant: t,
			size: n,
			className: e
		})),
		...i
	});
}
//#endregion
//#region src/components/ui/alert-dialog.tsx
function sy({ ...e }) {
	return /* @__PURE__ */ m(za, {
		"data-slot": "alert-dialog",
		...e
	});
}
function cy({ ...e }) {
	return /* @__PURE__ */ m(Ba, {
		"data-slot": "alert-dialog-trigger",
		...e
	});
}
function ly({ ...e }) {
	return /* @__PURE__ */ m(Va, {
		"data-slot": "alert-dialog-portal",
		...e
	});
}
function uy({ className: e, ...t }) {
	return /* @__PURE__ */ m(Ha, {
		"data-slot": "alert-dialog-overlay",
		className: X("fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", e),
		...t
	});
}
function dy({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ h(ly, { children: [/* @__PURE__ */ m(uy, {}), /* @__PURE__ */ m(Ua, {
		"data-slot": "alert-dialog-content",
		"data-size": t,
		className: X("group/alert-dialog-content fixed top-1/2 left-1/2 z-50 grid w-full -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none data-[size=default]:max-w-xs data-[size=sm]:max-w-xs data-[size=default]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...n
	})] });
}
function fy({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "alert-dialog-header",
		className: X("grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-4 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]", e),
		...t
	});
}
function py({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "alert-dialog-footer",
		className: X("-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end", e),
		...t
	});
}
function my({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "alert-dialog-media",
		className: X("mb-2 inline-flex size-10 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-6", e),
		...t
	});
}
function hy({ className: e, ...t }) {
	return /* @__PURE__ */ m(Ka, {
		"data-slot": "alert-dialog-title",
		className: X("text-base font-medium sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2", e),
		...t
	});
}
function gy({ className: e, ...t }) {
	return /* @__PURE__ */ m(qa, {
		"data-slot": "alert-dialog-description",
		className: X("text-sm text-balance text-muted-foreground md:text-pretty *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", e),
		...t
	});
}
function _y({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ m(oy, {
		variant: t,
		size: n,
		asChild: !0,
		children: /* @__PURE__ */ m(Wa, {
			"data-slot": "alert-dialog-action",
			className: X(e),
			...r
		})
	});
}
function vy({ className: e, variant: t = "outline", size: n = "default", ...r }) {
	return /* @__PURE__ */ m(oy, {
		variant: t,
		size: n,
		asChild: !0,
		children: /* @__PURE__ */ m(Ga, {
			"data-slot": "alert-dialog-cancel",
			className: X(e),
			...r
		})
	});
}
//#endregion
//#region src/components/ui/avatar.tsx
function yy({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ m(no, {
		"data-slot": "avatar",
		"data-size": t,
		className: X("group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten", e),
		...n
	});
}
function by({ className: e, ...t }) {
	return /* @__PURE__ */ m(io, {
		"data-slot": "avatar-image",
		className: X("aspect-square size-full rounded-full object-cover", e),
		...t
	});
}
function xy({ className: e, ...t }) {
	return /* @__PURE__ */ m(oo, {
		"data-slot": "avatar-fallback",
		className: X("flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs", e),
		...t
	});
}
function Sy({ className: e, ...t }) {
	return /* @__PURE__ */ m("span", {
		"data-slot": "avatar-badge",
		className: X("absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground bg-blend-color ring-2 ring-background select-none", "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden", "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2", "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2", e),
		...t
	});
}
function Cy({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "avatar-group",
		className: X("group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background", e),
		...t
	});
}
function wy({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "avatar-group-count",
		className: X("relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3", e),
		...t
	});
}
//#endregion
//#region src/components/ui/badge.tsx
var Ty = iy("group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-4xl border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3!", {
	variants: { variant: {
		default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
		secondary: "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80",
		destructive: "bg-destructive/10 text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20",
		outline: "border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
		ghost: "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
		link: "text-primary underline-offset-4 hover:underline"
	} },
	defaultVariants: { variant: "default" }
});
function Ey({ className: e, variant: t = "default", asChild: n = !1, ...r }) {
	return /* @__PURE__ */ m(n ? be : "span", {
		"data-slot": "badge",
		"data-variant": t,
		className: X(Ty({ variant: t }), e),
		...r
	});
}
//#endregion
//#region src/components/ui/button-group.tsx
function Dy({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "button-group",
		role: "group",
		className: X("flex h-7 items-center -space-x-px [&>*:first-child]:rounded-l-md [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none [&>*:last-child]:rounded-r-md [&>*:not(:first-child):not(:last-child)]:rounded-none", e),
		...t
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/tzName/index.js
function Oy(e, t, n = "long") {
	return new Intl.DateTimeFormat("en-US", {
		hour: "numeric",
		timeZone: e,
		timeZoneName: n
	}).format(t).split(/\s/g).slice(2).join(" ");
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/tzOffset/index.js
var ky = {}, Ay = {};
function jy(e, t) {
	try {
		let n = (ky[e] ||= new Intl.DateTimeFormat("en-US", {
			timeZone: e,
			timeZoneName: "longOffset"
		}).format)(t).split("GMT")[1];
		return n in Ay ? Ay[n] : Ny(n, n.split(":"));
	} catch {
		if (e in Ay) return Ay[e];
		let t = e?.match(My);
		return t ? Ny(e, t.slice(1)) : NaN;
	}
}
var My = /([+-]\d\d):?(\d\d)?/;
function Ny(e, t) {
	let n = +(t[0] || 0), r = +(t[1] || 0), i = (t[2] || 0) / 60;
	return Ay[e] = n * 60 + r > 0 ? n * 60 + r + i : n * 60 - r - i;
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/date/mini.js
var Py = class e extends Date {
	constructor(...e) {
		super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(jy(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Ry(this, e)) : this.setTime(Date.now());
	}
	static tz(t, ...n) {
		return n.length ? new e(...n, t) : new e(Date.now(), t);
	}
	withTimeZone(t) {
		return new e(+this, t);
	}
	getTimezoneOffset() {
		let e = -jy(this.timeZone, this);
		return e > 0 ? Math.floor(e) : Math.ceil(e);
	}
	setTime(e) {
		return Date.prototype.setTime.apply(this, arguments), Iy(this), +this;
	}
	[Symbol.for("constructDateFrom")](t) {
		return new e(+new Date(t), this.timeZone);
	}
}, Fy = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
	if (!Fy.test(e)) return;
	let t = e.replace(Fy, "$1UTC");
	Py.prototype[t] && (e.startsWith("get") ? Py.prototype[e] = function() {
		return this.internal[t]();
	} : (Py.prototype[e] = function() {
		return Date.prototype[t].apply(this.internal, arguments), Ly(this), +this;
	}, Py.prototype[t] = function() {
		return Date.prototype[t].apply(this, arguments), Iy(this), +this;
	}));
});
function Iy(e) {
	e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-jy(e.timeZone, e) * 60));
}
function Ly(e) {
	Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Ry(e);
}
function Ry(e, t) {
	let n = Array.isArray(t) ? zy(t) : +e.internal, r = jy(e.timeZone, e), i = r > 0 ? Math.floor(r) : Math.ceil(r), a = /* @__PURE__ */ new Date(+e);
	a.setUTCHours(a.getUTCHours() - 1);
	let o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), c = o - s, l = o;
	if (c && o !== i && Date.prototype.getHours.apply(e) !== (Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours())) {
		let t = /* @__PURE__ */ new Date(+e), n = o - i;
		n && t.setUTCMinutes(t.getUTCMinutes() + n);
		let r = jy(e.timeZone, t);
		(r > 0 ? Math.floor(r) : Math.ceil(r)) === i && (l = s);
	}
	let u = l - i;
	u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
	let d = /* @__PURE__ */ new Date(+e);
	d.setUTCSeconds(0);
	let f = o > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, p = Math.round(-(jy(e.timeZone, e) * 60)) % 60;
	(p || f) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + p + f);
	let m = jy(e.timeZone, e), h = m > 0 ? Math.floor(m) : Math.ceil(m), g = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - h, _ = h !== i, v = g - u, y = h - i, b = n - h * 60 * 1e3, x = y > 0 && By(e) - n === y * 60 * 1e3 && By(e, b) !== n;
	if (_ && v && !x) {
		Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + v);
		let t = jy(e.timeZone, e), n = h - (t > 0 ? Math.floor(t) : Math.ceil(t));
		n && v < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + n);
	}
	Iy(e);
	let S = (t ? n : n + p * 1e3) - +e.internal;
	S && Math.abs(S) < 18e5 && (Date.prototype.setTime.call(e, +e + S), Iy(e));
}
function zy(e) {
	return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function By(e, t) {
	let n = new Date(t ?? +e);
	return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-jy(e.timeZone, n) * 60)), +n;
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/date/index.js
var Vy = class e extends Py {
	static tz(t, ...n) {
		return n.length ? new e(...n, t) : new e(Date.now(), t);
	}
	toISOString() {
		let [e, t, n] = this.tzComponents(), r = `${e}${t}:${n}`;
		return this.internal.toISOString().slice(0, -1) + r;
	}
	toString() {
		return `${this.toDateString()} ${this.toTimeString()}`;
	}
	toDateString() {
		let [e, t, n, r] = this.internal.toUTCString().split(" ");
		return `${e?.slice(0, -1)} ${n} ${t} ${r}`;
	}
	toTimeString() {
		let e = this.internal.toUTCString().split(" ")[4], [t, n, r] = this.tzComponents();
		return `${e} GMT${t}${n}${r} (${Oy(this.timeZone, this)})`;
	}
	toLocaleString(e, t) {
		return Date.prototype.toLocaleString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	toLocaleDateString(e, t) {
		return Date.prototype.toLocaleDateString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	toLocaleTimeString(e, t) {
		return Date.prototype.toLocaleTimeString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	tzComponents() {
		let e = this.getTimezoneOffset();
		return [
			e > 0 ? "-" : "+",
			String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"),
			String(Math.abs(e) % 60).padStart(2, "0")
		];
	}
	withTimeZone(t) {
		return new e(+this, t);
	}
	[Symbol.for("constructDateFrom")](t) {
		return new e(+new Date(t), this.timeZone);
	}
}, Hy = 365.2425, Uy = 6048e5, Wy = 864e5, Gy = 86400;
Gy * 7, Gy * Hy / 12 * 3;
var Ky = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/constructFrom.js
function qy(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Ky in e ? e[Ky](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/toDate.js
function Z(e, t) {
	return qy(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addDays.js
function Jy(e, t, n) {
	let r = Z(e, n?.in);
	return isNaN(t) ? qy(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addMonths.js
function Yy(e, t, n) {
	let r = Z(e, n?.in);
	if (isNaN(t)) return qy(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = qy(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/defaultOptions.js
var Xy = {};
function Zy() {
	return Xy;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeek.js
function Qy(e, t) {
	let n = Zy(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Z(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeek.js
function $y(e, t) {
	return Qy(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeekYear.js
function eb(e, t) {
	let n = Z(e, t?.in), r = n.getFullYear(), i = qy(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = $y(i), o = qy(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = $y(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function tb(e) {
	let t = Z(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), +e - n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/normalizeDates.js
function nb(e, ...t) {
	let n = qy.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfDay.js
function rb(e, t) {
	let n = Z(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/differenceInCalendarDays.js
function ib(e, t, n) {
	let [r, i] = nb(n?.in, e, t), a = rb(r), o = rb(i), s = +a - tb(a), c = +o - tb(o);
	return Math.round((s - c) / Wy);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeekYear.js
function ab(e, t) {
	let n = eb(e, t), r = qy(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), $y(r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addWeeks.js
function ob(e, t, n) {
	return Jy(e, t * 7, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addYears.js
function sb(e, t, n) {
	return Yy(e, t * 12, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/max.js
function cb(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = qy.bind(null, e));
		let t = Z(e, r);
		(!n || n < t || isNaN(+t)) && (n = t);
	}), qy(r, n || NaN);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/min.js
function lb(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = qy.bind(null, e));
		let t = Z(e, r);
		(!n || n > t || isNaN(+t)) && (n = t);
	}), qy(r, n || NaN);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameDay.js
function ub(e, t, n) {
	let [r, i] = nb(n?.in, e, t);
	return +rb(r) == +rb(i);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isDate.js
function db(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isValid.js
function fb(e) {
	return !(!db(e) && typeof e != "number" || isNaN(+Z(e)));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/differenceInCalendarMonths.js
function pb(e, t, n) {
	let [r, i] = nb(n?.in, e, t), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
	return a * 12 + o;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfMonth.js
function mb(e, t) {
	let n = Z(e, t?.in), r = n.getMonth();
	return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/normalizeInterval.js
function hb(e, t) {
	let [n, r] = nb(e, t.start, t.end);
	return {
		start: n,
		end: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/eachMonthOfInterval.js
function gb(e, t) {
	let { start: n, end: r } = hb(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0), o.setDate(1);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(qy(n, o)), o.setMonth(o.getMonth() + s);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfMonth.js
function _b(e, t) {
	let n = Z(e, t?.in);
	return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfYear.js
function vb(e, t) {
	let n = Z(e, t?.in), r = n.getFullYear();
	return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfYear.js
function yb(e, t) {
	let n = Z(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/eachYearOfInterval.js
function bb(e, t) {
	let { start: n, end: r } = hb(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(qy(n, o)), o.setFullYear(o.getFullYear() + s);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfWeek.js
function xb(e, t) {
	let n = Zy(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Z(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
	return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfISOWeek.js
function Sb(e, t) {
	return xb(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var Cb = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, wb = (e, t, n) => {
	let r, i = Cb[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function Tb(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var Eb = {
	date: Tb({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: Tb({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: Tb({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Db = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, Ob = (e, t, n, r) => Db[e];
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function kb(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var Ab = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: kb({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: kb({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: kb({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: kb({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: kb({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function jb(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Nb(s, (e) => e.test(o)) : Mb(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function Mb(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function Nb(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function Pb(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US.js
var Fb = {
	code: "en-US",
	formatDistance: wb,
	formatLong: Eb,
	formatRelative: Ob,
	localize: Ab,
	match: {
		ordinalNumber: Pb({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: jb({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: jb({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: jb({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: jb({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: jb({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDayOfYear.js
function Ib(e, t) {
	let n = Z(e, t?.in);
	return ib(n, yb(n)) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeek.js
function Lb(e, t) {
	let n = Z(e, t?.in), r = +$y(n) - ab(n);
	return Math.round(r / Uy) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeekYear.js
function Rb(e, t) {
	let n = Z(e, t?.in), r = n.getFullYear(), i = Zy(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = qy(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = Qy(o, t), c = qy(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = Qy(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeekYear.js
function zb(e, t) {
	let n = Zy(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = Rb(e, t), a = qy(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), Qy(a, t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeek.js
function Bb(e, t) {
	let n = Z(e, t?.in), r = +Qy(n, t) - zb(n, t);
	return Math.round(r / Uy) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/addLeadingZeros.js
function Q(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/lightFormatters.js
var Vb = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return Q(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : Q(n + 1, 2);
	},
	d(e, t) {
		return Q(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return Q(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return Q(e.getHours(), t.length);
	},
	m(e, t) {
		return Q(e.getMinutes(), t.length);
	},
	s(e, t) {
		return Q(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return Q(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, Hb = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Ub = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return Vb.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = Rb(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? Q(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Q(a, t.length);
	},
	R: function(e, t) {
		return Q(eb(e), t.length);
	},
	u: function(e, t) {
		return Q(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return Q(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return Q(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return Vb.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return Q(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = Bb(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : Q(i, t.length);
	},
	I: function(e, t, n) {
		let r = Lb(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Q(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Vb.d(e, t);
	},
	D: function(e, t, n) {
		let r = Ib(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Q(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return Q(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return Q(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return Q(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? Hb.noon : r === 0 ? Hb.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? Hb.evening : r >= 12 ? Hb.afternoon : r >= 4 ? Hb.morning : Hb.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return Vb.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Vb.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Q(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Q(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Vb.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Vb.s(e, t);
	},
	S: function(e, t) {
		return Vb.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return Gb(r);
			case "XXXX":
			case "XX": return Kb(r);
			default: return Kb(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return Gb(r);
			case "xxxx":
			case "xx": return Kb(r);
			default: return Kb(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Wb(r, ":");
			default: return "GMT" + Kb(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Wb(r, ":");
			default: return "GMT" + Kb(r, ":");
		}
	},
	t: function(e, t, n) {
		return Q(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return Q(+e, t.length);
	}
};
function Wb(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + Q(a, 2);
}
function Gb(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + Q(Math.abs(e) / 60, 2) : Kb(e, t);
}
function Kb(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Q(Math.trunc(r / 60), 2), a = Q(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/longFormatters.js
var qb = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, Jb = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, Yb = {
	p: Jb,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return qb(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default: a = t.dateTime({ width: "full" });
		}
		return a.replace("{{date}}", qb(r, t)).replace("{{time}}", Jb(i, t));
	}
}, Xb = /^D+$/, Zb = /^Y+$/, Qb = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function $b(e) {
	return Xb.test(e);
}
function ex(e) {
	return Zb.test(e);
}
function tx(e, t, n) {
	let r = nx(e, t, n);
	if (console.warn(r), Qb.includes(e)) throw RangeError(r);
}
function nx(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/format.js
var rx = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ix = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ax = /^'([^]*?)'?$/, ox = /''/g, sx = /[a-zA-Z]/;
function cx(e, t, n) {
	let r = Zy(), i = n?.locale ?? r.locale ?? Fb, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Z(e, n?.in);
	if (!fb(s)) throw RangeError("Invalid time value");
	let c = t.match(ix).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = Yb[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(rx).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: lx(e)
		};
		if (Ub[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(sx)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && ex(a) || !n?.useAdditionalDayOfYearTokens && $b(a)) && tx(a, t, String(e));
		let o = Ub[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function lx(e) {
	let t = e.match(ax);
	return t ? t[1].replace(ox, "'") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDaysInMonth.js
function ux(e, t) {
	let n = Z(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = qy(n, 0);
	return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getMonth.js
function dx(e, t) {
	return Z(e, t?.in).getMonth();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getYear.js
function fx(e, t) {
	return Z(e, t?.in).getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isAfter.js
function px(e, t) {
	return +Z(e) > +Z(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isBefore.js
function mx(e, t) {
	return +Z(e) < +Z(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameMonth.js
function hx(e, t, n) {
	let [r, i] = nb(n?.in, e, t);
	return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameYear.js
function gx(e, t, n) {
	let [r, i] = nb(n?.in, e, t);
	return r.getFullYear() === i.getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/setMonth.js
function _x(e, t, n) {
	let r = Z(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = qy(n?.in || e, 0);
	o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
	let s = ux(o);
	return r.setMonth(t, Math.min(a, s)), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/setYear.js
function vx(e, t, n) {
	let r = Z(e, n?.in);
	return isNaN(+r) ? qy(n?.in || e, NaN) : (r.setFullYear(t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getBroadcastWeeksInMonth.js
var yx = 5, bx = 4;
function xx(e, t) {
	let n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, i = t.addDays(e, -r + 1), a = t.addDays(i, 34);
	return t.getMonth(e) === t.getMonth(a) ? yx : bx;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/startOfBroadcastWeek.js
function Sx(e, t) {
	let n = t.startOfMonth(e), r = n.getDay();
	return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/endOfBroadcastWeek.js
function Cx(e, t) {
	let n = Sx(e, t), r = xx(e, t);
	return t.addDays(n, r * 7 - 1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/locale/en-US.js
var wx = {
	...Fb,
	labels: {
		labelDayButton: (e, t, n, r) => {
			let i;
			i = r && typeof r.format == "function" ? r.format.bind(r) : (e, t) => cx(e, t, {
				locale: Fb,
				...n
			});
			let a = i(e, "PPPP");
			return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
		},
		labelMonthDropdown: "Choose the Month",
		labelNext: "Go to the Next Month",
		labelPrevious: "Go to the Previous Month",
		labelWeekNumber: (e) => `Week ${e}`,
		labelYearDropdown: "Choose the Year",
		labelGrid: (e, t, n) => {
			let r;
			return r = n && typeof n.format == "function" ? n.format.bind(n) : (e, n) => cx(e, n, {
				locale: Fb,
				...t
			}), r(e, "LLLL yyyy");
		},
		labelGridcell: (e, t, n, r) => {
			let i;
			i = r && typeof r.format == "function" ? r.format.bind(r) : (e, t) => cx(e, t, {
				locale: Fb,
				...n
			});
			let a = i(e, "PPPP");
			return t?.today && (a = `Today, ${a}`), a;
		},
		labelNav: "Navigation bar",
		labelWeekNumberHeader: "Week Number",
		labelWeekday: (e, t, n) => {
			let r;
			return r = n && typeof n.format == "function" ? n.format.bind(n) : (e, n) => cx(e, n, {
				locale: Fb,
				...t
			}), r(e, "cccc");
		}
	}
}, Tx = class e {
	constructor(e, t) {
		this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? Vy.tz(this.options.timeZone) : new (this.options.Date ?? Date)(), this.newDate = (e, t, n) => this.overrides?.newDate ? this.overrides.newDate(e, t, n) : this.options.timeZone ? new Vy(e, t, n, this.options.timeZone) : new Date(e, t, n), this.addDays = (e, t) => this.overrides?.addDays ? this.overrides.addDays(e, t) : Jy(e, t), this.addMonths = (e, t) => this.overrides?.addMonths ? this.overrides.addMonths(e, t) : Yy(e, t), this.addWeeks = (e, t) => this.overrides?.addWeeks ? this.overrides.addWeeks(e, t) : ob(e, t), this.addYears = (e, t) => this.overrides?.addYears ? this.overrides.addYears(e, t) : sb(e, t), this.differenceInCalendarDays = (e, t) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(e, t) : ib(e, t), this.differenceInCalendarMonths = (e, t) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(e, t) : pb(e, t), this.eachMonthOfInterval = (e) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(e) : gb(e), this.eachYearOfInterval = (e) => {
			let t = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(e) : bb(e), n = new Set(t.map((e) => this.getYear(e)));
			if (n.size === t.length) return t;
			let r = [];
			return n.forEach((e) => {
				r.push(new Date(e, 0, 1));
			}), r;
		}, this.endOfBroadcastWeek = (e) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(e) : Cx(e, this), this.endOfISOWeek = (e) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(e) : Sb(e), this.endOfMonth = (e) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(e) : mb(e), this.endOfWeek = (e, t) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(e, t) : xb(e, this.options), this.endOfYear = (e) => this.overrides?.endOfYear ? this.overrides.endOfYear(e) : vb(e), this.format = (e, t, n) => {
			let r = this.overrides?.format ? this.overrides.format(e, t, this.options) : cx(e, t, this.options);
			return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(r) : r;
		}, this.getISOWeek = (e) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(e) : Lb(e), this.getMonth = (e, t) => this.overrides?.getMonth ? this.overrides.getMonth(e, this.options) : dx(e, this.options), this.getYear = (e, t) => this.overrides?.getYear ? this.overrides.getYear(e, this.options) : fx(e, this.options), this.getWeek = (e, t) => this.overrides?.getWeek ? this.overrides.getWeek(e, this.options) : Bb(e, this.options), this.isAfter = (e, t) => this.overrides?.isAfter ? this.overrides.isAfter(e, t) : px(e, t), this.isBefore = (e, t) => this.overrides?.isBefore ? this.overrides.isBefore(e, t) : mx(e, t), this.isDate = (e) => this.overrides?.isDate ? this.overrides.isDate(e) : db(e), this.isSameDay = (e, t) => this.overrides?.isSameDay ? this.overrides.isSameDay(e, t) : ub(e, t), this.isSameMonth = (e, t) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(e, t) : hx(e, t), this.isSameYear = (e, t) => this.overrides?.isSameYear ? this.overrides.isSameYear(e, t) : gx(e, t), this.max = (e) => this.overrides?.max ? this.overrides.max(e) : cb(e), this.min = (e) => this.overrides?.min ? this.overrides.min(e) : lb(e), this.setMonth = (e, t) => this.overrides?.setMonth ? this.overrides.setMonth(e, t) : _x(e, t), this.setYear = (e, t) => this.overrides?.setYear ? this.overrides.setYear(e, t) : vx(e, t), this.startOfBroadcastWeek = (e, t) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(e, this) : Sx(e, this), this.startOfDay = (e) => this.overrides?.startOfDay ? this.overrides.startOfDay(e) : rb(e), this.startOfISOWeek = (e) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(e) : $y(e), this.startOfMonth = (e) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(e) : _b(e), this.startOfWeek = (e, t) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(e, this.options) : Qy(e, this.options), this.startOfYear = (e) => this.overrides?.startOfYear ? this.overrides.startOfYear(e) : yb(e), this.options = {
			locale: wx,
			...e
		}, this.overrides = t;
	}
	getDigitMap() {
		let { numerals: e = "latn" } = this.options, t = new Intl.NumberFormat("en-US", { numberingSystem: e }), n = {};
		for (let e = 0; e < 10; e++) n[e.toString()] = t.format(e);
		return n;
	}
	replaceDigits(e) {
		let t = this.getDigitMap();
		return e.replace(/\d/g, (e) => t[e] || e);
	}
	formatNumber(e) {
		return this.replaceDigits(e.toString());
	}
	getMonthYearOrder() {
		let t = this.options.locale?.code;
		return t && e.yearFirstLocales.has(t) ? "year-first" : "month-first";
	}
	formatMonthYear(t) {
		let { locale: n, timeZone: r, numerals: i } = this.options, a = n?.code;
		if (a && e.yearFirstLocales.has(a)) try {
			return new Intl.DateTimeFormat(a, {
				month: "long",
				year: "numeric",
				timeZone: r,
				numberingSystem: i
			}).format(t);
		} catch {}
		let o = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
		return this.format(t, o);
	}
};
Tx.yearFirstLocales = /* @__PURE__ */ new Set([
	"eu",
	"hu",
	"ja",
	"ja-Hira",
	"ja-JP",
	"ko",
	"ko-KR",
	"lt",
	"lt-LT",
	"lv",
	"lv-LV",
	"mn",
	"mn-MN",
	"zh",
	"zh-CN",
	"zh-HK",
	"zh-TW"
]);
var Ex = new Tx(), Dx = class {
	constructor(e, t, n = Ex) {
		this.date = e, this.displayMonth = t, this.outside = !(!t || n.isSameMonth(e, t)), this.dateLib = n, this.isoDate = n.format(e, "yyyy-MM-dd"), this.displayMonthId = n.format(t, "yyyy-MM"), this.dateMonthId = n.format(e, "yyyy-MM");
	}
	isEqualTo(e) {
		return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
	}
}, Ox = class {
	constructor(e, t) {
		this.date = e, this.weeks = t;
	}
}, kx = class {
	constructor(e, t) {
		this.days = t, this.weekNumber = e;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/CaptionLabel.js
function Ax(e) {
	return t.createElement("span", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Chevron.js
function jx(e) {
	let { size: n = 24, orientation: r = "left", className: i, style: a } = e;
	return t.createElement("svg", {
		className: i,
		style: a,
		width: n,
		height: n,
		viewBox: "0 0 24 24"
	}, r === "up" && t.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }), r === "down" && t.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }), r === "left" && t.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }), r === "right" && t.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" }));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Day.js
function Mx(e) {
	let { day: n, modifiers: r, ...i } = e;
	return t.createElement("td", { ...i });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/DayButton.js
function Nx(e) {
	let { day: n, modifiers: r, ...i } = e, a = t.useRef(null);
	return t.useEffect(() => {
		r.focused && a.current?.focus();
	}, [r.focused]), t.createElement("button", {
		ref: a,
		...i
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/UI.js
var $;
(function(e) {
	e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})($ ||= {});
var Px;
(function(e) {
	e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Px ||= {});
var Fx;
(function(e) {
	e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Fx ||= {});
var Ix;
(function(e) {
	e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Ix ||= {});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/useDayPicker.js
var Lx = n(void 0);
function Rx() {
	let e = o(Lx);
	if (e === void 0) throw Error("useDayPicker() must be used within a custom component.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Dropdown.js
function zx(e) {
	let { options: n, className: r, ...i } = e, { classNames: a, components: o, styles: s } = Rx(), c = [a[$.Dropdown], r].join(" "), l = n?.find(({ value: e }) => e === i.value);
	return t.createElement("span", {
		"data-disabled": i.disabled,
		className: a[$.DropdownRoot],
		style: s?.[$.DropdownRoot]
	}, t.createElement(o.Select, {
		className: c,
		...i
	}, n?.map(({ value: e, label: n, disabled: r }) => t.createElement(o.Option, {
		key: e,
		value: e,
		disabled: r
	}, n))), t.createElement("span", {
		className: a[$.CaptionLabel],
		style: s?.[$.CaptionLabel],
		"aria-hidden": !0
	}, l?.label, t.createElement(o.Chevron, {
		orientation: "down",
		size: 18,
		className: a[$.Chevron],
		style: s?.[$.Chevron]
	})));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/DropdownNav.js
function Bx(e) {
	return t.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Footer.js
function Vx(e) {
	return t.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Month.js
function Hx(e) {
	let { calendarMonth: n, displayIndex: r, ...i } = e;
	return t.createElement("div", { ...i }, e.children);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/MonthCaption.js
function Ux(e) {
	let { calendarMonth: n, displayIndex: r, ...i } = e;
	return t.createElement("div", { ...i });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/MonthGrid.js
function Wx(e) {
	return t.createElement("table", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Months.js
function Gx(e) {
	return t.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/MonthsDropdown.js
function Kx(e) {
	let { components: n } = Rx();
	return t.createElement(n.Dropdown, { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Nav.js
function qx(e) {
	let { onPreviousClick: n, onNextClick: r, previousMonth: i, nextMonth: o, ...s } = e, { components: c, classNames: l, styles: u, labels: { labelPrevious: d, labelNext: f } } = Rx(), p = a((e) => {
		o && r?.(e);
	}, [o, r]), m = a((e) => {
		i && n?.(e);
	}, [i, n]);
	return t.createElement("nav", { ...s }, t.createElement(c.PreviousMonthButton, {
		type: "button",
		className: l[$.PreviousMonthButton],
		style: u?.[$.PreviousMonthButton],
		tabIndex: i ? void 0 : -1,
		"aria-disabled": !i || void 0,
		"aria-label": d(i),
		onClick: m
	}, t.createElement(c.Chevron, {
		disabled: !i || void 0,
		className: l[$.Chevron],
		style: u?.[$.Chevron],
		orientation: "left"
	})), t.createElement(c.NextMonthButton, {
		type: "button",
		className: l[$.NextMonthButton],
		style: u?.[$.NextMonthButton],
		tabIndex: o ? void 0 : -1,
		"aria-disabled": !o || void 0,
		"aria-label": f(o),
		onClick: p
	}, t.createElement(c.Chevron, {
		disabled: !o || void 0,
		orientation: "right",
		className: l[$.Chevron],
		style: u?.[$.Chevron]
	})));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/NextMonthButton.js
function Jx(e) {
	return t.createElement("button", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Option.js
function Yx(e) {
	return t.createElement("option", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/PreviousMonthButton.js
function Xx(e) {
	return t.createElement("button", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Root.js
function Zx(e) {
	let { rootRef: n, ...r } = e;
	return t.createElement("div", {
		...r,
		ref: n
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Select.js
function Qx(e) {
	return t.createElement("select", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Week.js
function $x(e) {
	let { week: n, ...r } = e;
	return t.createElement("tr", { ...r });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Weekday.js
function eS(e) {
	return t.createElement("th", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Weekdays.js
function tS(e) {
	return t.createElement("thead", { "aria-hidden": !0 }, t.createElement("tr", { ...e }));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/WeekNumber.js
function nS(e) {
	let { week: n, ...r } = e;
	return t.createElement("th", { ...r });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/WeekNumberHeader.js
function rS(e) {
	return t.createElement("th", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/Weeks.js
function iS(e) {
	return t.createElement("tbody", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/YearsDropdown.js
function aS(e) {
	let { components: n } = Rx();
	return t.createElement(n.Dropdown, { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/components/custom-components.js
var oS = /* @__PURE__ */ _({
	CaptionLabel: () => Ax,
	Chevron: () => jx,
	Day: () => Mx,
	DayButton: () => Nx,
	Dropdown: () => zx,
	DropdownNav: () => Bx,
	Footer: () => Vx,
	Month: () => Hx,
	MonthCaption: () => Ux,
	MonthGrid: () => Wx,
	Months: () => Gx,
	MonthsDropdown: () => Kx,
	Nav: () => qx,
	NextMonthButton: () => Jx,
	Option: () => Yx,
	PreviousMonthButton: () => Xx,
	Root: () => Zx,
	Select: () => Qx,
	Week: () => $x,
	WeekNumber: () => nS,
	WeekNumberHeader: () => rS,
	Weekday: () => eS,
	Weekdays: () => tS,
	Weeks: () => iS,
	YearsDropdown: () => aS
});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/rangeIncludesDate.js
function sS(e, t, n = !1, r = Ex) {
	let { from: i, to: a } = e, { differenceInCalendarDays: o, isSameDay: s } = r;
	return i && a ? (o(a, i) < 0 && ([i, a] = [a, i]), o(t, i) >= +!!n && o(a, t) >= +!!n) : !n && a ? s(a, t) : !n && i ? s(i, t) : !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/typeguards.js
function cS(e) {
	return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function lS(e) {
	return !!(e && typeof e == "object" && "from" in e);
}
function uS(e) {
	return !!(e && typeof e == "object" && "after" in e);
}
function dS(e) {
	return !!(e && typeof e == "object" && "before" in e);
}
function fS(e) {
	return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function pS(e, t) {
	return Array.isArray(e) && e.every(t.isDate);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/dateMatchModifiers.js
function mS(e, t, n = Ex) {
	let r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: a, isAfter: o } = n;
	return r.some((t) => {
		if (typeof t == "boolean") return t;
		if (n.isDate(t)) return i(e, t);
		if (pS(t, n)) return t.some((t) => i(e, t));
		if (lS(t)) return sS(t, e, !1, n);
		if (fS(t)) return Array.isArray(t.dayOfWeek) ? t.dayOfWeek.includes(e.getDay()) : t.dayOfWeek === e.getDay();
		if (cS(t)) {
			let n = a(t.before, e), r = a(t.after, e), i = n > 0, s = r < 0;
			return o(t.before, t.after) ? s && i : i || s;
		}
		return uS(t) ? a(e, t.after) > 0 : dS(t) ? a(t.before, e) > 0 : typeof t == "function" && t(e);
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/createGetModifiers.js
function hS(e, t, n, r, i) {
	let { disabled: a, hidden: o, modifiers: s, showOutsideDays: c, broadcastCalendar: l, today: u = i.today() } = t, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: m, endOfMonth: h, isAfter: g } = i, _ = n && p(n), v = r && h(r), y = {
		[Px.focused]: [],
		[Px.outside]: [],
		[Px.disabled]: [],
		[Px.hidden]: [],
		[Px.today]: []
	}, b = {};
	for (let t of e) {
		let { date: e, displayMonth: n } = t, r = !(!n || f(e, n)), p = !!(_ && m(e, _)), h = !!(v && g(e, v)), x = !!(a && mS(e, a, i)), S = !!(o && mS(e, o, i)) || p || h || !l && !c && r || l && c === !1 && r, C = d(e, u);
		r && y.outside.push(t), x && y.disabled.push(t), S && y.hidden.push(t), C && y.today.push(t), s && Object.keys(s).forEach((n) => {
			let r = s?.[n];
			r && mS(e, r, i) && (b[n] ? b[n].push(t) : b[n] = [t]);
		});
	}
	return (e) => {
		let t = {
			[Px.focused]: !1,
			[Px.disabled]: !1,
			[Px.hidden]: !1,
			[Px.outside]: !1,
			[Px.today]: !1
		}, n = {};
		for (let n in y) t[n] = y[n].some((t) => t === e);
		for (let t in b) n[t] = b[t].some((t) => t === e);
		return {
			...t,
			...n
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getClassNamesForModifiers.js
function gS(e, t, n = {}) {
	return Object.entries(e).filter(([, e]) => e === !0).reduce((e, [r]) => (n[r] ? e.push(n[r]) : t[Px[r]] ? e.push(t[Px[r]]) : t[Fx[r]] && e.push(t[Fx[r]]), e), [t[$.Day]]);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getComponents.js
function _S(e) {
	return {
		...oS,
		...e
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getDataAttributes.js
function vS(e) {
	let t = {
		"data-mode": e.mode ?? void 0,
		"data-required": "required" in e ? e.required : void 0,
		"data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
		"data-week-numbers": e.showWeekNumber || void 0,
		"data-broadcast-calendar": e.broadcastCalendar || void 0,
		"data-nav-layout": e.navLayout || void 0
	};
	return Object.entries(e).forEach(([e, n]) => {
		e.startsWith("data-") && (t[e] = n);
	}), t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getDefaultClassNames.js
function yS() {
	let e = {};
	for (let t in $) e[$[t]] = `rdp-${$[t]}`;
	for (let t in Px) e[Px[t]] = `rdp-${Px[t]}`;
	for (let t in Fx) e[Fx[t]] = `rdp-${Fx[t]}`;
	for (let t in Ix) e[Ix[t]] = `rdp-${Ix[t]}`;
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatCaption.js
function bS(e, t, n) {
	return (n ?? new Tx(t)).formatMonthYear(e);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatDay.js
function xS(e, t, n) {
	return (n ?? new Tx(t)).format(e, "d");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatMonthDropdown.js
function SS(e, t = Ex) {
	return t.format(e, "LLLL");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatWeekdayName.js
function CS(e, t, n) {
	return (n ?? new Tx(t)).format(e, "cccccc");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatWeekNumber.js
function wS(e, t = Ex) {
	return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatWeekNumberHeader.js
function TS() {
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/formatYearDropdown.js
function ES(e, t = Ex) {
	return t.format(e, "yyyy");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/formatters/index.js
var DS = /* @__PURE__ */ _({
	formatCaption: () => bS,
	formatDay: () => xS,
	formatMonthDropdown: () => SS,
	formatWeekNumber: () => wS,
	formatWeekNumberHeader: () => TS,
	formatWeekdayName: () => CS,
	formatYearDropdown: () => ES
});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getFormatters.js
function OS(e) {
	return {
		...DS,
		...e
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelDayButton.js
function kS(e, t, n, r) {
	let i = (r ?? new Tx(n)).format(e, "PPPP");
	return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelGrid.js
function AS(e, t, n) {
	return (n ?? new Tx(t)).formatMonthYear(e);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelGridcell.js
function jS(e, t, n, r) {
	let i = (r ?? new Tx(n)).format(e, "PPPP");
	return t?.today && (i = `Today, ${i}`), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelMonthDropdown.js
function MS(e) {
	return "Choose the Month";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelNav.js
function NS() {
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelNext.js
var PS = "Go to the Next Month";
function FS(e, t) {
	return PS;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelPrevious.js
function IS(e) {
	return "Go to the Previous Month";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelWeekday.js
function LS(e, t, n) {
	return (n ?? new Tx(t)).format(e, "cccc");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelWeekNumber.js
function RS(e, t) {
	return `Week ${e}`;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelWeekNumberHeader.js
function zS(e) {
	return "Week Number";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/labelYearDropdown.js
function BS(e) {
	return "Choose the Year";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/labels/index.js
var VS = /* @__PURE__ */ _({
	labelDayButton: () => kS,
	labelGrid: () => AS,
	labelGridcell: () => jS,
	labelMonthDropdown: () => MS,
	labelNav: () => NS,
	labelNext: () => FS,
	labelPrevious: () => IS,
	labelWeekNumber: () => RS,
	labelWeekNumberHeader: () => zS,
	labelWeekday: () => LS,
	labelYearDropdown: () => BS
}), HS = (e, t, n) => t || (n ? typeof n == "function" ? n : (...e) => n : e);
function US(e, t) {
	let n = t.locale?.labels ?? {};
	return {
		...VS,
		...e ?? {},
		labelDayButton: HS(kS, e?.labelDayButton, n.labelDayButton),
		labelMonthDropdown: HS(MS, e?.labelMonthDropdown, n.labelMonthDropdown),
		labelNext: HS(FS, e?.labelNext, n.labelNext),
		labelPrevious: HS(IS, e?.labelPrevious, n.labelPrevious),
		labelWeekNumber: HS(RS, e?.labelWeekNumber, n.labelWeekNumber),
		labelYearDropdown: HS(BS, e?.labelYearDropdown, n.labelYearDropdown),
		labelGrid: HS(AS, e?.labelGrid, n.labelGrid),
		labelGridcell: HS(jS, e?.labelGridcell, n.labelGridcell),
		labelNav: HS(NS, e?.labelNav, n.labelNav),
		labelWeekNumberHeader: HS(zS, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
		labelWeekday: HS(LS, e?.labelWeekday, n.labelWeekday)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getMonthOptions.js
function WS(e, t, n, r, i) {
	let { startOfMonth: a, startOfYear: o, endOfYear: s, eachMonthOfInterval: c, getMonth: l } = i;
	return c({
		start: o(e),
		end: s(e)
	}).map((e) => {
		let o = r.formatMonthDropdown(e, i);
		return {
			value: l(e),
			label: o,
			disabled: t && e < a(t) || n && e > a(n) || !1
		};
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getStyleForModifiers.js
function GS(e, t = {}, n = {}) {
	let r = { ...t?.[$.Day] };
	return Object.entries(e).filter(([, e]) => e === !0).forEach(([e]) => {
		r = {
			...r,
			...n?.[e]
		};
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getWeekdays.js
function KS(e, t, n, r) {
	let i = r ?? e.today(), a = n ? e.startOfBroadcastWeek(i, e) : t ? e.startOfISOWeek(i) : e.startOfWeek(i), o = [];
	for (let t = 0; t < 7; t++) {
		let n = e.addDays(a, t);
		o.push(n);
	}
	return o;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getYearOptions.js
function qS(e, t, n, r, i = !1) {
	if (!e || !t) return;
	let { startOfYear: a, endOfYear: o, eachYearOfInterval: s, getYear: c } = r, l = s({
		start: a(e),
		end: o(t)
	});
	return i && l.reverse(), l.map((e) => {
		let t = n.formatYearDropdown(e, r);
		return {
			value: c(e),
			label: t,
			disabled: !1
		};
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/noonDateLib.js
function JS(e, t = {}) {
	let { weekStartsOn: n, locale: r } = t, i = n ?? r?.options?.weekStartsOn ?? 0, a = (t) => {
		let n = typeof t == "number" || typeof t == "string" ? new Date(t) : t;
		return new Vy(n.getFullYear(), n.getMonth(), n.getDate(), 12, 0, 0, e);
	}, o = (e) => {
		let t = a(e);
		return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
	};
	return {
		today: () => a(Vy.tz(e)),
		newDate: (t, n, r) => new Vy(t, n, r, 12, 0, 0, e),
		startOfDay: (e) => a(e),
		startOfWeek: (e, t) => {
			let n = a(e), r = t?.weekStartsOn ?? i, o = (n.getDay() - r + 7) % 7;
			return n.setDate(n.getDate() - o), n;
		},
		startOfISOWeek: (e) => {
			let t = a(e), n = (t.getDay() - 1 + 7) % 7;
			return t.setDate(t.getDate() - n), t;
		},
		startOfMonth: (e) => {
			let t = a(e);
			return t.setDate(1), t;
		},
		startOfYear: (e) => {
			let t = a(e);
			return t.setMonth(0, 1), t;
		},
		endOfWeek: (e, t) => {
			let n = a(e), r = (((t?.weekStartsOn ?? i) + 6) % 7 - n.getDay() + 7) % 7;
			return n.setDate(n.getDate() + r), n;
		},
		endOfISOWeek: (e) => {
			let t = a(e), n = (7 - t.getDay()) % 7;
			return t.setDate(t.getDate() + n), t;
		},
		endOfMonth: (e) => {
			let t = a(e);
			return t.setMonth(t.getMonth() + 1, 0), t;
		},
		endOfYear: (e) => {
			let t = a(e);
			return t.setMonth(11, 31), t;
		},
		eachMonthOfInterval: (t) => {
			let n = a(t.start), r = a(t.end), i = [], o = new Vy(n.getFullYear(), n.getMonth(), 1, 12, 0, 0, e), s = r.getFullYear() * 12 + r.getMonth();
			for (; o.getFullYear() * 12 + o.getMonth() <= s;) i.push(new Vy(o, e)), o.setMonth(o.getMonth() + 1, 1);
			return i;
		},
		addDays: (e, t) => {
			let n = a(e);
			return n.setDate(n.getDate() + t), n;
		},
		addWeeks: (e, t) => {
			let n = a(e);
			return n.setDate(n.getDate() + t * 7), n;
		},
		addMonths: (e, t) => {
			let n = a(e);
			return n.setMonth(n.getMonth() + t), n;
		},
		addYears: (e, t) => {
			let n = a(e);
			return n.setFullYear(n.getFullYear() + t), n;
		},
		eachYearOfInterval: (t) => {
			let n = a(t.start), r = a(t.end), i = [], o = new Vy(n.getFullYear(), 0, 1, 12, 0, 0, e);
			for (; o.getFullYear() <= r.getFullYear();) i.push(new Vy(o, e)), o.setFullYear(o.getFullYear() + 1, 0, 1);
			return i;
		},
		getWeek: (e, t) => Bb(o(e), {
			weekStartsOn: t?.weekStartsOn ?? i,
			firstWeekContainsDate: t?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
		}),
		getISOWeek: (e) => Lb(o(e)),
		differenceInCalendarDays: (e, t) => ib(o(e), o(t)),
		differenceInCalendarMonths: (e, t) => pb(o(e), o(t))
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/useAnimation.js
var YS = (e) => e instanceof HTMLElement ? e : null, XS = (e) => [...e.querySelectorAll("[data-animated-month]") ?? []], ZS = (e) => YS(e.querySelector("[data-animated-month]")), QS = (e) => YS(e.querySelector("[data-animated-caption]")), $S = (e) => YS(e.querySelector("[data-animated-weeks]")), eC = (e) => YS(e.querySelector("[data-animated-nav]")), tC = (e) => YS(e.querySelector("[data-animated-weekdays]"));
function nC(e, t, { classNames: n, months: r, focused: i, dateLib: a }) {
	let o = u(null), s = u(r), l = u(!1);
	c(() => {
		let c = s.current;
		if (s.current = r, !t || !e.current || !(e.current instanceof HTMLElement) || r.length === 0 || c.length === 0 || r.length !== c.length) return;
		let u = a.isSameMonth(r[0].date, c[0].date), d = a.isAfter(r[0].date, c[0].date), f = d ? n[Ix.caption_after_enter] : n[Ix.caption_before_enter], p = d ? n[Ix.weeks_after_enter] : n[Ix.weeks_before_enter], m = o.current, h = e.current.cloneNode(!0);
		if (h instanceof HTMLElement ? (XS(h).forEach((e) => {
			if (!(e instanceof HTMLElement)) return;
			let t = ZS(e);
			t && e.contains(t) && e.removeChild(t);
			let n = QS(e);
			n && n.classList.remove(f);
			let r = $S(e);
			r && r.classList.remove(p);
		}), o.current = h) : o.current = null, l.current || u || i) return;
		let g = m instanceof HTMLElement ? XS(m) : [], _ = XS(e.current);
		if (_?.every((e) => e instanceof HTMLElement) && g?.every((e) => e instanceof HTMLElement)) {
			l.current = !0;
			let t = [];
			e.current.style.isolation = "isolate";
			let r = eC(e.current);
			r && (r.style.zIndex = "1"), _.forEach((i, a) => {
				let o = g[a];
				if (!o) return;
				i.style.position = "relative", i.style.overflow = "hidden";
				let s = QS(i);
				s && s.classList.add(f);
				let c = $S(i);
				c && c.classList.add(p);
				let u = () => {
					l.current = !1, e.current && (e.current.style.isolation = ""), r && (r.style.zIndex = ""), s && s.classList.remove(f), c && c.classList.remove(p), i.style.position = "", i.style.overflow = "", i.contains(o) && i.removeChild(o);
				};
				t.push(u), o.style.pointerEvents = "none", o.style.position = "absolute", o.style.overflow = "hidden", o.setAttribute("aria-hidden", "true");
				let m = tC(o);
				m && (m.style.opacity = "0");
				let h = QS(o);
				h && (h.classList.add(d ? n[Ix.caption_before_exit] : n[Ix.caption_after_exit]), h.addEventListener("animationend", u));
				let _ = $S(o);
				_ && _.classList.add(d ? n[Ix.weeks_before_exit] : n[Ix.weeks_after_exit]), i.insertBefore(o, i.firstChild);
			});
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getDates.js
function rC(e, t, n, r) {
	let i = e[0], a = e[e.length - 1], { ISOWeek: o, fixedWeeks: s, broadcastCalendar: c } = n ?? {}, { addDays: l, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: m, endOfWeek: h, isAfter: g, startOfBroadcastWeek: _, startOfISOWeek: v, startOfWeek: y } = r, b = c ? _(i, r) : o ? v(i) : y(i), x = c ? f(a) : o ? p(m(a)) : h(m(a)), S = t && (c ? f(t) : o ? p(t) : h(t)), C = u(S && g(x, S) ? S : x, b), w = d(a, i) + 1, T = [];
	for (let e = 0; e <= C; e++) {
		let t = l(b, e);
		T.push(t);
	}
	let E = (c ? 35 : 42) * w;
	if (s && T.length < E) {
		let e = E - T.length;
		for (let t = 0; t < e; t++) {
			let e = l(T[T.length - 1], 1);
			T.push(e);
		}
	}
	return T;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getDays.js
function iC(e) {
	let t = [];
	return e.reduce((e, n) => {
		let r = n.weeks.reduce((e, t) => e.concat(t.days.slice()), t.slice());
		return e.concat(r.slice());
	}, t.slice());
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getDisplayMonths.js
function aC(e, t, n, r) {
	let { numberOfMonths: i = 1 } = n, a = [];
	for (let n = 0; n < i; n++) {
		let i = r.addMonths(e, n);
		if (t && i > t) break;
		a.push(i);
	}
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getInitialMonth.js
function oC(e, t, n, r) {
	let { month: i, defaultMonth: a, today: o = r.today(), numberOfMonths: s = 1 } = e, c = i || a || o, { differenceInCalendarMonths: l, addMonths: u, startOfMonth: d } = r;
	return n && l(n, c) < s - 1 && (c = u(n, -1 * (s - 1))), t && l(c, t) < 0 && (c = t), d(c);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getMonths.js
function sC(e, t, n, r) {
	let { addDays: i, endOfBroadcastWeek: a, endOfISOWeek: o, endOfMonth: s, endOfWeek: c, getISOWeek: l, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = r, m = e.reduce((e, m) => {
		let h = n.broadcastCalendar ? d(m, r) : n.ISOWeek ? f(m) : p(m), g = n.broadcastCalendar ? a(m) : n.ISOWeek ? o(s(m)) : c(s(m)), _ = t.filter((e) => e >= h && e <= g), v = n.broadcastCalendar ? 35 : 42;
		if (n.fixedWeeks && _.length < v) {
			let e = t.filter((e) => {
				let t = v - _.length;
				return e > g && e <= i(g, t);
			});
			_.push(...e);
		}
		let y = new Ox(m, _.reduce((e, t) => {
			let i = n.ISOWeek ? l(t) : u(t), a = e.find((e) => e.weekNumber === i), o = new Dx(t, m, r);
			return a ? a.days.push(o) : e.push(new kx(i, [o])), e;
		}, []));
		return e.push(y), e;
	}, []);
	return n.reverseMonths ? m.reverse() : m;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getNavMonth.js
function cC(e, t) {
	let { startMonth: n, endMonth: r } = e, { startOfYear: i, startOfDay: a, startOfMonth: o, endOfMonth: s, addYears: c, endOfYear: l, today: u } = t, d = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
	return n ? n = o(n) : !n && d && (n = i(c(e.today ?? u(), -100))), r ? r = s(r) : !r && d && (r = l(e.today ?? u())), [n && a(n), r && a(r)];
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getNextMonth.js
function lC(e, t, n, r) {
	if (n.disableNavigation) return;
	let { pagedNavigation: i, numberOfMonths: a = 1 } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a : 1, u = o(e);
	if (!t || !(c(t, e) < a)) return s(u, l);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getPreviousMonth.js
function uC(e, t, n, r) {
	if (n.disableNavigation) return;
	let { pagedNavigation: i, numberOfMonths: a } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a ?? 1 : 1, u = o(e);
	if (!t || !(c(u, t) <= 0)) return s(u, -l);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getWeeks.js
function dC(e) {
	return e.reduce((e, t) => e.concat(t.weeks.slice()), [].slice());
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/useControlledValue.js
function fC(e, t) {
	let [n, r] = d(e);
	return [t === void 0 ? n : t, r];
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/useCalendar.js
function pC(e, t) {
	let [n, r] = cC(e, t), { startOfMonth: i, endOfMonth: a } = t, o = oC(e, n, r, t), [c, u] = fC(o, e.month ? o : void 0);
	s(() => {
		let i = oC(e, n, r, t);
		u(i);
	}, [e.timeZone]);
	let { months: d, weeks: f, days: p, previousMonth: m, nextMonth: h } = l(() => {
		let i = aC(c, r, { numberOfMonths: e.numberOfMonths }, t), o = sC(i, rC(i, e.endMonth ? a(e.endMonth) : void 0, {
			ISOWeek: e.ISOWeek,
			fixedWeeks: e.fixedWeeks,
			broadcastCalendar: e.broadcastCalendar
		}, t), {
			broadcastCalendar: e.broadcastCalendar,
			fixedWeeks: e.fixedWeeks,
			ISOWeek: e.ISOWeek,
			reverseMonths: e.reverseMonths
		}, t);
		return {
			months: o,
			weeks: dC(o),
			days: iC(o),
			previousMonth: uC(c, n, e, t),
			nextMonth: lC(c, r, e, t)
		};
	}, [
		t,
		c.getTime(),
		r?.getTime(),
		n?.getTime(),
		e.disableNavigation,
		e.broadcastCalendar,
		e.endMonth?.getTime(),
		e.fixedWeeks,
		e.ISOWeek,
		e.numberOfMonths,
		e.pagedNavigation,
		e.reverseMonths
	]), { disableNavigation: g, onMonthChange: _ } = e, v = (e) => f.some((t) => t.days.some((t) => t.isEqualTo(e))), y = (e) => {
		if (g) return;
		let t = i(e);
		n && t < i(n) && (t = i(n)), r && t > i(r) && (t = i(r)), u(t), _?.(t);
	};
	return {
		months: d,
		weeks: f,
		days: p,
		navStart: n,
		navEnd: r,
		previousMonth: m,
		nextMonth: h,
		goToMonth: y,
		goToDay: (e) => {
			v(e) || y(e.date);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/calculateFocusTarget.js
var mC;
(function(e) {
	e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(mC ||= {});
function hC(e) {
	return !e[Px.disabled] && !e[Px.hidden] && !e[Px.outside];
}
function gC(e, t, n, r) {
	let i, a = -1;
	for (let o of e) {
		let e = t(o);
		hC(e) && (e[Px.focused] && a < mC.FocusedModifier ? (i = o, a = mC.FocusedModifier) : r?.isEqualTo(o) && a < mC.LastFocused ? (i = o, a = mC.LastFocused) : n(o.date) && a < mC.Selected ? (i = o, a = mC.Selected) : e[Px.today] && a < mC.Today && (i = o, a = mC.Today));
	}
	return i ||= e.find((e) => hC(t(e))), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getFocusableDate.js
function _C(e, t, n, r, i, a, o) {
	let { ISOWeek: s, broadcastCalendar: c } = a, { addDays: l, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: m, endOfWeek: h, max: g, min: _, startOfBroadcastWeek: v, startOfISOWeek: y, startOfWeek: b } = o, x = {
		day: l,
		week: d,
		month: u,
		year: f,
		startOfWeek: (e) => c ? v(e, o) : s ? y(e) : b(e),
		endOfWeek: (e) => c ? p(e) : s ? m(e) : h(e)
	}[e](n, t === "after" ? 1 : -1);
	return t === "before" && r ? x = g([r, x]) : t === "after" && i && (x = _([i, x])), x;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/helpers/getNextFocus.js
function vC(e, t, n, r, i, a, o, s = 0) {
	if (s > 365) return;
	let c = _C(e, t, n.date, r, i, a, o), l = !!(a.disabled && mS(c, a.disabled, o)), u = !!(a.hidden && mS(c, a.hidden, o)), d = new Dx(c, c, o);
	return !l && !u ? d : vC(e, t, d, r, i, a, o, s + 1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/useFocus.js
function yC(e, t, n, r, i) {
	let { autoFocus: a } = e, [o, s] = d(), c = gC(t.days, n, r || (() => !1), o), [l, u] = d(a ? c : void 0);
	return {
		isFocusTarget: (e) => !!c?.isEqualTo(e),
		setFocused: u,
		focused: l,
		blur: () => {
			s(l), u(void 0);
		},
		moveFocus: (n, r) => {
			if (!l) return;
			let a = vC(n, r, l, t.navStart, t.navEnd, e, i);
			a && (!e.disableNavigation || t.days.some((e) => e.isEqualTo(a))) && (t.goToDay(a), u(a));
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/selection/useMulti.js
function bC(e, t) {
	let { selected: n, required: r, onSelect: i } = e, [a, o] = fC(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t, l = (e) => s?.some((t) => c(t, e)) ?? !1, { min: u, max: d } = e;
	return {
		selected: s,
		select: (e, t, n) => {
			let a = [...s ?? []];
			if (l(e)) {
				if (s?.length === u || r && s?.length === 1) return;
				a = s?.filter((t) => !c(t, e));
			} else a = s?.length === d ? [e] : [...a, e];
			return i || o(a), i?.(a, e, t, n), a;
		},
		isSelected: l
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/addToRange.js
function xC(e, t, n = 0, r = 0, i = !1, a = Ex) {
	let { from: o, to: s } = t || {}, { isSameDay: c, isAfter: l, isBefore: u } = a, d;
	if (!o && !s) d = {
		from: e,
		to: n > 0 ? void 0 : e
	};
	else if (o && !s) d = c(o, e) ? n === 0 ? {
		from: o,
		to: e
	} : i ? {
		from: o,
		to: void 0
	} : void 0 : u(e, o) ? {
		from: e,
		to: o
	} : {
		from: o,
		to: e
	};
	else if (o && s) {
		if (c(o, e) && c(s, e)) d = i ? {
			from: o,
			to: s
		} : void 0;
		else if (c(o, e)) d = {
			from: o,
			to: n > 0 ? void 0 : e
		};
		else if (c(s, e)) d = {
			from: e,
			to: n > 0 ? void 0 : e
		};
		else if (u(e, o)) d = {
			from: e,
			to: s
		};
		else if (l(e, o)) d = {
			from: o,
			to: e
		};
		else if (l(e, s)) d = {
			from: o,
			to: e
		};
		else throw Error("Invalid range");
	}
	if (d?.from && d?.to) {
		let t = a.differenceInCalendarDays(d.to, d.from);
		(r > 0 && t > r || n > 1 && t < n) && (d = {
			from: e,
			to: void 0
		});
	}
	return d;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/rangeContainsDayOfWeek.js
function SC(e, t, n = Ex) {
	let r = Array.isArray(t) ? t : [t], i = e.from, a = n.differenceInCalendarDays(e.to, e.from), o = Math.min(a, 6);
	for (let e = 0; e <= o; e++) {
		if (r.includes(i.getDay())) return !0;
		i = n.addDays(i, 1);
	}
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/rangeOverlaps.js
function CC(e, t, n = Ex) {
	return sS(e, t.from, !1, n) || sS(e, t.to, !1, n) || sS(t, e.from, !1, n) || sS(t, e.to, !1, n);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/rangeContainsModifiers.js
function wC(e, t, n = Ex) {
	let r = Array.isArray(t) ? t : [t];
	if (r.filter((e) => typeof e != "function").some((t) => typeof t == "boolean" ? t : n.isDate(t) ? sS(e, t, !1, n) : pS(t, n) ? t.some((t) => sS(e, t, !1, n)) : lS(t) ? t.from && t.to ? CC(e, {
		from: t.from,
		to: t.to
	}, n) : !1 : fS(t) ? SC(e, t.dayOfWeek, n) : cS(t) ? n.isAfter(t.before, t.after) ? CC(e, {
		from: n.addDays(t.after, 1),
		to: n.addDays(t.before, -1)
	}, n) : mS(e.from, t, n) || mS(e.to, t, n) : uS(t) || dS(t) ? mS(e.from, t, n) || mS(e.to, t, n) : !1)) return !0;
	let i = r.filter((e) => typeof e == "function");
	if (i.length) {
		let t = e.from, r = n.differenceInCalendarDays(e.to, e.from);
		for (let e = 0; e <= r; e++) {
			if (i.some((e) => e(t))) return !0;
			t = n.addDays(t, 1);
		}
	}
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/selection/useRange.js
function TC(e, t) {
	let { disabled: n, excludeDisabled: r, resetOnSelect: i, selected: a, required: o, onSelect: s } = e, [c, l] = fC(a, s ? a : void 0), u = s ? a : c;
	return {
		selected: u,
		select: (a, c, d) => {
			let { min: f, max: p } = e, m;
			if (a) {
				let e = u?.from, n = u?.to, r = !!e && !!n, s = !!e && !!n && t.isSameDay(e, n) && t.isSameDay(a, e);
				m = i && (r || !u?.from) ? !o && s ? void 0 : {
					from: a,
					to: void 0
				} : xC(a, u, f, p, o, t);
			}
			return r && n && m?.from && m.to && wC({
				from: m.from,
				to: m.to
			}, n, t) && (m.from = a, m.to = void 0), s || l(m), s?.(m, a, c, d), m;
		},
		isSelected: (e) => u && sS(u, e, !1, t)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/selection/useSingle.js
function EC(e, t) {
	let { selected: n, required: r, onSelect: i } = e, [a, o] = fC(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t;
	return {
		selected: s,
		select: (e, t, n) => {
			let a = e;
			return !r && s && s && c(e, s) && (a = void 0), i || o(a), i?.(a, e, t, n), a;
		},
		isSelected: (e) => s ? c(s, e) : !1
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/useSelection.js
function DC(e, t) {
	let n = EC(e, t), r = bC(e, t), i = TC(e, t);
	switch (e.mode) {
		case "single": return n;
		case "multiple": return r;
		case "range": return i;
		default: return;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/toTimeZone.js
function OC(e, t) {
	return e instanceof Vy && e.timeZone === t ? e : new Vy(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/utils/convertMatchersToTimeZone.js
function kC(e, t, n) {
	if (!n) return OC(e, t);
	let r = OC(e, t), i = new Vy(r.getFullYear(), r.getMonth(), r.getDate(), 12, 0, 0, t);
	return new Date(i.getTime());
}
function AC(e, t, n) {
	return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? kC(e, t, n) : Array.isArray(e) ? e.map((e) => e instanceof Date ? kC(e, t, n) : e) : lS(e) ? {
		...e,
		from: e.from ? OC(e.from, t) : e.from,
		to: e.to ? OC(e.to, t) : e.to
	} : cS(e) ? {
		before: kC(e.before, t, n),
		after: kC(e.after, t, n)
	} : uS(e) ? { after: kC(e.after, t, n) } : dS(e) ? { before: kC(e.before, t, n) } : e;
}
function jC(e, t, n) {
	return e && (Array.isArray(e) ? e.map((e) => AC(e, t, n)) : AC(e, t, n));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.3.0_react@19.3.0/node_modules/react-day-picker/dist/esm/DayPicker.js
function MC(e) {
	let n = e, r = n.timeZone;
	if (r && (n = {
		...e,
		timeZone: r
	}, n.today && (n.today = OC(n.today, r)), n.month && (n.month = OC(n.month, r)), n.defaultMonth && (n.defaultMonth = OC(n.defaultMonth, r)), n.startMonth && (n.startMonth = OC(n.startMonth, r)), n.endMonth && (n.endMonth = OC(n.endMonth, r)), n.mode === "single" && n.selected ? n.selected = OC(n.selected, r) : n.mode === "multiple" && n.selected ? n.selected = n.selected?.map((e) => OC(e, r)) : n.mode === "range" && n.selected && (n.selected = {
		from: n.selected.from ? OC(n.selected.from, r) : n.selected.from,
		to: n.selected.to ? OC(n.selected.to, r) : n.selected.to
	}), n.disabled !== void 0 && (n.disabled = jC(n.disabled, r)), n.hidden !== void 0 && (n.hidden = jC(n.hidden, r)), n.modifiers)) {
		let e = {};
		Object.keys(n.modifiers).forEach((t) => {
			e[t] = jC(n.modifiers?.[t], r);
		}), n.modifiers = e;
	}
	let { components: i, formatters: o, labels: s, dateLib: c, locale: d, classNames: f } = l(() => {
		let e = {
			...wx,
			...n.locale
		}, t = n.broadcastCalendar ? 1 : n.weekStartsOn, r = n.noonSafe && n.timeZone ? JS(n.timeZone, {
			weekStartsOn: t,
			locale: e
		}) : void 0, i = n.dateLib && r ? {
			...r,
			...n.dateLib
		} : n.dateLib ?? r, a = new Tx({
			locale: e,
			weekStartsOn: t,
			firstWeekContainsDate: n.firstWeekContainsDate,
			useAdditionalWeekYearTokens: n.useAdditionalWeekYearTokens,
			useAdditionalDayOfYearTokens: n.useAdditionalDayOfYearTokens,
			timeZone: n.timeZone,
			numerals: n.numerals
		}, i);
		return {
			dateLib: a,
			components: _S(n.components),
			formatters: OS(n.formatters),
			labels: US(n.labels, a.options),
			locale: e,
			classNames: {
				...yS(),
				...n.classNames
			}
		};
	}, [
		n.locale,
		n.broadcastCalendar,
		n.weekStartsOn,
		n.firstWeekContainsDate,
		n.useAdditionalWeekYearTokens,
		n.useAdditionalDayOfYearTokens,
		n.timeZone,
		n.numerals,
		n.dateLib,
		n.noonSafe,
		n.components,
		n.formatters,
		n.labels,
		n.classNames
	]);
	n.today || (n = {
		...n,
		today: c.today()
	});
	let { captionLayout: p, mode: m, navLayout: h, numberOfMonths: g = 1, onDayBlur: _, onDayClick: v, onDayFocus: y, onDayKeyDown: b, onDayMouseEnter: x, onDayMouseLeave: S, onNextClick: C, onPrevClick: w, showWeekNumber: T, styles: E } = n, { formatCaption: D, formatDay: O, formatMonthDropdown: k, formatWeekNumber: A, formatWeekNumberHeader: j, formatWeekdayName: M, formatYearDropdown: ee } = o, N = pC(n, c), { days: te, months: P, navStart: ne, navEnd: re, previousMonth: ie, nextMonth: ae, goToMonth: F } = N, oe = hS(te, n, ne, re, c), { isSelected: se, select: ce, selected: I } = DC(n, c) ?? {}, { blur: le, focused: ue, isFocusTarget: de, moveFocus: fe, setFocused: pe } = yC(n, N, oe, se ?? (() => !1), c), { labelDayButton: me, labelGridcell: he, labelGrid: ge, labelMonthDropdown: L, labelNav: _e, labelPrevious: ve, labelNext: ye, labelWeekday: be, labelWeekNumber: xe, labelWeekNumberHeader: Se, labelYearDropdown: Ce } = s, we = l(() => KS(c, n.ISOWeek, n.broadcastCalendar, n.today), [
		c,
		n.ISOWeek,
		n.broadcastCalendar,
		n.today
	]), Te = m !== void 0 || v !== void 0, Ee = a(() => {
		ie && (F(ie), w?.(ie));
	}, [
		ie,
		F,
		w
	]), De = a(() => {
		ae && (F(ae), C?.(ae));
	}, [
		F,
		ae,
		C
	]), Oe = a((e, t) => (n) => {
		n.preventDefault(), n.stopPropagation(), pe(e), !t.disabled && (ce?.(e.date, t, n), v?.(e.date, t, n));
	}, [
		ce,
		v,
		pe
	]), ke = a((e, t) => (n) => {
		pe(e), y?.(e.date, t, n);
	}, [y, pe]), Ae = a((e, t) => (n) => {
		le(), _?.(e.date, t, n);
	}, [le, _]), je = a((e, t) => (r) => {
		let i = {
			ArrowLeft: [r.shiftKey ? "month" : "day", n.dir === "rtl" ? "after" : "before"],
			ArrowRight: [r.shiftKey ? "month" : "day", n.dir === "rtl" ? "before" : "after"],
			ArrowDown: [r.shiftKey ? "year" : "week", "after"],
			ArrowUp: [r.shiftKey ? "year" : "week", "before"],
			PageUp: [r.shiftKey ? "year" : "month", "before"],
			PageDown: [r.shiftKey ? "year" : "month", "after"],
			Home: ["startOfWeek", "before"],
			End: ["endOfWeek", "after"]
		};
		if (i[r.key]) {
			r.preventDefault(), r.stopPropagation();
			let [e, t] = i[r.key];
			fe(e, t);
		}
		b?.(e.date, t, r);
	}, [
		fe,
		b,
		n.dir
	]), Me = a((e, t) => (n) => {
		x?.(e.date, t, n);
	}, [x]), Ne = a((e, t) => (n) => {
		S?.(e.date, t, n);
	}, [S]), Pe = a((e, t) => (n) => {
		let r = Number(n.target.value), i = c.setMonth(c.startOfMonth(e), r);
		F(c.addMonths(i, -t));
	}, [c, F]), R = a((e, t) => (n) => {
		let r = Number(n.target.value), i = c.setYear(c.startOfMonth(e), r);
		F(c.addMonths(i, -t));
	}, [c, F]), { className: Fe, style: Ie } = l(() => ({
		className: [f[$.Root], n.className].filter(Boolean).join(" "),
		style: {
			...E?.[$.Root],
			...n.style
		}
	}), [
		f,
		n.className,
		n.style,
		E
	]), Le = vS(n), Re = (e) => {
		let t = E?.[$.Dropdown], n = E?.[e];
		if (t || n) return {
			...t,
			...n
		};
	}, ze = u(null);
	nC(ze, !!n.animate, {
		classNames: f,
		months: P,
		focused: ue,
		dateLib: c
	});
	let Be = {
		dayPickerProps: n,
		selected: I,
		select: ce,
		isSelected: se,
		months: P,
		nextMonth: ae,
		previousMonth: ie,
		goToMonth: F,
		getModifiers: oe,
		components: i,
		classNames: f,
		styles: E,
		labels: s,
		formatters: o
	};
	return t.createElement(Lx.Provider, { value: Be }, t.createElement(i.Root, {
		rootRef: n.animate ? ze : void 0,
		className: Fe,
		style: Ie,
		dir: n.dir,
		id: n.id,
		lang: n.lang ?? d.code,
		nonce: n.nonce,
		title: n.title,
		role: n.role,
		"aria-label": n["aria-label"],
		"aria-labelledby": n["aria-labelledby"],
		...Le
	}, t.createElement(i.Months, {
		className: f[$.Months],
		style: E?.[$.Months]
	}, !n.hideNavigation && !h && t.createElement(i.Nav, {
		"data-animated-nav": n.animate ? "true" : void 0,
		className: f[$.Nav],
		style: E?.[$.Nav],
		"aria-label": _e(),
		onPreviousClick: Ee,
		onNextClick: De,
		previousMonth: ie,
		nextMonth: ae
	}), P.map((e, r) => {
		let a = n.reverseMonths ? P.length - 1 - r : r;
		return t.createElement(i.Month, {
			"data-animated-month": n.animate ? "true" : void 0,
			className: f[$.Month],
			style: E?.[$.Month],
			key: r,
			displayIndex: r,
			calendarMonth: e
		}, h === "around" && !n.hideNavigation && r === 0 && t.createElement(i.PreviousMonthButton, {
			type: "button",
			className: f[$.PreviousMonthButton],
			style: E?.[$.PreviousMonthButton],
			tabIndex: ie ? void 0 : -1,
			"aria-disabled": !ie || void 0,
			"aria-label": ve(ie),
			onClick: Ee,
			"data-animated-button": n.animate ? "true" : void 0
		}, t.createElement(i.Chevron, {
			disabled: !ie || void 0,
			className: f[$.Chevron],
			style: E?.[$.Chevron],
			orientation: n.dir === "rtl" ? "right" : "left"
		})), t.createElement(i.MonthCaption, {
			"data-animated-caption": n.animate ? "true" : void 0,
			className: f[$.MonthCaption],
			style: E?.[$.MonthCaption],
			calendarMonth: e,
			displayIndex: r
		}, p?.startsWith("dropdown") ? t.createElement(i.DropdownNav, {
			className: f[$.Dropdowns],
			style: E?.[$.Dropdowns]
		}, (() => {
			let r = p === "dropdown" || p === "dropdown-months" ? t.createElement(i.MonthsDropdown, {
				key: "month",
				className: f[$.MonthsDropdown],
				"aria-label": L(),
				disabled: !!n.disableNavigation,
				onChange: Pe(e.date, a),
				options: WS(e.date, ne, re, o, c),
				style: Re($.MonthsDropdown),
				value: c.getMonth(e.date)
			}) : t.createElement("span", { key: "month" }, k(e.date, c)), s = p === "dropdown" || p === "dropdown-years" ? t.createElement(i.YearsDropdown, {
				key: "year",
				className: f[$.YearsDropdown],
				"aria-label": Ce(c.options),
				disabled: !!n.disableNavigation,
				onChange: R(e.date, a),
				options: qS(ne, re, o, c, !!n.reverseYears),
				style: Re($.YearsDropdown),
				value: c.getYear(e.date)
			}) : t.createElement("span", { key: "year" }, ee(e.date, c));
			return c.getMonthYearOrder() === "year-first" ? [s, r] : [r, s];
		})(), t.createElement("span", {
			role: "status",
			"aria-live": "polite",
			style: {
				border: 0,
				clip: "rect(0 0 0 0)",
				height: "1px",
				margin: "-1px",
				overflow: "hidden",
				padding: 0,
				position: "absolute",
				width: "1px",
				whiteSpace: "nowrap",
				wordWrap: "normal"
			}
		}, D(e.date, c.options, c))) : t.createElement(i.CaptionLabel, {
			className: f[$.CaptionLabel],
			style: E?.[$.CaptionLabel],
			role: "status",
			"aria-live": "polite"
		}, D(e.date, c.options, c))), h === "around" && !n.hideNavigation && r === g - 1 && t.createElement(i.NextMonthButton, {
			type: "button",
			className: f[$.NextMonthButton],
			style: E?.[$.NextMonthButton],
			tabIndex: ae ? void 0 : -1,
			"aria-disabled": !ae || void 0,
			"aria-label": ye(ae),
			onClick: De,
			"data-animated-button": n.animate ? "true" : void 0
		}, t.createElement(i.Chevron, {
			disabled: !ae || void 0,
			className: f[$.Chevron],
			style: E?.[$.Chevron],
			orientation: n.dir === "rtl" ? "left" : "right"
		})), r === g - 1 && h === "after" && !n.hideNavigation && t.createElement(i.Nav, {
			"data-animated-nav": n.animate ? "true" : void 0,
			className: f[$.Nav],
			style: E?.[$.Nav],
			"aria-label": _e(),
			onPreviousClick: Ee,
			onNextClick: De,
			previousMonth: ie,
			nextMonth: ae
		}), t.createElement(i.MonthGrid, {
			role: "grid",
			"aria-multiselectable": m === "multiple" || m === "range",
			"aria-label": ge(e.date, c.options, c) || void 0,
			className: f[$.MonthGrid],
			style: E?.[$.MonthGrid]
		}, !n.hideWeekdays && t.createElement(i.Weekdays, {
			"data-animated-weekdays": n.animate ? "true" : void 0,
			className: f[$.Weekdays],
			style: E?.[$.Weekdays]
		}, T && t.createElement(i.WeekNumberHeader, {
			"aria-label": Se(c.options),
			className: f[$.WeekNumberHeader],
			style: E?.[$.WeekNumberHeader],
			scope: "col"
		}, j()), we.map((e) => t.createElement(i.Weekday, {
			"aria-label": be(e, c.options, c),
			className: f[$.Weekday],
			key: String(e),
			style: E?.[$.Weekday],
			scope: "col"
		}, M(e, c.options, c)))), t.createElement(i.Weeks, {
			"data-animated-weeks": n.animate ? "true" : void 0,
			className: f[$.Weeks],
			style: E?.[$.Weeks]
		}, e.weeks.map((e) => t.createElement(i.Week, {
			className: f[$.Week],
			key: e.weekNumber,
			style: E?.[$.Week],
			week: e
		}, T && t.createElement(i.WeekNumber, {
			week: e,
			style: E?.[$.WeekNumber],
			"aria-label": xe(e.weekNumber, { locale: d }),
			className: f[$.WeekNumber],
			scope: "row",
			role: "rowheader"
		}, A(e.weekNumber, c)), e.days.map((e) => {
			let { date: r } = e, a = oe(e);
			if (a[Px.focused] = !a.hidden && !!ue?.isEqualTo(e), a[Fx.selected] = se?.(r) || a.selected, lS(I)) {
				let { from: e, to: t } = I;
				a[Fx.range_start] = !!(e && t && c.isSameDay(r, e)), a[Fx.range_end] = !!(e && t && c.isSameDay(r, t)), a[Fx.range_middle] = sS(I, r, !0, c);
			}
			let o = GS(a, E, n.modifiersStyles), s = gS(a, f, n.modifiersClassNames), l = !Te && !a.hidden ? he(r, a, c.options, c) : void 0;
			return t.createElement(i.Day, {
				key: `${e.isoDate}_${e.displayMonthId}`,
				day: e,
				modifiers: a,
				className: s.join(" "),
				style: o,
				role: "gridcell",
				"aria-selected": a.selected || void 0,
				"aria-label": l,
				"data-day": e.isoDate,
				"data-month": e.outside ? e.dateMonthId : void 0,
				"data-selected": a.selected || void 0,
				"data-disabled": a.disabled || void 0,
				"data-hidden": a.hidden || void 0,
				"data-outside": e.outside || void 0,
				"data-focused": a.focused || void 0,
				"data-today": a.today || void 0
			}, !a.hidden && Te ? t.createElement(i.DayButton, {
				className: f[$.DayButton],
				style: E?.[$.DayButton],
				type: "button",
				day: e,
				modifiers: a,
				disabled: !a.focused && a.disabled || void 0,
				"aria-disabled": a.focused && a.disabled || void 0,
				tabIndex: de(e) ? 0 : -1,
				"aria-label": me(r, a, c.options, c),
				onClick: Oe(e, a),
				onBlur: Ae(e, a),
				onFocus: ke(e, a),
				onKeyDown: je(e, a),
				onMouseEnter: Me(e, a),
				onMouseLeave: Ne(e, a)
			}, O(r, c.options, c)) : !a.hidden && O(e.date, c.options, c));
		}))))));
	})), n.footer && t.createElement(i.Footer, {
		className: f[$.Footer],
		style: E?.[$.Footer],
		role: "status",
		"aria-live": "polite"
	}, n.footer)));
}
//#endregion
//#region src/components/ui/calendar.tsx
function NC({ className: e, classNames: t, showOutsideDays: n = !0, captionLayout: r = "label", buttonVariant: i = "ghost", locale: a, formatters: o, components: s, ...c }) {
	let l = yS();
	return /* @__PURE__ */ m(MC, {
		showOutsideDays: n,
		className: X("group/calendar bg-background p-2 [--cell-radius:var(--radius-md)] [--cell-size:--spacing(7)] in-data-[slot=card-content]:bg-transparent in-data-[slot=popover-content]:bg-transparent", String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`, String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`, e),
		captionLayout: r,
		locale: a,
		formatters: {
			formatMonthDropdown: (e) => e.toLocaleString(a?.code, { month: "short" }),
			...o
		},
		classNames: {
			root: X("w-fit", l.root),
			months: X("relative flex flex-col gap-4 md:flex-row", l.months),
			month: X("flex w-full flex-col gap-4", l.month),
			nav: X("absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1", l.nav),
			button_previous: X(ay({ variant: i }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", l.button_previous),
			button_next: X(ay({ variant: i }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", l.button_next),
			month_caption: X("flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)", l.month_caption),
			dropdowns: X("flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium", l.dropdowns),
			dropdown_root: X("relative rounded-(--cell-radius)", l.dropdown_root),
			dropdown: X("absolute inset-0 bg-popover opacity-0", l.dropdown),
			caption_label: X("font-medium select-none", r === "label" ? "text-sm" : "flex items-center gap-1 rounded-(--cell-radius) text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground", l.caption_label),
			month_grid: X("w-full border-collapse", l.month_grid),
			weekdays: X("flex", l.weekdays),
			weekday: X("flex-1 rounded-(--cell-radius) text-[0.8rem] font-normal text-muted-foreground select-none", l.weekday),
			week: X("mt-2 flex w-full", l.week),
			week_number_header: X("w-(--cell-size) select-none", l.week_number_header),
			week_number: X("text-[0.8rem] text-muted-foreground select-none", l.week_number),
			day: X("group/day relative aspect-square h-full w-full rounded-(--cell-radius) p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-(--cell-radius)", c.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-(--cell-radius)" : "[&:first-child[data-selected=true]_button]:rounded-l-(--cell-radius)", l.day),
			range_start: X("relative isolate z-0 rounded-l-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:right-0 after:w-4 after:bg-muted", l.range_start),
			range_middle: X("rounded-none", l.range_middle),
			range_end: X("relative isolate z-0 rounded-r-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:left-0 after:w-4 after:bg-muted", l.range_end),
			today: X("rounded-(--cell-radius) bg-muted text-foreground data-[selected=true]:rounded-none", l.today),
			outside: X("text-muted-foreground aria-selected:text-muted-foreground", l.outside),
			disabled: X("text-muted-foreground opacity-50", l.disabled),
			hidden: X("invisible", l.hidden),
			...t
		},
		components: {
			Root: ({ className: e, rootRef: t, ...n }) => /* @__PURE__ */ m("div", {
				"data-slot": "calendar",
				ref: t,
				className: X(e),
				...n
			}),
			Chevron: ({ className: e, orientation: t, ...n }) => m(t === "left" ? ie : t === "right" ? F : ne, {
				className: X("size-4", e),
				...n
			}),
			DayButton: ({ ...e }) => /* @__PURE__ */ m(PC, {
				locale: a,
				...e
			}),
			WeekNumber: ({ children: e, ...t }) => /* @__PURE__ */ m("td", {
				...t,
				children: /* @__PURE__ */ m("div", {
					className: "flex size-(--cell-size) items-center justify-center text-center",
					children: e
				})
			}),
			...s
		},
		...c
	});
}
function PC({ className: t, day: n, modifiers: r, locale: i, ...a }) {
	let o = yS(), s = e.useRef(null);
	return e.useEffect(() => {
		r.focused && s.current?.focus();
	}, [r.focused]), /* @__PURE__ */ m(oy, {
		ref: s,
		variant: "ghost",
		size: "icon",
		"data-day": n.date.toLocaleDateString(i?.code),
		"data-selected-single": r.selected && !r.range_start && !r.range_end && !r.range_middle,
		"data-range-start": r.range_start,
		"data-range-end": r.range_end,
		"data-range-middle": r.range_middle,
		className: X("relative isolate z-10 flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 border-0 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-(--cell-radius) data-[range-end=true]:rounded-r-(--cell-radius) data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-muted data-[range-middle=true]:text-foreground data-[range-start=true]:rounded-(--cell-radius) data-[range-start=true]:rounded-l-(--cell-radius) data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-foreground [&>span]:text-xs [&>span]:opacity-70", o.day, t),
		...a
	});
}
//#endregion
//#region src/components/ui/card.tsx
function FC({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card",
		"data-size": t,
		className: X("group/card flex flex-col gap-4 overflow-hidden rounded-xl bg-card py-4 text-sm text-card-foreground ring-1 ring-foreground/10 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl", e),
		...n
	});
}
function IC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-header",
		className: X("group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3", e),
		...t
	});
}
function LC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-title",
		className: X("text-base leading-snug font-medium group-data-[size=sm]/card:text-sm", e),
		...t
	});
}
function RC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-description",
		className: X("text-sm text-muted-foreground", e),
		...t
	});
}
function zC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-action",
		className: X("col-start-2 row-span-2 row-start-1 self-start justify-self-end", e),
		...t
	});
}
function BC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-content",
		className: X("px-4 group-data-[size=sm]/card:px-3", e),
		...t
	});
}
function VC({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "card-footer",
		className: X("flex items-center rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/card:p-3", e),
		...t
	});
}
//#endregion
//#region src/components/ui/checkbox.tsx
function HC({ className: e, ...t }) {
	return /* @__PURE__ */ m(To, {
		"data-slot": "checkbox",
		className: X("peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary", e),
		...t,
		children: /* @__PURE__ */ m(Do, {
			"data-slot": "checkbox-indicator",
			className: "grid place-content-center text-current transition-none [&>svg]:size-3.5",
			children: /* @__PURE__ */ m(te, {})
		})
	});
}
//#endregion
//#region src/components/ui/collapsible.tsx
function UC({ ...e }) {
	return /* @__PURE__ */ m(Zt, {
		"data-slot": "collapsible",
		...e
	});
}
function WC({ ...e }) {
	return /* @__PURE__ */ m(Kt, {
		"data-slot": "collapsible-trigger",
		...e
	});
}
function GC({ ...e }) {
	return /* @__PURE__ */ m(Jt, {
		"data-slot": "collapsible-content",
		...e
	});
}
//#endregion
//#region ../../node_modules/.pnpm/cmdk@1.1.1_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3.0_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/cmdk/dist/chunk-NZJY6EH4.mjs
var KC = 1, qC = .9, JC = .8, YC = .17, XC = .1, ZC = .999, QC = .9999, $C = .99, ew = /[\\\/_+.#"@\[\(\{&]/, tw = /[\\\/_+.#"@\[\(\{&]/g, nw = /[\s-]/, rw = /[\s-]/g;
function iw(e, t, n, r, i, a, o) {
	if (a === t.length) return i === e.length ? KC : $C;
	var s = `${i},${a}`;
	if (o[s] !== void 0) return o[s];
	for (var c = r.charAt(a), l = n.indexOf(c, i), u = 0, d, f, p, m; l >= 0;) d = iw(e, t, n, r, l + 1, a + 1, o), d > u && (l === i ? d *= KC : ew.test(e.charAt(l - 1)) ? (d *= JC, p = e.slice(i, l - 1).match(tw), p && i > 0 && (d *= ZC ** +p.length)) : nw.test(e.charAt(l - 1)) ? (d *= qC, m = e.slice(i, l - 1).match(rw), m && i > 0 && (d *= ZC ** +m.length)) : (d *= YC, i > 0 && (d *= ZC ** +(l - i))), e.charAt(l) !== t.charAt(a) && (d *= QC)), (d < XC && n.charAt(l - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(l - 1) !== r.charAt(a)) && (f = iw(e, t, n, r, l + 1, a + 2, o), f * XC > d && (d = f * XC)), d > u && (u = d), l = n.indexOf(c, l + 1);
	return o[s] = u, u;
}
function aw(e) {
	return e.toLowerCase().replace(rw, " ");
}
function ow(e, t, n) {
	return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, iw(e, t, aw(e), aw(t), 0, 0, {});
}
//#endregion
//#region ../../node_modules/.pnpm/cmdk@1.1.1_@types+react-dom@19.3.0_@types+react@19.3.0__@types+react@19.3.0_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/cmdk/dist/index.mjs
var sw = "[cmdk-group=\"\"]", cw = "[cmdk-group-items=\"\"]", lw = "[cmdk-group-heading=\"\"]", uw = "[cmdk-item=\"\"]", dw = `${uw}:not([aria-disabled="true"])`, fw = "cmdk-item-select", pw = "data-value", mw = (e, t, n) => ow(e, t, n), hw = e.createContext(void 0), gw = () => e.useContext(hw), _w = e.createContext(void 0), vw = () => e.useContext(_w), yw = e.createContext(void 0), bw = e.forwardRef((t, n) => {
	let r = Pw(() => ({
		search: "",
		value: t.value ?? t.defaultValue ?? "",
		selectedItemId: void 0,
		filtered: {
			count: 0,
			items: /* @__PURE__ */ new Map(),
			groups: /* @__PURE__ */ new Set()
		}
	})), i = Pw(() => /* @__PURE__ */ new Set()), a = Pw(() => /* @__PURE__ */ new Map()), o = Pw(() => /* @__PURE__ */ new Map()), s = Pw(() => /* @__PURE__ */ new Set()), c = Mw(t), { label: l, children: u, value: d, onValueChange: f, filter: p, shouldFilter: m, loop: h, disablePointerSelection: g = !1, vimBindings: _ = !0, ...v } = t, y = V(), b = V(), x = V(), S = e.useRef(null), C = Lw();
	Nw(() => {
		if (d !== void 0) {
			let e = d.trim();
			r.current.value = e, w.emit();
		}
	}, [d]), Nw(() => {
		C(6, A);
	}, []);
	let w = e.useMemo(() => ({
		subscribe: (e) => (s.current.add(e), () => s.current.delete(e)),
		snapshot: () => r.current,
		setState: (e, t, n) => {
			var i, a, o;
			if (!Object.is(r.current[e], t)) {
				if (r.current[e] = t, e === "search") k(), D(), C(1, O);
				else if (e === "value") {
					if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
						let e = document.getElementById(x);
						e ? e.focus() : (i = document.getElementById(y)) == null || i.focus();
					}
					if (C(7, () => {
						r.current.selectedItemId = j()?.id, w.emit();
					}), n || C(5, A), c.current?.value !== void 0) {
						let e = t ?? "";
						(o = (a = c.current).onValueChange) == null || o.call(a, e);
						return;
					}
				}
				w.emit();
			}
		},
		emit: () => {
			s.current.forEach((e) => e());
		}
	}), []), T = e.useMemo(() => ({
		value: (e, t, n) => {
			t !== o.current.get(e)?.value && (o.current.set(e, {
				value: t,
				keywords: n
			}), r.current.filtered.items.set(e, E(t, n)), C(2, () => {
				D(), w.emit();
			}));
		},
		item: (e, t) => (i.current.add(e), t && (a.current.has(t) ? a.current.get(t).add(e) : a.current.set(t, /* @__PURE__ */ new Set([e]))), C(3, () => {
			k(), D(), r.current.value || O(), w.emit();
		}), () => {
			o.current.delete(e), i.current.delete(e), r.current.filtered.items.delete(e);
			let t = j();
			C(4, () => {
				k(), t?.getAttribute("id") === e && O(), w.emit();
			});
		}),
		group: (e) => (a.current.has(e) || a.current.set(e, /* @__PURE__ */ new Set()), () => {
			o.current.delete(e), a.current.delete(e);
		}),
		filter: () => c.current.shouldFilter,
		label: l || t["aria-label"],
		getDisablePointerSelection: () => c.current.disablePointerSelection,
		listId: y,
		inputId: x,
		labelId: b,
		listInnerRef: S
	}), []);
	function E(e, t) {
		let n = c.current?.filter ?? mw;
		return e ? n(e, r.current.search, t) : 0;
	}
	function D() {
		if (!r.current.search || c.current.shouldFilter === !1) return;
		let e = r.current.filtered.items, t = [];
		r.current.filtered.groups.forEach((n) => {
			let r = a.current.get(n), i = 0;
			r.forEach((t) => {
				let n = e.get(t);
				i = Math.max(n, i);
			}), t.push([n, i]);
		});
		let n = S.current;
		M().sort((t, n) => {
			let r = t.getAttribute("id"), i = n.getAttribute("id");
			return (e.get(i) ?? 0) - (e.get(r) ?? 0);
		}).forEach((e) => {
			let t = e.closest(cw);
			t ? t.appendChild(e.parentElement === t ? e : e.closest(`${cw} > *`)) : n.appendChild(e.parentElement === n ? e : e.closest(`${cw} > *`));
		}), t.sort((e, t) => t[1] - e[1]).forEach((e) => {
			let t = S.current?.querySelector(`${sw}[${pw}="${encodeURIComponent(e[0])}"]`);
			t?.parentElement.appendChild(t);
		});
	}
	function O() {
		let e = M().find((e) => e.getAttribute("aria-disabled") !== "true")?.getAttribute(pw);
		w.setState("value", e || void 0);
	}
	function k() {
		if (!r.current.search || c.current.shouldFilter === !1) {
			r.current.filtered.count = i.current.size;
			return;
		}
		r.current.filtered.groups = /* @__PURE__ */ new Set();
		let e = 0;
		for (let t of i.current) {
			let n = E(o.current.get(t)?.value ?? "", o.current.get(t)?.keywords ?? []);
			r.current.filtered.items.set(t, n), n > 0 && e++;
		}
		for (let [e, t] of a.current) for (let n of t) if (r.current.filtered.items.get(n) > 0) {
			r.current.filtered.groups.add(e);
			break;
		}
		r.current.filtered.count = e;
	}
	function A() {
		var e;
		let t = j();
		t && (t.parentElement?.firstChild === t && ((e = t.closest(sw)?.querySelector(lw)) == null || e.scrollIntoView({ block: "nearest" })), t.scrollIntoView({ block: "nearest" }));
	}
	function j() {
		return S.current?.querySelector(`${uw}[aria-selected="true"]`);
	}
	function M() {
		return Array.from(S.current?.querySelectorAll(dw) || []);
	}
	function ee(e) {
		let t = M()[e];
		t && w.setState("value", t.getAttribute(pw));
	}
	function N(e) {
		var t;
		let n = j(), r = M(), i = r.findIndex((e) => e === n), a = r[i + e];
		(t = c.current) != null && t.loop && (a = i + e < 0 ? r[r.length - 1] : i + e === r.length ? r[0] : r[i + e]), a && w.setState("value", a.getAttribute(pw));
	}
	function te(e) {
		let t = j()?.closest(sw), n;
		for (; t && !n;) t = e > 0 ? Aw(t, sw) : jw(t, sw), n = t?.querySelector(dw);
		n ? w.setState("value", n.getAttribute(pw)) : N(e);
	}
	let P = () => ee(M().length - 1), ne = (e) => {
		e.preventDefault(), e.metaKey ? P() : e.altKey ? te(1) : N(1);
	}, re = (e) => {
		e.preventDefault(), e.metaKey ? ee(0) : e.altKey ? te(-1) : N(-1);
	};
	return e.createElement(R.div, {
		ref: n,
		tabIndex: -1,
		...v,
		"cmdk-root": "",
		onKeyDown: (e) => {
			var t;
			(t = v.onKeyDown) == null || t.call(v, e);
			let n = e.nativeEvent.isComposing || e.keyCode === 229;
			if (!(e.defaultPrevented || n)) switch (e.key) {
				case "n":
				case "j":
					_ && e.ctrlKey && ne(e);
					break;
				case "ArrowDown":
					ne(e);
					break;
				case "p":
				case "k":
					_ && e.ctrlKey && re(e);
					break;
				case "ArrowUp":
					re(e);
					break;
				case "Home":
					e.preventDefault(), ee(0);
					break;
				case "End":
					e.preventDefault(), P();
					break;
				case "Enter": {
					e.preventDefault();
					let t = j();
					if (t) {
						let e = new Event(fw);
						t.dispatchEvent(e);
					}
				}
			}
		}
	}, e.createElement("label", {
		"cmdk-label": "",
		htmlFor: T.inputId,
		id: T.labelId,
		style: Bw
	}, l), zw(t, (t) => e.createElement(_w.Provider, { value: w }, e.createElement(hw.Provider, { value: T }, t))));
}), xw = e.forwardRef((t, n) => {
	let r = V(), i = e.useRef(null), a = e.useContext(yw), o = gw(), s = Mw(t), c = s.current?.forceMount ?? a?.forceMount;
	Nw(() => {
		if (!c) return o.item(r, a?.id);
	}, [c]);
	let l = Iw(r, i, [
		t.value,
		t.children,
		i
	], t.keywords), u = vw(), d = Fw((e) => e.value && e.value === l.current), f = Fw((e) => c || o.filter() === !1 ? !0 : !e.search || e.filtered.items.get(r) > 0);
	e.useEffect(() => {
		let e = i.current;
		if (e && !t.disabled) return e.addEventListener(fw, p), () => e.removeEventListener(fw, p);
	}, [
		f,
		t.onSelect,
		t.disabled
	]);
	function p() {
		var e, t;
		m(), (t = (e = s.current).onSelect) == null || t.call(e, l.current);
	}
	function m() {
		u.setState("value", l.current, !0);
	}
	if (!f) return null;
	let { disabled: h, value: g, onSelect: _, forceMount: v, keywords: y, ...b } = t;
	return e.createElement(R.div, {
		ref: ge(i, n),
		...b,
		id: r,
		"cmdk-item": "",
		role: "option",
		"aria-disabled": !!h,
		"aria-selected": !!d,
		"data-disabled": !!h,
		"data-selected": !!d,
		onPointerMove: h || o.getDisablePointerSelection() ? void 0 : m,
		onClick: h ? void 0 : p
	}, t.children);
}), Sw = e.forwardRef((t, n) => {
	let { heading: r, children: i, forceMount: a, ...o } = t, s = V(), c = e.useRef(null), l = e.useRef(null), u = V(), d = gw(), f = Fw((e) => a || d.filter() === !1 ? !0 : !e.search || e.filtered.groups.has(s));
	Nw(() => d.group(s), []), Iw(s, c, [
		t.value,
		t.heading,
		l
	]);
	let p = e.useMemo(() => ({
		id: s,
		forceMount: a
	}), [a]);
	return e.createElement(R.div, {
		ref: ge(c, n),
		...o,
		"cmdk-group": "",
		role: "presentation",
		hidden: !f || void 0
	}, r && e.createElement("div", {
		ref: l,
		"cmdk-group-heading": "",
		"aria-hidden": !0,
		id: u
	}, r), zw(t, (t) => e.createElement("div", {
		"cmdk-group-items": "",
		role: "group",
		"aria-labelledby": r ? u : void 0
	}, e.createElement(yw.Provider, { value: p }, t))));
}), Cw = e.forwardRef((t, n) => {
	let { alwaysRender: r, ...i } = t, a = e.useRef(null), o = Fw((e) => !e.search);
	return !r && !o ? null : e.createElement(R.div, {
		ref: ge(a, n),
		...i,
		"cmdk-separator": "",
		role: "separator"
	});
}), ww = e.forwardRef((t, n) => {
	let { onValueChange: r, ...i } = t, a = t.value != null, o = vw(), s = Fw((e) => e.search), c = Fw((e) => e.selectedItemId), l = gw();
	return e.useEffect(() => {
		t.value != null && o.setState("search", t.value);
	}, [t.value]), e.createElement(R.input, {
		ref: n,
		...i,
		"cmdk-input": "",
		autoComplete: "off",
		autoCorrect: "off",
		spellCheck: !1,
		"aria-autocomplete": "list",
		role: "combobox",
		"aria-expanded": !0,
		"aria-controls": l.listId,
		"aria-labelledby": l.labelId,
		"aria-activedescendant": c,
		id: l.inputId,
		type: "text",
		value: a ? t.value : s,
		onChange: (e) => {
			a || o.setState("search", e.target.value), r?.(e.target.value);
		}
	});
}), Tw = e.forwardRef((t, n) => {
	let { children: r, label: i = "Suggestions", ...a } = t, o = e.useRef(null), s = e.useRef(null), c = Fw((e) => e.selectedItemId), l = gw();
	return e.useEffect(() => {
		if (s.current && o.current) {
			let e = s.current, t = o.current, n, r = new ResizeObserver(() => {
				n = requestAnimationFrame(() => {
					let n = e.offsetHeight;
					t.style.setProperty("--cmdk-list-height", n.toFixed(1) + "px");
				});
			});
			return r.observe(e), () => {
				cancelAnimationFrame(n), r.unobserve(e);
			};
		}
	}, []), e.createElement(R.div, {
		ref: ge(o, n),
		...a,
		"cmdk-list": "",
		role: "listbox",
		tabIndex: -1,
		"aria-activedescendant": c,
		"aria-label": i,
		id: l.listId
	}, zw(t, (t) => e.createElement("div", {
		ref: ge(s, l.listInnerRef),
		"cmdk-list-sizer": ""
	}, t)));
}), Ew = e.forwardRef((t, n) => {
	let { open: r, onOpenChange: i, overlayClassName: a, contentClassName: o, container: s, ...c } = t;
	return e.createElement($i, {
		open: r,
		onOpenChange: i
	}, e.createElement(aa, { container: s }, e.createElement(sa, {
		"cmdk-overlay": "",
		className: a
	}), e.createElement(da, {
		"aria-label": t.label,
		"cmdk-dialog": "",
		className: o
	}, e.createElement(bw, {
		ref: n,
		...c
	}))));
}), Dw = e.forwardRef((t, n) => Fw((e) => e.filtered.count === 0) ? e.createElement(R.div, {
	ref: n,
	...t,
	"cmdk-empty": "",
	role: "presentation"
}) : null), Ow = e.forwardRef((t, n) => {
	let { progress: r, children: i, label: a = "Loading...", ...o } = t;
	return e.createElement(R.div, {
		ref: n,
		...o,
		"cmdk-loading": "",
		role: "progressbar",
		"aria-valuenow": r,
		"aria-valuemin": 0,
		"aria-valuemax": 100,
		"aria-label": a
	}, zw(t, (t) => e.createElement("div", { "aria-hidden": !0 }, t)));
}), kw = Object.assign(bw, {
	List: Tw,
	Item: xw,
	Input: ww,
	Group: Sw,
	Separator: Cw,
	Dialog: Ew,
	Empty: Dw,
	Loading: Ow
});
function Aw(e, t) {
	let n = e.nextElementSibling;
	for (; n;) {
		if (n.matches(t)) return n;
		n = n.nextElementSibling;
	}
}
function jw(e, t) {
	let n = e.previousElementSibling;
	for (; n;) {
		if (n.matches(t)) return n;
		n = n.previousElementSibling;
	}
}
function Mw(t) {
	let n = e.useRef(t);
	return Nw(() => {
		n.current = t;
	}), n;
}
var Nw = typeof window > "u" ? e.useEffect : e.useLayoutEffect;
function Pw(t) {
	let n = e.useRef();
	return n.current === void 0 && (n.current = t()), n;
}
function Fw(t) {
	let n = vw(), r = () => t(n.snapshot());
	return e.useSyncExternalStore(n.subscribe, r, r);
}
function Iw(t, n, r, i = []) {
	let a = e.useRef(), o = gw();
	return Nw(() => {
		var e;
		let s = (() => {
			for (let e of r) {
				if (typeof e == "string") return e.trim();
				if (typeof e == "object" && "current" in e) return e.current ? e.current.textContent?.trim() : a.current;
			}
		})(), c = i.map((e) => e.trim());
		o.value(t, s, c), (e = n.current) == null || e.setAttribute(pw, s), a.current = s;
	}), a;
}
var Lw = () => {
	let [t, n] = e.useState(), r = Pw(() => /* @__PURE__ */ new Map());
	return Nw(() => {
		r.current.forEach((e) => e()), r.current = /* @__PURE__ */ new Map();
	}, [t]), (e, t) => {
		r.current.set(e, t), n({});
	};
};
function Rw(e) {
	let t = e.type;
	return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function zw({ asChild: t, children: n }, r) {
	return t && e.isValidElement(n) ? e.cloneElement(Rw(n), { ref: n.ref }, r(n.props.children)) : r(n);
}
var Bw = {
	position: "absolute",
	width: "1px",
	height: "1px",
	padding: "0",
	margin: "-1px",
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	borderWidth: "0"
};
//#endregion
//#region src/components/ui/command.tsx
function Vw({ className: e, ...t }) {
	return /* @__PURE__ */ m(kw, {
		"data-slot": "command",
		className: X("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", e),
		...t
	});
}
function Hw({ className: e, ...t }) {
	return /* @__PURE__ */ h("div", {
		"data-slot": "command-input-wrapper",
		className: "flex h-9 items-center gap-2 border-b px-3",
		children: [/* @__PURE__ */ m(ue, { className: "size-4 shrink-0 opacity-50" }), /* @__PURE__ */ m(kw.Input, {
			"data-slot": "command-input",
			className: X("flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", e),
			...t
		})]
	});
}
function Uw({ className: e, ...t }) {
	return /* @__PURE__ */ m(kw.List, {
		"data-slot": "command-list",
		className: X("max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto", e),
		...t
	});
}
function Ww({ ...e }) {
	return /* @__PURE__ */ m(kw.Empty, {
		"data-slot": "command-empty",
		className: "py-6 text-center text-sm",
		...e
	});
}
function Gw({ className: e, ...t }) {
	return /* @__PURE__ */ m(kw.Item, {
		"data-slot": "command-item",
		className: X("relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...t
	});
}
//#endregion
//#region src/components/ui/label.tsx
function Kw({ className: e, ...t }) {
	return /* @__PURE__ */ m(lf, {
		"data-slot": "label",
		className: X("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", e),
		...t
	});
}
//#endregion
//#region src/components/ui/separator.tsx
function qw({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }) {
	return /* @__PURE__ */ m(dh, {
		"data-slot": "separator",
		decorative: n,
		orientation: t,
		className: X("shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch", e),
		...r
	});
}
//#endregion
//#region src/components/ui/field.tsx
function Jw({ className: e, ...t }) {
	return /* @__PURE__ */ m("fieldset", {
		"data-slot": "field-set",
		className: X("flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3", e),
		...t
	});
}
function Yw({ className: e, variant: t = "legend", ...n }) {
	return /* @__PURE__ */ m("legend", {
		"data-slot": "field-legend",
		"data-variant": t,
		className: X("mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base", e),
		...n
	});
}
function Xw({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "field-group",
		className: X("group/field-group @container/field-group flex w-full flex-col gap-5 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4", e),
		...t
	});
}
var Zw = iy("group/field flex w-full gap-2 data-[invalid=true]:text-destructive", {
	variants: { orientation: {
		vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
		horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
		responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
	} },
	defaultVariants: { orientation: "vertical" }
});
function Qw({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ m("div", {
		role: "group",
		"data-slot": "field",
		"data-orientation": t,
		className: X(Zw({ orientation: t }), e),
		...n
	});
}
function $w({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "field-content",
		className: X("group/field-content flex flex-1 flex-col gap-0.5 leading-snug", e),
		...t
	});
}
function eT({ className: e, ...t }) {
	return /* @__PURE__ */ m(Kw, {
		"data-slot": "field-label",
		className: X("group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50 has-data-checked:border-primary/30 has-data-checked:bg-primary/5 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5 dark:has-data-checked:border-primary/20 dark:has-data-checked:bg-primary/10", "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col", e),
		...t
	});
}
function tT({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "field-label",
		className: X("flex w-fit items-center gap-2 text-sm leading-snug font-medium group-data-[disabled=true]/field:opacity-50", e),
		...t
	});
}
function nT({ className: e, ...t }) {
	return /* @__PURE__ */ m("p", {
		"data-slot": "field-description",
		className: X("text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5", "last:mt-0 nth-last-2:-mt-1", "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary", e),
		...t
	});
}
function rT({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ h("div", {
		"data-slot": "field-separator",
		"data-content": !!e,
		className: X("relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2", t),
		...n,
		children: [/* @__PURE__ */ m(qw, { className: "absolute inset-0 top-1/2" }), e && /* @__PURE__ */ m("span", {
			className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
			"data-slot": "field-separator-content",
			children: e
		})]
	});
}
function iT({ className: e, children: t, errors: n, ...r }) {
	let i = l(() => {
		if (t) return t;
		if (!n?.length) return null;
		let e = [...new Map(n.map((e) => [e?.message, e])).values()];
		return e?.length === 1 ? e[0]?.message : /* @__PURE__ */ m("ul", {
			className: "ml-4 flex list-disc flex-col gap-1",
			children: e.map((e, t) => e?.message && /* @__PURE__ */ m("li", { children: e.message }, t))
		});
	}, [t, n]);
	return i ? /* @__PURE__ */ m("div", {
		role: "alert",
		"data-slot": "field-error",
		className: X("text-sm font-normal text-destructive", e),
		...r,
		children: i
	}) : null;
}
//#endregion
//#region src/components/ui/input.tsx
function aT({ className: e, type: t, ...n }) {
	return /* @__PURE__ */ m("input", {
		type: t,
		"data-slot": "input",
		className: X("h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", e),
		...n
	});
}
//#endregion
//#region src/components/ui/textarea.tsx
function oT({ className: e, ...t }) {
	return /* @__PURE__ */ m("textarea", {
		"data-slot": "textarea",
		className: X("flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", e),
		...t
	});
}
//#endregion
//#region src/components/ui/input-group.tsx
function sT({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "input-group",
		role: "group",
		className: X("group/input-group relative flex h-7 w-full min-w-0 items-center rounded-md border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5", e),
		...t
	});
}
var cT = iy("flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4", {
	variants: { align: {
		"inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
		"inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
		"block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
		"block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
	} },
	defaultVariants: { align: "inline-start" }
});
function lT({ className: e, align: t = "inline-start", ...n }) {
	return /* @__PURE__ */ m("div", {
		role: "group",
		"data-slot": "input-group-addon",
		"data-align": t,
		className: X(cT({ align: t }), e),
		onClick: (e) => {
			e.target.closest("button") || e.currentTarget.parentElement?.querySelector("input")?.focus();
		},
		...n
	});
}
var uT = iy("flex items-center gap-2 text-sm shadow-none", {
	variants: { size: {
		xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
		sm: "",
		"icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
		"icon-sm": "size-8 p-0 has-[>svg]:p-0"
	} },
	defaultVariants: { size: "xs" }
});
function dT({ className: e, type: t = "button", variant: n = "ghost", size: r = "xs", ...i }) {
	return /* @__PURE__ */ m(oy, {
		type: t,
		"data-size": r,
		variant: n,
		className: X(uT({ size: r }), e),
		...i
	});
}
function fT({ className: e, ...t }) {
	return /* @__PURE__ */ m("span", {
		className: X("flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4", e),
		...t
	});
}
function pT({ className: e, ...t }) {
	return /* @__PURE__ */ m(aT, {
		"data-slot": "input-group-control",
		className: X("flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent", e),
		...t
	});
}
function mT({ className: e, ...t }) {
	return /* @__PURE__ */ m(oT, {
		"data-slot": "input-group-control",
		className: X("flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent", e),
		...t
	});
}
//#endregion
//#region src/components/ui/popover.tsx
function hT({ ...e }) {
	return /* @__PURE__ */ m(Rf, {
		"data-slot": "popover",
		...e
	});
}
function gT({ ...e }) {
	return /* @__PURE__ */ m(zf, {
		"data-slot": "popover-trigger",
		...e
	});
}
function _T({ className: e, align: t = "center", sideOffset: n = 4, ...r }) {
	return /* @__PURE__ */ m(Bf, { children: /* @__PURE__ */ m(Vf, {
		"data-slot": "popover-content",
		align: t,
		sideOffset: n,
		className: X("z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r
	}) });
}
function vT({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "popover-header",
		className: X("flex flex-col gap-0.5 text-sm", e),
		...t
	});
}
function yT({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "popover-title",
		className: X("font-medium", e),
		...t
	});
}
function bT({ className: e, ...t }) {
	return /* @__PURE__ */ m("p", {
		"data-slot": "popover-description",
		className: X("text-muted-foreground", e),
		...t
	});
}
//#endregion
//#region src/components/ui/date-picker.tsx
function xT({ value: t, onChange: n, disabled: r }) {
	let [i, a] = e.useState(!1), o = e.useMemo(() => new Date(t), [t]), [s, c] = e.useState(o), l = ST(o, !0), u = e.useRef(null);
	return /* @__PURE__ */ m(Qw, {
		className: "w-full",
		children: /* @__PURE__ */ h(sT, { children: [/* @__PURE__ */ m(pT, {
			id: "date-required",
			value: l,
			readOnly: !0,
			disabled: r
		}), /* @__PURE__ */ m(lT, {
			align: "inline-end",
			children: /* @__PURE__ */ h(hT, {
				open: i,
				onOpenChange: a,
				children: [/* @__PURE__ */ m(gT, {
					asChild: !0,
					children: /* @__PURE__ */ h(dT, {
						id: "date-picker",
						variant: "ghost",
						size: "icon-xs",
						"aria-label": "Select date",
						disabled: r,
						children: [/* @__PURE__ */ m(ee, {}), /* @__PURE__ */ m("span", {
							className: "sr-only",
							children: "Select date"
						})]
					})
				}), /* @__PURE__ */ m(_T, {
					ref: u,
					className: "w-auto overflow-hidden p-0 h-[295px]",
					align: "end",
					alignOffset: -8,
					sideOffset: 10,
					onFocusOutside: (e) => e.preventDefault(),
					onInteractOutside: (e) => {
						let t = e.target;
						t && u.current?.contains(t) && e.preventDefault();
					},
					children: /* @__PURE__ */ m(NC, {
						mode: "single",
						selected: o,
						month: s,
						onMonthChange: c,
						onSelect: (e) => {
							if (!e) {
								a(!1);
								return;
							}
							a(!1), n?.(ST(e));
						}
					})
				})]
			})
		})] })
	});
}
function ST(e, t = !1) {
	return e ? t ? e.toLocaleDateString("en-GB", {
		day: "2-digit",
		month: "short",
		year: "numeric"
	}) : `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}` : "";
}
//#endregion
//#region src/components/ui/dialog.tsx
function CT({ ...e }) {
	return /* @__PURE__ */ m($i, {
		"data-slot": "dialog",
		...e
	});
}
function wT({ ...e }) {
	return /* @__PURE__ */ m(ta, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function TT({ ...e }) {
	return /* @__PURE__ */ m(aa, {
		"data-slot": "dialog-portal",
		...e
	});
}
function ET({ ...e }) {
	return /* @__PURE__ */ m(ba, {
		"data-slot": "dialog-close",
		...e
	});
}
function DT({ className: e, ...t }) {
	return /* @__PURE__ */ m(sa, {
		"data-slot": "dialog-overlay",
		className: X("fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", e),
		...t
	});
}
function OT({ className: e, children: t, showCloseButton: n = !0, ...r }) {
	return /* @__PURE__ */ h(TT, { children: [/* @__PURE__ */ m(DT, {}), /* @__PURE__ */ h(da, {
		"data-slot": "dialog-content",
		className: X("fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r,
		children: [t, n && /* @__PURE__ */ m(ba, {
			"data-slot": "dialog-close",
			asChild: !0,
			children: /* @__PURE__ */ h(oy, {
				variant: "ghost",
				className: "absolute top-2 right-2",
				size: "icon-sm",
				children: [/* @__PURE__ */ m(fe, {}), /* @__PURE__ */ m("span", {
					className: "sr-only",
					children: "Close"
				})]
			})
		})]
	})] });
}
function kT({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "dialog-header",
		className: X("flex flex-col gap-2", e),
		...t
	});
}
function AT({ className: e, showCloseButton: t = !1, children: n, ...r }) {
	return /* @__PURE__ */ h("div", {
		"data-slot": "dialog-footer",
		className: X("-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end", e),
		...r,
		children: [n, t && /* @__PURE__ */ m(ba, {
			asChild: !0,
			children: /* @__PURE__ */ m(oy, {
				variant: "outline",
				children: "Close"
			})
		})]
	});
}
function jT({ className: e, ...t }) {
	return /* @__PURE__ */ m(ga, {
		"data-slot": "dialog-title",
		className: X("cn-font-heading text-base leading-none font-medium", e),
		...t
	});
}
function MT({ className: e, ...t }) {
	return /* @__PURE__ */ m(va, {
		"data-slot": "dialog-description",
		className: X("text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", e),
		...t
	});
}
//#endregion
//#region src/components/ui/dropdown-menu.tsx
function NT({ ...e }) {
	return /* @__PURE__ */ m(Kd, {
		"data-slot": "dropdown-menu",
		...e
	});
}
function PT({ ...e }) {
	return /* @__PURE__ */ m(Jd, {
		"data-slot": "dropdown-menu-portal",
		...e
	});
}
function FT({ ...e }) {
	return /* @__PURE__ */ m(qd, {
		"data-slot": "dropdown-menu-trigger",
		...e
	});
}
function IT({ className: e, align: t = "start", sideOffset: n = 4, ...r }) {
	return /* @__PURE__ */ m(Jd, { children: /* @__PURE__ */ m(Yd, {
		"data-slot": "dropdown-menu-content",
		sideOffset: n,
		align: t,
		className: X("z-50 max-h-(--radix-dropdown-menu-content-available-height) w-(--radix-dropdown-menu-trigger-width) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:overflow-hidden data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r
	}) });
}
function LT({ ...e }) {
	return /* @__PURE__ */ m(Xd, {
		"data-slot": "dropdown-menu-group",
		...e
	});
}
function RT({ className: e, inset: t, variant: n = "default", ...r }) {
	return /* @__PURE__ */ m(Qd, {
		"data-slot": "dropdown-menu-item",
		"data-inset": t,
		"data-variant": n,
		className: X("group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive", e),
		...r
	});
}
function zT({ className: e, children: t, checked: n, inset: r, ...i }) {
	return /* @__PURE__ */ h($d, {
		"data-slot": "dropdown-menu-checkbox-item",
		"data-inset": r,
		className: X("relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		checked: n,
		...i,
		children: [/* @__PURE__ */ m("span", {
			className: "pointer-events-none absolute right-2 flex items-center justify-center",
			"data-slot": "dropdown-menu-checkbox-item-indicator",
			children: /* @__PURE__ */ m(nf, { children: /* @__PURE__ */ m(te, {}) })
		}), t]
	});
}
function BT({ ...e }) {
	return /* @__PURE__ */ m(ef, {
		"data-slot": "dropdown-menu-radio-group",
		...e
	});
}
function VT({ className: e, children: t, inset: n, ...r }) {
	return /* @__PURE__ */ h(tf, {
		"data-slot": "dropdown-menu-radio-item",
		"data-inset": n,
		className: X("relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...r,
		children: [/* @__PURE__ */ m("span", {
			className: "pointer-events-none absolute right-2 flex items-center justify-center",
			"data-slot": "dropdown-menu-radio-item-indicator",
			children: /* @__PURE__ */ m(nf, { children: /* @__PURE__ */ m(te, {}) })
		}), t]
	});
}
function HT({ className: e, inset: t, ...n }) {
	return /* @__PURE__ */ m(Zd, {
		"data-slot": "dropdown-menu-label",
		"data-inset": t,
		className: X("px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7", e),
		...n
	});
}
function UT({ className: e, ...t }) {
	return /* @__PURE__ */ m(rf, {
		"data-slot": "dropdown-menu-separator",
		className: X("-mx-1 my-1 h-px bg-border", e),
		...t
	});
}
function WT({ className: e, ...t }) {
	return /* @__PURE__ */ m("span", {
		"data-slot": "dropdown-menu-shortcut",
		className: X("ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground", e),
		...t
	});
}
function GT({ ...e }) {
	return /* @__PURE__ */ m(af, {
		"data-slot": "dropdown-menu-sub",
		...e
	});
}
function KT({ className: e, inset: t, children: n, ...r }) {
	return /* @__PURE__ */ h(of, {
		"data-slot": "dropdown-menu-sub-trigger",
		"data-inset": t,
		className: X("flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-inset:pl-7 data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...r,
		children: [n, /* @__PURE__ */ m(F, { className: "cn-rtl-flip ml-auto" })]
	});
}
function qT({ className: e, ...t }) {
	return /* @__PURE__ */ m(sf, {
		"data-slot": "dropdown-menu-sub-content",
		className: X("z-50 min-w-[96px] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...t
	});
}
//#endregion
//#region src/components/ui/pagination.tsx
function JT({ className: e, ...t }) {
	return /* @__PURE__ */ m("nav", {
		"aria-label": "pagination",
		"data-slot": "pagination",
		className: X("mx-auto flex w-full justify-center", e),
		...t
	});
}
function YT({ className: e, ...t }) {
	return /* @__PURE__ */ m("ul", {
		"data-slot": "pagination-content",
		className: X("flex items-center gap-0.5", e),
		...t
	});
}
function XT({ ...e }) {
	return /* @__PURE__ */ m("li", {
		"data-slot": "pagination-item",
		...e
	});
}
function ZT({ className: e, isActive: t, size: n = "icon", ...r }) {
	return /* @__PURE__ */ m(oy, {
		asChild: !0,
		variant: t ? "outline" : "ghost",
		size: n,
		className: X(e),
		children: /* @__PURE__ */ m("a", {
			"aria-current": t ? "page" : void 0,
			"data-slot": "pagination-link",
			"data-active": t,
			...r
		})
	});
}
function QT({ className: e, text: t = "Previous", ...n }) {
	return /* @__PURE__ */ h(ZT, {
		"aria-label": "Go to previous page",
		size: "default",
		className: X("pl-1.5!", e),
		...n,
		children: [/* @__PURE__ */ m(ie, { "data-icon": "inline-start" }), /* @__PURE__ */ m("span", {
			className: "hidden sm:block",
			children: t
		})]
	});
}
function $T({ className: e, text: t = "Next", ...n }) {
	return /* @__PURE__ */ h(ZT, {
		"aria-label": "Go to next page",
		size: "default",
		className: X("pr-1.5!", e),
		...n,
		children: [/* @__PURE__ */ m("span", {
			className: "hidden sm:block",
			children: t
		}), /* @__PURE__ */ m(F, { "data-icon": "inline-end" })]
	});
}
function eE({ className: e, ...t }) {
	return /* @__PURE__ */ h("span", {
		"aria-hidden": !0,
		"data-slot": "pagination-ellipsis",
		className: X("flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4", e),
		...t,
		children: [/* @__PURE__ */ m(I, {}), /* @__PURE__ */ m("span", {
			className: "sr-only",
			children: "More pages"
		})]
	});
}
//#endregion
//#region src/components/ui/progress.tsx
function tE({ className: t, value: n, ...r }) {
	let [i, a] = e.useState(0);
	return e.useEffect(() => {
		let e = requestAnimationFrame(() => a(n || 0));
		return () => cancelAnimationFrame(e);
	}, [n]), /* @__PURE__ */ m(op, {
		"data-slot": "progress",
		value: n,
		className: X("relative flex h-1 w-full items-center overflow-x-hidden rounded-full bg-muted", t),
		...r,
		children: /* @__PURE__ */ m(sp, {
			"data-slot": "progress-indicator",
			className: "size-full flex-1 bg-primary transition-all",
			style: { transform: `translateX(-${100 - i}%)` }
		})
	});
}
//#endregion
//#region src/components/ui/scroll-area.tsx
function nE({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ h(Kp, {
		"data-slot": "scroll-area",
		type: "always",
		className: X("relative flex flex-col overflow-hidden", e),
		...n,
		children: [
			/* @__PURE__ */ m(qp, {
				"data-slot": "scroll-area-viewport",
				className: "w-full grow rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
				children: t
			}),
			/* @__PURE__ */ m(rE, {}),
			/* @__PURE__ */ m(Jp, {})
		]
	});
}
function rE({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ m(bp, {
		"data-slot": "scroll-area-scrollbar",
		"data-orientation": t,
		orientation: t,
		className: X("flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent", e),
		...n,
		children: /* @__PURE__ */ m(jp, {
			"data-slot": "scroll-area-thumb",
			className: "relative flex-1 rounded-full bg-border"
		})
	});
}
//#endregion
//#region src/components/ui/select.tsx
function iE({ ...e }) {
	return /* @__PURE__ */ m(um, {
		"data-slot": "select",
		...e
	});
}
function aE({ className: e, ...t }) {
	return /* @__PURE__ */ m(Fm, {
		"data-slot": "select-group",
		className: X("scroll-my-1 p-1", e),
		...t
	});
}
function oE({ ...e }) {
	return /* @__PURE__ */ m(mm, {
		"data-slot": "select-value",
		...e
	});
}
function sE({ className: e, size: t = "default", children: n, ...r }) {
	return /* @__PURE__ */ h(fm, {
		"data-slot": "select-trigger",
		"data-size": t,
		className: X("flex w-fit items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-8 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...r,
		children: [n, /* @__PURE__ */ m(hm, {
			asChild: !0,
			children: /* @__PURE__ */ m(ne, { className: "pointer-events-none size-4 text-muted-foreground" })
		})]
	});
}
function cE({ className: e, children: t, position: n = "item-aligned", align: r = "center", ...i }) {
	return /* @__PURE__ */ m(vm, { children: /* @__PURE__ */ h(bm, {
		"data-slot": "select-content",
		"data-align-trigger": n === "item-aligned",
		className: X("relative z-50 max-h-(--radix-select-content-available-height) min-w-36 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
		position: n,
		align: r,
		...i,
		children: [
			/* @__PURE__ */ m(fE, {}),
			/* @__PURE__ */ m(Mm, {
				"data-position": n,
				className: X("data-[position=popper]:h-(--radix-select-trigger-height) data-[position=popper]:w-full data-[position=popper]:min-w-(--radix-select-trigger-width)", n === "popper" && ""),
				children: t
			}),
			/* @__PURE__ */ m(pE, {})
		]
	}) });
}
function lE({ className: e, ...t }) {
	return /* @__PURE__ */ m(Lm, {
		"data-slot": "select-label",
		className: X("px-1.5 py-1 text-xs text-muted-foreground", e),
		...t
	});
}
function uE({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ h(Vm, {
		"data-slot": "select-item",
		className: X("relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
		...n,
		children: [/* @__PURE__ */ m("span", {
			className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center",
			children: /* @__PURE__ */ m(Gm, { children: /* @__PURE__ */ m(te, { className: "pointer-events-none" }) })
		}), /* @__PURE__ */ m(Um, { children: t })]
	});
}
function dE({ className: e, ...t }) {
	return /* @__PURE__ */ m(Zm, {
		"data-slot": "select-separator",
		className: X("pointer-events-none -mx-1 my-1 h-px bg-border", e),
		...t
	});
}
function fE({ className: e, ...t }) {
	return /* @__PURE__ */ m(qm, {
		"data-slot": "select-scroll-up-button",
		className: X("z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", e),
		...t,
		children: /* @__PURE__ */ m(se, {})
	});
}
function pE({ className: e, ...t }) {
	return /* @__PURE__ */ m(Ym, {
		"data-slot": "select-scroll-down-button",
		className: X("z-10 flex cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", e),
		...t,
		children: /* @__PURE__ */ m(ne, {})
	});
}
//#endregion
//#region src/components/ui/sheet.tsx
function mE({ ...e }) {
	return /* @__PURE__ */ m($i, {
		"data-slot": "sheet",
		...e
	});
}
function hE({ ...e }) {
	return /* @__PURE__ */ m(ta, {
		"data-slot": "sheet-trigger",
		...e
	});
}
function gE({ ...e }) {
	return /* @__PURE__ */ m(ba, {
		"data-slot": "sheet-close",
		...e
	});
}
function _E({ ...e }) {
	return /* @__PURE__ */ m(aa, {
		"data-slot": "sheet-portal",
		...e
	});
}
function vE({ className: e, ...t }) {
	return /* @__PURE__ */ m(sa, {
		"data-slot": "sheet-overlay",
		className: X("fixed inset-0 z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", e),
		...t
	});
}
function yE({ className: e, children: t, side: n = "right", showCloseButton: r = !0, ...i }) {
	return /* @__PURE__ */ h(_E, { children: [/* @__PURE__ */ m(vE, {}), /* @__PURE__ */ h(da, {
		"data-slot": "sheet-content",
		"data-side": n,
		className: X("fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-[side=bottom]:data-open:slide-in-from-bottom-10 data-[side=left]:data-open:slide-in-from-left-10 data-[side=right]:data-open:slide-in-from-right-10 data-[side=top]:data-open:slide-in-from-top-10 data-closed:animate-out data-closed:fade-out-0 data-[side=bottom]:data-closed:slide-out-to-bottom-10 data-[side=left]:data-closed:slide-out-to-left-10 data-[side=right]:data-closed:slide-out-to-right-10 data-[side=top]:data-closed:slide-out-to-top-10", e),
		...i,
		children: [t, r && /* @__PURE__ */ m(ba, {
			"data-slot": "sheet-close",
			asChild: !0,
			children: /* @__PURE__ */ h(oy, {
				variant: "ghost",
				className: "absolute top-3 right-3",
				size: "icon-sm",
				children: [/* @__PURE__ */ m(fe, {}), /* @__PURE__ */ m("span", {
					className: "sr-only",
					children: "Close"
				})]
			})
		})]
	})] });
}
function bE({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "sheet-header",
		className: X("flex flex-col gap-0.5 p-4", e),
		...t
	});
}
function xE({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "sheet-footer",
		className: X("mt-auto flex flex-col gap-2 p-4", e),
		...t
	});
}
function SE({ className: e, ...t }) {
	return /* @__PURE__ */ m(ga, {
		"data-slot": "sheet-title",
		className: X("text-base font-medium text-foreground", e),
		...t
	});
}
function CE({ className: e, ...t }) {
	return /* @__PURE__ */ m(va, {
		"data-slot": "sheet-description",
		className: X("text-sm text-muted-foreground", e),
		...t
	});
}
//#endregion
//#region src/components/ui/skeleton.tsx
function wE({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "skeleton",
		className: X("animate-pulse rounded-md bg-muted", e),
		...t
	});
}
//#endregion
//#region src/components/ui/slider.tsx
function TE({ className: t, defaultValue: n, value: r, min: i = 0, max: a = 100, ...o }) {
	let s = e.useMemo(() => Array.isArray(r) ? r : Array.isArray(n) ? n : [i, a], [
		r,
		n,
		i,
		a
	]);
	return /* @__PURE__ */ h(wh, {
		"data-slot": "slider",
		defaultValue: n,
		value: r,
		min: i,
		max: a,
		className: X("relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col", t),
		...o,
		children: [/* @__PURE__ */ m(jh, {
			"data-slot": "slider-track",
			className: "relative grow overflow-hidden rounded-full bg-muted data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1",
			children: /* @__PURE__ */ m(Nh, {
				"data-slot": "slider-range",
				className: "absolute bg-primary select-none data-horizontal:h-full data-vertical:w-full"
			})
		}), Array.from({ length: s.length }, (e, t) => /* @__PURE__ */ m(Bh, {
			"data-slot": "slider-thumb",
			className: "relative block size-3 shrink-0 rounded-full border border-ring bg-white ring-ring/50 transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50"
		}, t))]
	});
}
//#endregion
//#region src/components/ui/switch.tsx
function EE({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ m(dg, {
		"data-slot": "switch",
		"data-size": t,
		className: X("peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50", e),
		...n,
		children: /* @__PURE__ */ m(pg, {
			"data-slot": "switch-thumb",
			className: "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] dark:data-checked:bg-primary-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground"
		})
	});
}
//#endregion
//#region src/components/ui/table.tsx
function DE({ className: e, ...t }) {
	return /* @__PURE__ */ m("div", {
		"data-slot": "table-container",
		className: "relative w-full overflow-x-auto",
		children: /* @__PURE__ */ m("table", {
			"data-slot": "table",
			className: X("w-full caption-bottom text-sm", e),
			...t
		})
	});
}
function OE({ className: e, ...t }) {
	return /* @__PURE__ */ m("thead", {
		"data-slot": "table-header",
		className: X("[&_tr]:border-b", e),
		...t
	});
}
function kE({ className: e, ...t }) {
	return /* @__PURE__ */ m("tbody", {
		"data-slot": "table-body",
		className: X("[&_tr:last-child]:border-0", e),
		...t
	});
}
function AE({ className: e, ...t }) {
	return /* @__PURE__ */ m("tfoot", {
		"data-slot": "table-footer",
		className: X("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
		...t
	});
}
function jE({ className: e, ...t }) {
	return /* @__PURE__ */ m("tr", {
		"data-slot": "table-row",
		className: X("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e),
		...t
	});
}
function ME({ className: e, ...t }) {
	return /* @__PURE__ */ m("th", {
		"data-slot": "table-head",
		className: X("h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0", e),
		...t
	});
}
function NE({ className: e, ...t }) {
	return /* @__PURE__ */ m("td", {
		"data-slot": "table-cell",
		className: X("p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0", e),
		...t
	});
}
function PE({ className: e, ...t }) {
	return /* @__PURE__ */ m("caption", {
		"data-slot": "table-caption",
		className: X("mt-4 text-sm text-muted-foreground", e),
		...t
	});
}
//#endregion
//#region src/components/ui/toggle.tsx
var FE = iy("group/toggle inline-flex items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border border-input bg-transparent hover:bg-muted"
		},
		size: {
			default: "h-8 min-w-8 px-2",
			sm: "h-7 min-w-7 rounded-[min(var(--radius-md),12px)] px-1.5 text-[0.8rem]",
			lg: "h-9 min-w-9 px-2.5"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function IE({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ m(Sg, {
		"data-slot": "toggle",
		className: X(FE({
			variant: t,
			size: n,
			className: e
		})),
		...r
	});
}
//#endregion
//#region src/components/ui/toggle-group.tsx
var LE = e.createContext({
	size: "default",
	variant: "default",
	spacing: 0,
	orientation: "horizontal"
});
function RE({ className: e, variant: t, size: n, spacing: r = 0, orientation: i = "horizontal", children: a, ...o }) {
	return /* @__PURE__ */ m(kg, {
		"data-slot": "toggle-group",
		"data-variant": t,
		"data-size": n,
		"data-spacing": r,
		"data-orientation": i,
		style: { "--gap": r },
		className: X("group/toggle-group flex w-fit flex-row items-center bg-background shadow-lg p-1 ring-1 ring-border gap-[--spacing(var(--gap))] rounded-xl data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-vertical:flex-col data-vertical:items-stretch", e),
		...o,
		children: /* @__PURE__ */ m(LE.Provider, {
			value: {
				variant: t,
				size: n,
				spacing: r,
				orientation: i
			},
			children: a
		})
	});
}
function zE({ className: t, children: n, variant: r = "default", size: i = "default", ...a }) {
	let o = e.useContext(LE);
	return /* @__PURE__ */ m(Rg, {
		"data-slot": "toggle-group-item",
		"data-variant": o.variant || r,
		"data-size": o.size || i,
		"data-spacing": o.spacing,
		className: X("shrink-0 group-data-[spacing=0]/toggle-group:rounded-none group-data-[spacing=0]/toggle-group:px-2 focus:z-10 focus-visible:z-10 group-data-horizontal/toggle-group:data-[spacing=0]:first:rounded-l-lg group-data-vertical/toggle-group:data-[spacing=0]:first:rounded-t-lg group-data-horizontal/toggle-group:data-[spacing=0]:last:rounded-r-lg group-data-vertical/toggle-group:data-[spacing=0]:last:rounded-b-lg group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:border-l-0 group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:border-t-0 group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-l group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-t", FE({
			variant: o.variant || r,
			size: o.size || i
		}), t),
		...a,
		children: n
	});
}
//#endregion
//#region src/components/ui/tooltip.tsx
function BE({ delayDuration: e = 0, ...t }) {
	return /* @__PURE__ */ m(y_, {
		"data-slot": "tooltip-provider",
		delayDuration: e,
		...t
	});
}
function VE({ ...e }) {
	return /* @__PURE__ */ m(b_, {
		"data-slot": "tooltip",
		...e
	});
}
function HE({ ...e }) {
	return /* @__PURE__ */ m(x_, {
		"data-slot": "tooltip-trigger",
		...e
	});
}
function UE({ className: e, sideOffset: t = 0, children: n, ...r }) {
	return /* @__PURE__ */ m(S_, { children: /* @__PURE__ */ h(C_, {
		"data-slot": "tooltip-content",
		sideOffset: t,
		className: X("z-50 inline-flex w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-50 **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r,
		children: [n, /* @__PURE__ */ m(w_, { className: "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })]
	}) });
}
//#endregion
export { Qv as Accordion, ty as AccordionContent, $v as AccordionItem, ey as AccordionTrigger, sy as AlertDialog, _y as AlertDialogAction, vy as AlertDialogCancel, dy as AlertDialogContent, gy as AlertDialogDescription, py as AlertDialogFooter, fy as AlertDialogHeader, my as AlertDialogMedia, hy as AlertDialogTitle, cy as AlertDialogTrigger, yy as Avatar, Sy as AvatarBadge, xy as AvatarFallback, Cy as AvatarGroup, wy as AvatarGroupCount, by as AvatarImage, Ey as Badge, oy as Button, Dy as ButtonGroup, NC as Calendar, PC as CalendarDayButton, FC as Card, zC as CardAction, BC as CardContent, RC as CardDescription, VC as CardFooter, IC as CardHeader, LC as CardTitle, HC as Checkbox, UC as Collapsible, GC as CollapsibleContent, WC as CollapsibleTrigger, Vw as Command, Ww as CommandEmpty, Hw as CommandInput, Gw as CommandItem, Uw as CommandList, xT as DatePicker, CT as Dialog, ET as DialogClose, OT as DialogContent, MT as DialogDescription, AT as DialogFooter, kT as DialogHeader, DT as DialogOverlay, TT as DialogPortal, jT as DialogTitle, wT as DialogTrigger, NT as DropdownMenu, zT as DropdownMenuCheckboxItem, IT as DropdownMenuContent, LT as DropdownMenuGroup, RT as DropdownMenuItem, HT as DropdownMenuLabel, PT as DropdownMenuPortal, BT as DropdownMenuRadioGroup, VT as DropdownMenuRadioItem, UT as DropdownMenuSeparator, WT as DropdownMenuShortcut, GT as DropdownMenuSub, qT as DropdownMenuSubContent, KT as DropdownMenuSubTrigger, FT as DropdownMenuTrigger, Qw as Field, $w as FieldContent, nT as FieldDescription, iT as FieldError, Xw as FieldGroup, eT as FieldLabel, Yw as FieldLegend, rT as FieldSeparator, Jw as FieldSet, tT as FieldTitle, aT as Input, sT as InputGroup, lT as InputGroupAddon, dT as InputGroupButton, pT as InputGroupInput, fT as InputGroupText, mT as InputGroupTextarea, Kw as Label, JT as Pagination, YT as PaginationContent, eE as PaginationEllipsis, XT as PaginationItem, ZT as PaginationLink, $T as PaginationNext, QT as PaginationPrevious, hT as Popover, _T as PopoverContent, bT as PopoverDescription, vT as PopoverHeader, yT as PopoverTitle, gT as PopoverTrigger, tE as Progress, nE as ScrollArea, rE as ScrollBar, iE as Select, cE as SelectContent, aE as SelectGroup, uE as SelectItem, lE as SelectLabel, pE as SelectScrollDownButton, fE as SelectScrollUpButton, dE as SelectSeparator, sE as SelectTrigger, oE as SelectValue, qw as Separator, mE as Sheet, gE as SheetClose, yE as SheetContent, CE as SheetDescription, xE as SheetFooter, bE as SheetHeader, SE as SheetTitle, hE as SheetTrigger, wE as Skeleton, TE as Slider, EE as Switch, DE as Table, kE as TableBody, PE as TableCaption, NE as TableCell, AE as TableFooter, ME as TableHead, OE as TableHeader, jE as TableRow, oT as Textarea, IE as Toggle, RE as ToggleGroup, zE as ToggleGroupItem, VE as Tooltip, UE as TooltipContent, BE as TooltipProvider, HE as TooltipTrigger, Ty as badgeVariants, ay as buttonVariants, X as cn, FE as toggleVariants };
